// This file is auto-generated by @hey-api/openapi-ts

export const $AIRLocationResult = {
  properties: {
    location_id: {
      type: "string",
      title: "Location Id",
      default: "",
    },
    location_number: {
      type: "string",
      title: "Location Number",
      default: "",
    },
    location_name: {
      type: "string",
      title: "Location Name",
      default: "",
    },
    street_address: {
      type: "string",
      title: "Street Address",
      default: "",
    },
    city: {
      type: "string",
      title: "City",
      default: "",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    aal_rl_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Rl By Peril",
      default: {},
    },
    location_detail: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationDetail",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["address_id"],
  title: "AIRLocationResult",
  description: `API type for AIR (ICM_YLT) per-location results.

ICM_YLT data is persisted in the identical \`\`RMSLocationResult\`\` JSONB
shape via the shared elt_persist pipeline, so this is structurally a copy.
It exists purely to give the AIR-backed \`\`air\`\` field a vendor-accurate
name in the public API / generated client, distinct from the RMS results.`,
} as const;

export const $AalPremiumGateBar = {
  properties: {
    gate: {
      type: "string",
      title: "Gate",
    },
    aal_budget: {
      type: "number",
      title: "Aal Budget",
    },
    bound_aal: {
      type: "number",
      title: "Bound Aal",
    },
    quoted_aal: {
      type: "number",
      title: "Quoted Aal",
    },
    current_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Current Aal",
    },
    loss_ratio: {
      $ref: "#/components/schemas/AalPremiumGateLossRatio",
    },
  },
  type: "object",
  required: [
    "gate",
    "aal_budget",
    "bound_aal",
    "quoted_aal",
    "current_aal",
    "loss_ratio",
  ],
  title: "AalPremiumGateBar",
} as const;

export const $AalPremiumGateLossRatio = {
  properties: {
    target: {
      type: "number",
      title: "Target",
    },
    bound: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bound",
    },
    bound_and_quoted: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bound And Quoted",
    },
    effect_on_bound: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Effect On Bound",
    },
  },
  type: "object",
  required: ["target", "bound", "bound_and_quoted", "effect_on_bound"],
  title: "AalPremiumGateLossRatio",
} as const;

export const $AalPremiumGateResponse = {
  properties: {
    capacity_breakpoints: {
      items: {
        $ref: "#/components/schemas/GateBreakpoint",
      },
      type: "array",
      title: "Capacity Breakpoints",
    },
    bars: {
      items: {
        $ref: "#/components/schemas/AalPremiumGateBar",
      },
      type: "array",
      title: "Bars",
    },
  },
  type: "object",
  required: ["capacity_breakpoints", "bars"],
  title: "AalPremiumGateResponse",
} as const;

export const $AalPremiumGateTrackingRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
  },
  type: "object",
  required: ["report_id", "layer_id"],
  title: "AalPremiumGateTrackingRequest",
} as const;

export const $ActiveStorm = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    name: {
      type: "string",
      title: "Name",
    },
    classification: {
      type: "string",
      title: "Classification",
    },
    intensity_kt: {
      type: "integer",
      title: "Intensity Kt",
    },
    lat: {
      type: "number",
      title: "Lat",
    },
    lon: {
      type: "number",
      title: "Lon",
    },
    bin_number: {
      type: "string",
      title: "Bin Number",
    },
    last_update: {
      type: "string",
      title: "Last Update",
    },
  },
  additionalProperties: false,
  type: "object",
  required: [
    "id",
    "name",
    "classification",
    "intensity_kt",
    "lat",
    "lon",
    "bin_number",
    "last_update",
  ],
  title: "ActiveStorm",
  description: "One storm the NHC is currently issuing advisories for.",
} as const;

export const $ActiveStorms = {
  properties: {
    storms: {
      items: {
        $ref: "#/components/schemas/StormWithTrack",
      },
      type: "array",
      title: "Storms",
    },
  },
  type: "object",
  required: ["storms"],
  title: "ActiveStorms",
  description: "Every storm the NHC is advising on. Empty out of season.",
} as const;

export const $AddCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    message: {
      type: "string",
      title: "Message",
    },
    target_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/CommentTargetType",
        },
        {
          type: "null",
        },
      ],
    },
    target_key: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Target Key",
    },
  },
  type: "object",
  required: ["report_id", "message", "target_type", "target_key"],
  title: "AddCommentRequest",
} as const;

export const $AddCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "AddCommentResponse",
} as const;

export const $AddManualAddressRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address: {
      $ref: "#/components/schemas/RawAddress",
    },
  },
  type: "object",
  required: ["report_id", "address"],
  title: "AddManualAddressRequest",
} as const;

export const $AddManualAddressResponse = {
  properties: {
    report: {
      $ref: "#/components/schemas/ReportResponse",
    },
  },
  type: "object",
  required: ["report"],
  title: "AddManualAddressResponse",
} as const;

export const $AddSavedFilterRequest = {
  properties: {
    url: {
      type: "string",
      title: "Url",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
  },
  type: "object",
  required: ["url", "nickname", "is_default"],
  title: "AddSavedFilterRequest",
} as const;

export const $AdditionalAssigneeInfo = {
  properties: {
    assignees: {
      additionalProperties: {
        type: "string",
      },
      propertyNames: {
        const: "handler",
      },
      type: "object",
      title: "Assignees",
    },
  },
  type: "object",
  required: ["assignees"],
  title: "AdditionalAssigneeInfo",
} as const;

export const $AdditionalFile = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    uploaded_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Uploaded At",
    },
  },
  type: "object",
  required: ["name", "uploaded_at"],
  title: "AdditionalFile",
} as const;

export const $Address = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    is_deleted: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Deleted",
    },
    default_sort_key: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Default Sort Key",
    },
    private_computed_values: {
      $ref: "#/components/schemas/RawAddress",
    },
    private_original_values: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Original Values",
    },
    private_overrides: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "number",
          },
          {
            type: "integer",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Overrides",
    },
    private_flags: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              type: "string",
              enum: [
                "missing_coverage_headers",
                "date_parsing_error",
                "number_parsing_error",
                "large_number_warning",
                "suspicious_year_warning",
                "year_out_of_range_warning",
                "future_year_warning",
                "general_mismatch",
                "low_confidence",
                "medium_confidence",
                "non_property_insurance_value",
                "unrecognized_central_alarm_value",
                "unrecognized_yes_no_value",
                "low_sprinkler_percentage",
                "unrecognized_sprinkler_value",
                "zip_parsing_error",
                "blank_tiv_value",
                "non_ascii_removed",
                "address_corrected_by_geocoding",
                "geocoding_failed",
                "location_number_mismatch",
                "year_defaulted_to_year_built",
                "approximate_geocoding",
                "high_protection_class",
                "tier_1_wind_zone",
                "itv_calc_warning",
                "bi_estimate_warning",
                "coverage_adjusted_by_reconciliation",
                "zip_unrecognized",
                "zip_not_rater_valid",
                "zip_state_mismatch",
                "number_of_buildings_replaced",
              ],
            },
            {
              $ref: "#/components/schemas/UnknownCoverageColumnFlag",
            },
            {
              $ref: "#/components/schemas/UnknownInsuranceSubjectFlag",
            },
            {
              $ref: "#/components/schemas/AddressCorrectedByModel",
            },
            {
              $ref: "#/components/schemas/AddressFlaggedByGeocoding",
            },
            {
              $ref: "#/components/schemas/CoverageComputedFromColumnSum",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Private Flags",
    },
    ofac_result: {
      anyOf: [
        {
          $ref: "#/components/schemas/OFACResult",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "address_id",
    "private_computed_values",
    "private_original_values",
    "private_overrides",
    "private_flags",
  ],
  title: "Address",
} as const;

export const $AddressCorrectedByModel = {
  properties: {
    flag_id: {
      type: "string",
      const: "address_corrected_by_llm_parse",
      title: "Flag Id",
    },
    original: {
      type: "string",
      title: "Original",
    },
  },
  type: "object",
  required: ["flag_id", "original"],
  title: "AddressCorrectedByModel",
} as const;

export const $AddressFlaggedByGeocoding = {
  properties: {
    flag_id: {
      type: "string",
      const: "address_flagged_by_geocoding",
      title: "Flag Id",
    },
    geocoded: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded",
    },
  },
  type: "object",
  required: ["flag_id", "geocoded"],
  title: "AddressFlaggedByGeocoding",
} as const;

export const $AddressIntegrationData = {
  properties: {
    rms: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    air: {
      anyOf: [
        {
          $ref: "#/components/schemas/AIRLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    spatialkat: {
      anyOf: [
        {
          $ref: "#/components/schemas/SpatialKatLocationResult",
        },
        {
          type: "null",
        },
      ],
    },
    geographic_enrichment: {
      anyOf: [
        {
          $ref: "#/components/schemas/GeographicEnrichmentData",
        },
        {
          type: "null",
        },
      ],
    },
    hazard_hub: {
      anyOf: [
        {
          $ref: "#/components/schemas/HazardHubData",
        },
        {
          type: "null",
        },
      ],
    },
    nearmap: {
      anyOf: [
        {
          $ref: "#/components/schemas/NearmapData",
        },
        {
          type: "null",
        },
      ],
    },
    nearmap_ai: {
      anyOf: [
        {
          $ref: "#/components/schemas/NearmapAiData",
        },
        {
          type: "null",
        },
      ],
    },
    cape: {
      anyOf: [
        {
          $ref: "#/components/schemas/CapeData",
        },
        {
          type: "null",
        },
      ],
    },
    sindri: {
      anyOf: [
        {
          $ref: "#/components/schemas/SindriRow",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "AddressIntegrationData",
} as const;

export const $AddressList = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "AddressList",
} as const;

export const $AdvancedDeductible = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    short_deductible_description: {
      type: "string",
      title: "Short Deductible Description",
    },
    executable_python_function_str: {
      type: "string",
      title: "Executable Python Function Str",
    },
    executable_python_function_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Executable Python Function Override",
    },
    override_authored_against_form: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Override Authored Against Form",
    },
    direct_excerpts: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Direct Excerpts",
    },
    manual_excerpt_overrides: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Excerpt Overrides",
    },
    removed_excerpt_names: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Removed Excerpt Names",
    },
    excerpt_sort_keys: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Excerpt Sort Keys",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "short_deductible_description",
    "executable_python_function_str",
  ],
  title: "AdvancedDeductible",
} as const;

export const $AdvancedDeductibleInfo = {
  properties: {
    extracted_deductibles: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/AdvancedDeductible",
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Deductibles",
    },
    manual_deductibles: {
      additionalProperties: {
        $ref: "#/components/schemas/AdvancedDeductible",
      },
      type: "object",
      title: "Manual Deductibles",
    },
    extraction_instructions: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Extraction Instructions",
    },
  },
  type: "object",
  required: ["extracted_deductibles", "manual_deductibles"],
  title: "AdvancedDeductibleInfo",
} as const;

export const $AdvancedLimit = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    short_limit_description: {
      type: "string",
      title: "Short Limit Description",
    },
    document_quotation: {
      type: "string",
      title: "Document Quotation",
    },
    executable_python_function_str: {
      type: "string",
      title: "Executable Python Function Str",
    },
    executable_python_function_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Executable Python Function Override",
    },
    override_authored_against_form: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Override Authored Against Form",
    },
    direct_excerpts: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Direct Excerpts",
    },
    manual_excerpt_overrides: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Excerpt Overrides",
    },
    removed_excerpt_names: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Removed Excerpt Names",
    },
    excerpt_sort_keys: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Excerpt Sort Keys",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "short_limit_description",
    "document_quotation",
    "executable_python_function_str",
  ],
  title: "AdvancedLimit",
} as const;

export const $AdvancedLimitInfo = {
  properties: {
    extracted_limits: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/AdvancedLimit",
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Limits",
    },
    manual_limits: {
      additionalProperties: {
        $ref: "#/components/schemas/AdvancedLimit",
      },
      type: "object",
      title: "Manual Limits",
    },
    extraction_instructions: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Extraction Instructions",
    },
  },
  type: "object",
  required: ["extracted_limits", "manual_limits"],
  title: "AdvancedLimitInfo",
} as const;

export const $Appetite = {
  properties: {
    appetite_result: {
      type: "string",
      enum: [
        "in_appetite",
        "sic_codes_invalid",
        "no_sov_file",
        "no_loss_run_file",
        "far_away_effective_date",
        "low_tiv",
        "prior_submission",
        "updated_submission",
        "missing_cope_info",
        "foreign_exposure",
      ],
      title: "Appetite Result",
    },
    appetite_results: {
      items: {
        type: "string",
        enum: [
          "in_appetite",
          "sic_codes_invalid",
          "no_sov_file",
          "no_loss_run_file",
          "far_away_effective_date",
          "low_tiv",
          "prior_submission",
          "updated_submission",
          "missing_cope_info",
          "foreign_exposure",
        ],
      },
      type: "array",
      title: "Appetite Results",
    },
  },
  type: "object",
  required: ["appetite_result"],
  title: "Appetite",
} as const;

export const $ApplicationWorkingSet = {
  properties: {
    overlay: {
      $ref: "#/components/schemas/PolicyFieldOverlay",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["overlay", "notes"],
  title: "ApplicationWorkingSet",
  description: `Application-local state stored in \`\`policy_application.working_set\`\` —
only the overlay and underwriter notes, never a copy of report data.`,
} as const;

export const $AreaExposure = {
  properties: {
    locations: {
      type: "integer",
      title: "Locations",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    policy_count: {
      type: "integer",
      title: "Policy Count",
    },
    reachable_line: {
      type: "number",
      title: "Reachable Line",
    },
    blocked_line: {
      type: "number",
      title: "Blocked Line",
    },
    policies_without_layers: {
      type: "integer",
      title: "Policies Without Layers",
    },
    policies: {
      items: {
        $ref: "#/components/schemas/PolicyExposure",
      },
      type: "array",
      title: "Policies",
    },
    measured: {
      items: {
        items: {
          $ref: "#/components/schemas/LatLon",
        },
        type: "array",
      },
      type: "array",
      title: "Measured",
    },
    truncated: {
      type: "boolean",
      title: "Truncated",
    },
  },
  type: "object",
  required: [
    "locations",
    "tiv",
    "policy_count",
    "reachable_line",
    "blocked_line",
    "policies_without_layers",
    "policies",
    "measured",
    "truncated",
  ],
  title: "AreaExposure",
  description: `What sits inside a drawn shape, and what a loss there would reach.

Severity is the request's \`\`damage_ratio\`\`.`,
} as const;

export const $AreaExposureRequest = {
  properties: {
    lob: {
      type: "string",
      title: "Lob",
    },
    statuses: {
      anyOf: [
        {
          items: {
            type: "string",
            enum: [
              "pre_underwriting_review",
              "blocked",
              "not_cleared_prior_submission",
              "not_cleared_incomplete_submission",
              "not_cleared_out_of_appetite",
              "not_cleared_effective_date_too_far",
              "not_cleared_unapproved_broker",
              "not_cleared_low_tiv",
              "not_cleared_foreign_exposure",
              "cleared",
              "pending",
              "modeling_complete",
              "referral_sent",
              "flagged_for_review",
              "indicated",
              "quoted",
              "declined",
              "closed",
              "closed_bor",
              "not_reviewed",
              "lost",
              "quoted_not_taken_up",
              "bound",
              "issued",
            ],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Statuses",
    },
    polygon: {
      items: {
        $ref: "#/components/schemas/LatLon",
      },
      type: "array",
      maxItems: 2000,
      minItems: 3,
      title: "Polygon",
    },
    buffer_miles: {
      type: "number",
      maximum: 500,
      minimum: 0,
      title: "Buffer Miles",
    },
    track_radii_miles: {
      anyOf: [
        {
          items: {
            type: "number",
          },
          type: "array",
          maxItems: 2000,
        },
        {
          type: "null",
        },
      ],
      title: "Track Radii Miles",
    },
    damage_ratio: {
      type: "number",
      maximum: 1,
      exclusiveMinimum: 0,
      title: "Damage Ratio",
    },
  },
  type: "object",
  required: [
    "lob",
    "statuses",
    "polygon",
    "buffer_miles",
    "track_radii_miles",
    "damage_ratio",
  ],
  title: "AreaExposureRequest",
} as const;

export const $AssessmentData = {
  properties: {
    total_assessed_value: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Total Assessed Value",
    },
    tax_market_value: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Tax Market Value",
    },
    assessed_improvement_value: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Assessed Improvement Value",
    },
    assessed_land_value: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Assessed Land Value",
    },
    tax_amount: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tax Amount",
    },
    number_of_bedrooms: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Bedrooms",
    },
    number_of_baths: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Baths",
    },
    garage_cars: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Garage Cars",
    },
    lot_size_acres: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lot Size Acres",
    },
    lot_size_square_feet: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Lot Size Square Feet",
    },
    building_area_1: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Building Area 1",
    },
    owner_occupied: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Owner Occupied",
    },
  },
  type: "object",
  title: "AssessmentData",
  description:
    "Assessor fields beyond the COPE construction set (``enhanced_property.assessment``).",
} as const;

export const $Attachment = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    from_email: {
      type: "boolean",
      title: "From Email",
    },
    original_mapping: {
      type: "string",
      enum: [
        "sov_spreadsheet",
        "acord_app",
        "loss_run",
        "none",
        "screenshot",
        "rater",
        "loss_control_report",
        "policy_document",
        "manuscript_form",
        "final_manuscript_form",
        "specs_sheet",
        "record_keeping",
        "luminor_quote",
        "luminor_tria",
        "luminor_binder",
        "luminor_policy",
        "lead_quote",
        "lead_binder",
        "lead_policy",
        "bound_sov",
        "sl_letter",
        "endorsement_file",
        "endorsement_sov",
        "engineering_report",
        "rate_matrix",
        "form_review",
      ],
      title: "Original Mapping",
    },
    manual_mapping: {
      anyOf: [
        {
          type: "string",
          enum: [
            "sov_spreadsheet",
            "acord_app",
            "loss_run",
            "none",
            "screenshot",
            "rater",
            "loss_control_report",
            "policy_document",
            "manuscript_form",
            "final_manuscript_form",
            "specs_sheet",
            "record_keeping",
            "luminor_quote",
            "luminor_tria",
            "luminor_binder",
            "luminor_policy",
            "lead_quote",
            "lead_binder",
            "lead_policy",
            "bound_sov",
            "sl_letter",
            "endorsement_file",
            "endorsement_sov",
            "engineering_report",
            "rate_matrix",
            "form_review",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Manual Mapping",
    },
    source: {
      anyOf: [
        {
          type: "string",
          enum: ["email", "screenshot_tool", "user_upload", "generated"],
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
    conversation_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Conversation Id",
    },
    policy_application_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Application Id",
    },
    endorsement_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Endorsement Id",
    },
  },
  type: "object",
  required: ["name", "from_email", "original_mapping", "manual_mapping"],
  title: "Attachment",
} as const;

export const $AttachmentInfo = {
  properties: {
    attachments: {
      items: {
        $ref: "#/components/schemas/Attachment",
      },
      type: "array",
      title: "Attachments",
    },
  },
  type: "object",
  required: ["attachments"],
  title: "AttachmentInfo",
} as const;

export const $AutoAssignmentStyle = {
  properties: {
    assignment_type: {
      type: "string",
      enum: ["round_robin", "override_in_email"],
      title: "Assignment Type",
    },
    original_assignee: {
      type: "string",
      title: "Original Assignee",
    },
  },
  type: "object",
  required: ["assignment_type", "original_assignee"],
  title: "AutoAssignmentStyle",
} as const;

export const $BatchCommentsRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    target_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/CommentTargetType",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["report_ids", "target_type"],
  title: "BatchCommentsRequest",
} as const;

export const $BatchCommentsResponse = {
  properties: {
    comments_by_report_id: {
      additionalProperties: {
        $ref: "#/components/schemas/Comments",
      },
      type: "object",
      title: "Comments By Report Id",
    },
  },
  type: "object",
  required: ["comments_by_report_id"],
  title: "BatchCommentsResponse",
} as const;

export const $Body_asgard_application_quote_unknowns = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    template: {
      anyOf: [
        {
          type: "string",
          format: "binary",
        },
        {
          type: "null",
        },
      ],
      title: "Template",
    },
  },
  type: "object",
  required: ["application_id"],
  title: "Body_asgard_application_quote_unknowns",
} as const;

export const $Body_asgard_create_endorsement = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    policy_application_id: {
      type: "string",
      format: "uuid",
      title: "Policy Application Id",
    },
    effective_date: {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    description: {
      type: "string",
      title: "Description",
    },
    premium_basis: {
      $ref: "#/components/schemas/EndorsementPremiumBasis",
    },
    tiv_target: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Target",
    },
    custom_term_premium_delta: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Custom Term Premium Delta",
    },
    files: {
      anyOf: [
        {
          items: {
            type: "string",
            format: "binary",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Files",
    },
  },
  type: "object",
  required: [
    "report_id",
    "policy_application_id",
    "effective_date",
    "description",
    "premium_basis",
  ],
  title: "Body_asgard_create_endorsement",
} as const;

export const $Body_asgard_create_template = {
  properties: {
    template: {
      type: "string",
      format: "binary",
      title: "Template",
    },
  },
  type: "object",
  required: ["template"],
  title: "Body_asgard_create_template",
} as const;

export const $Body_asgard_generate_application_quote = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    output_format: {
      type: "string",
      enum: ["docx", "pdf"],
      title: "Output Format",
    },
    save_to_report: {
      type: "boolean",
      title: "Save To Report",
    },
    persist_template: {
      type: "boolean",
      title: "Persist Template",
    },
    full_package: {
      type: "boolean",
      title: "Full Package",
    },
    template: {
      anyOf: [
        {
          type: "string",
          format: "binary",
        },
        {
          type: "null",
        },
      ],
      title: "Template",
    },
  },
  type: "object",
  required: [
    "application_id",
    "output_format",
    "save_to_report",
    "persist_template",
    "full_package",
  ],
  title: "Body_asgard_generate_application_quote",
} as const;

export const $Body_asgard_save_application_quote_template = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    template: {
      type: "string",
      format: "binary",
      title: "Template",
    },
  },
  type: "object",
  required: ["application_id", "template"],
  title: "Body_asgard_save_application_quote_template",
} as const;

export const $Body_asgard_upload_additional_file = {
  properties: {
    files: {
      items: {
        type: "string",
        format: "binary",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "Body_asgard_upload_additional_file",
} as const;

export const $Body_asgard_upload_email_thread = {
  properties: {
    files: {
      items: {
        type: "string",
        format: "binary",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "Body_asgard_upload_email_thread",
} as const;

export const $Body_asgard_upload_endorsement_documents = {
  properties: {
    endorsement_id: {
      type: "string",
      format: "uuid",
      title: "Endorsement Id",
    },
    files: {
      items: {
        type: "string",
        format: "binary",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["endorsement_id", "files"],
  title: "Body_asgard_upload_endorsement_documents",
} as const;

export const $Body_bdx_peril_breakdown = {
  properties: {
    file: {
      type: "string",
      format: "binary",
      title: "File",
    },
  },
  type: "object",
  required: ["file"],
  title: "Body_bdx_peril_breakdown",
} as const;

export const $Body_login = {
  properties: {
    grant_type: {
      anyOf: [
        {
          type: "string",
          pattern: "password",
        },
        {
          type: "null",
        },
      ],
      title: "Grant Type",
    },
    username: {
      type: "string",
      title: "Username",
    },
    password: {
      type: "string",
      title: "Password",
    },
    scope: {
      type: "string",
      title: "Scope",
      default: "",
    },
    client_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Id",
    },
    client_secret: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Client Secret",
    },
  },
  type: "object",
  required: ["username", "password"],
  title: "Body_login",
} as const;

export const $BookSummaryResponse = {
  properties: {
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    states: {
      items: {
        $ref: "#/components/schemas/StateSummary",
      },
      type: "array",
      title: "States",
    },
  },
  type: "object",
  required: ["total_tiv", "states"],
  title: "BookSummaryResponse",
} as const;

export const $BorEmailRecord = {
  properties: {
    sent_at: {
      type: "string",
      format: "date-time",
      title: "Sent At",
    },
    recipients: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Recipients",
    },
    subject: {
      type: "string",
      title: "Subject",
    },
    email_type: {
      type: "string",
      title: "Email Type",
    },
  },
  type: "object",
  required: ["sent_at", "recipients", "subject", "email_type"],
  title: "BorEmailRecord",
  description:
    "One sent broker email, stored in BorLetter.emails_sent keyed by step.",
} as const;

export const $BorEmailRequest = {
  properties: {
    bor_id: {
      type: "string",
      format: "uuid",
      title: "Bor Id",
    },
    step: {
      type: "string",
      enum: [
        "outgoing_broker_notified_at",
        "incoming_broker_notified_at",
        "rescind_letter_received_at",
        "finalized_at",
        "outgoing_broker_resolution_sent_at",
        "incoming_broker_resolution_sent_at",
      ],
      title: "Step",
    },
  },
  type: "object",
  required: ["bor_id", "step"],
  title: "BorEmailRequest",
} as const;

export const $BorLetterListResponse = {
  properties: {
    bor_letters: {
      items: {
        $ref: "#/components/schemas/BorLetterResponse",
      },
      type: "array",
      title: "Bor Letters",
    },
  },
  type: "object",
  required: ["bor_letters"],
  title: "BorLetterListResponse",
} as const;

export const $BorLetterResponse = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    cleared_report_id: {
      type: "string",
      title: "Cleared Report Id",
    },
    incoming_report_id: {
      type: "string",
      title: "Incoming Report Id",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
    created_by: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Created By",
    },
    received_at: {
      type: "string",
      format: "date-time",
      title: "Received At",
    },
    outgoing_broker_notified_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Outgoing Broker Notified At",
    },
    incoming_broker_notified_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Incoming Broker Notified At",
    },
    rescind_letter_received_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Rescind Letter Received At",
    },
    finalized_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Finalized At",
    },
    outgoing_broker_resolution_sent_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Outgoing Broker Resolution Sent At",
    },
    incoming_broker_resolution_sent_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Incoming Broker Resolution Sent At",
    },
    rescind_deadline: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Rescind Deadline",
    },
    is_resolved: {
      type: "boolean",
      title: "Is Resolved",
    },
    notification_sla_deadline: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Notification Sla Deadline",
    },
    notifications_sent: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Notifications Sent",
    },
    emails_sent: {
      additionalProperties: {
        $ref: "#/components/schemas/BorEmailRecord",
      },
      type: "object",
      title: "Emails Sent",
    },
  },
  type: "object",
  required: [
    "id",
    "client_id",
    "cleared_report_id",
    "incoming_report_id",
    "effective_date",
    "notes",
    "created_by",
    "received_at",
    "outgoing_broker_notified_at",
    "incoming_broker_notified_at",
    "rescind_letter_received_at",
    "finalized_at",
    "outgoing_broker_resolution_sent_at",
    "incoming_broker_resolution_sent_at",
    "rescind_deadline",
    "is_resolved",
    "notification_sla_deadline",
    "notifications_sent",
    "emails_sent",
  ],
  title: "BorLetterResponse",
} as const;

export const $BuildingData = {
  properties: {
    id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    roof_age_years: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Age Years",
    },
    materials: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Materials",
    },
    shapes: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Shapes",
    },
  },
  type: "object",
  title: "BuildingData",
  description:
    "One building/structure on the parcel, joining buildings + roof_age + geoJson.",
} as const;

export const $BulkEditRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    field: {
      type: "string",
      title: "Field",
    },
    instructions: {
      type: "string",
      title: "Instructions",
    },
  },
  type: "object",
  required: ["report_id", "field", "instructions"],
  title: "BulkEditRequest",
} as const;

export const $BulkEditResponse = {
  properties: {
    before: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Before",
    },
    after: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "After",
    },
  },
  type: "object",
  required: ["before", "after"],
  title: "BulkEditResponse",
} as const;

export const $BulkEnrichmentReportResult = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    company_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Name",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
    },
    enqueued_sources: {
      items: {
        type: "string",
        enum: ["nearmap", "hazard_hub", "cape"],
      },
      type: "array",
      title: "Enqueued Sources",
    },
    skipped_reason: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Skipped Reason",
    },
  },
  type: "object",
  required: [
    "report_id",
    "company_name",
    "num_addresses",
    "enqueued_sources",
    "skipped_reason",
  ],
  title: "BulkEnrichmentReportResult",
} as const;

export const $BulkEnrichmentRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    sources: {
      items: {
        type: "string",
        enum: ["nearmap", "hazard_hub", "cape"],
      },
      type: "array",
      title: "Sources",
    },
  },
  type: "object",
  required: ["report_ids", "sources"],
  title: "BulkEnrichmentRequest",
} as const;

export const $BulkEnrichmentResponse = {
  properties: {
    results: {
      items: {
        $ref: "#/components/schemas/BulkEnrichmentReportResult",
      },
      type: "array",
      title: "Results",
    },
    enqueued_count: {
      type: "integer",
      title: "Enqueued Count",
    },
    skipped_count: {
      type: "integer",
      title: "Skipped Count",
    },
  },
  type: "object",
  required: ["results", "enqueued_count", "skipped_count"],
  title: "BulkEnrichmentResponse",
} as const;

export const $CalculatePremiumRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    batch_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "CalculatePremiumRequest",
} as const;

export const $CalculatedPremiumResponse = {
  properties: {
    layers: {
      items: {
        $ref: "#/components/schemas/LayerPremiumBreakdown",
      },
      type: "array",
      title: "Layers",
    },
    errors: {
      items: {
        $ref: "#/components/schemas/PremiumError",
      },
      type: "array",
      title: "Errors",
      default: [],
    },
  },
  type: "object",
  required: ["layers"],
  title: "CalculatedPremiumResponse",
} as const;

export const $CancelJobRequest = {
  properties: {
    report_integration_id: {
      type: "string",
      title: "Report Integration Id",
    },
  },
  type: "object",
  required: ["report_integration_id"],
  title: "CancelJobRequest",
} as const;

export const $CancelJobResponse = {
  properties: {},
  type: "object",
  title: "CancelJobResponse",
} as const;

export const $CapeData = {
  properties: {
    structure_count: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Structure Count",
    },
    weighted_roof_condition_rating: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Weighted Roof Condition Rating",
    },
    pool_count: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Pool Count",
    },
    wildfire_hazard_potential: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wildfire Hazard Potential",
    },
    primary_structure: {
      anyOf: [
        {
          $ref: "#/components/schemas/CapeStructureData",
        },
        {
          type: "null",
        },
      ],
    },
    derived_modifiers: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Derived Modifiers",
      default: {},
    },
  },
  type: "object",
  title: "CapeData",
  description: `Curated subset of the Cape Analytics commercial property response.

Construct from a validated Cape envelope with :meth:\`from_cape\`. The model
stays a plain round-trippable struct (\`\`model_validate\`\` / \`\`model_dump\`\`)
so it can be persisted and re-read without re-parsing. Kept deliberately
slim (this is stored per-address); the full response is archived to GCS.`,
} as const;

export const $CapeInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "CapeInitiateRequest",
} as const;

export const $CapeInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "CapeInitiateResponse",
} as const;

export const $CapeJobHistoryItem = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
    },
    enriched_count: {
      type: "integer",
      title: "Enriched Count",
    },
  },
  type: "object",
  required: [
    "batch_id",
    "status",
    "started_at",
    "finished_at",
    "num_addresses",
    "enriched_count",
  ],
  title: "CapeJobHistoryItem",
} as const;

export const $CapeJobHistoryResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/CapeJobHistoryItem",
      },
      type: "array",
      title: "Jobs",
      default: [],
    },
  },
  type: "object",
  title: "CapeJobHistoryResponse",
} as const;

export const $CapeStructureData = {
  properties: {
    roof_covering: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Covering",
    },
    roof_geometry: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Geometry",
    },
    roof_age_years: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Age Years",
    },
    roof_replacement_year: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Replacement Year",
    },
    solar_panel: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Solar Panel",
    },
    tree_overhang: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Tree Overhang",
    },
    number_of_stories: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Stories",
    },
    year_built: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Year Built",
    },
    construction_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Type",
    },
    structure_exterior: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Structure Exterior",
    },
    structure_foundation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Structure Foundation",
    },
  },
  type: "object",
  title: "CapeStructureData",
  description: `Displayed attributes of one structure/building, flattened from \`\`structures[]\`\`.

Deliberately slim: only the scalars the SOV grid renders are kept, so the
per-address row we persist stays small. The full structure detail (all
attributes, every structure) lives in the raw envelope archived to GCS and
can be backfilled here later if a consumer needs more.`,
} as const;

export const $CatActivateResult = {
  properties: {
    integration_type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Integration Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["integration_type", "batch_id"],
  title: "CatActivateResult",
  description:
    "Result of promoting a run to the report's live results for its vendor.",
} as const;

export const $CatAggregateData = {
  properties: {
    aal_combined_groundup: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Combined Groundup",
    },
    aal_per_peril_groundup: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Per Peril Groundup",
      default: {},
    },
    layers: {
      items: {
        $ref: "#/components/schemas/CatLayerResult",
      },
      type: "array",
      title: "Layers",
      default: [],
    },
    ep_curves: {
      items: {
        $ref: "#/components/schemas/EPRow",
      },
      type: "array",
      title: "Ep Curves",
      default: [],
    },
    standard_deviation_combined_groundup: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Standard Deviation Combined Groundup",
    },
    standard_deviation_per_peril_groundup: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Standard Deviation Per Peril Groundup",
      default: {},
    },
    pmi: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatPmiData",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "CatAggregateData",
} as const;

export const $CatJobHistoryItem = {
  properties: {
    type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
      default: 0,
    },
    total_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Aal",
    },
    total_tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    foreign_tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Foreign Tiv",
    },
    num_layers: {
      type: "integer",
      title: "Num Layers",
      default: 0,
    },
    enriched: {
      type: "boolean",
      title: "Enriched",
      default: false,
    },
    enrichment_source: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Enrichment Source",
    },
    is_test: {
      type: "boolean",
      title: "Is Test",
      default: false,
    },
    sub_tasks_count: {
      type: "integer",
      title: "Sub Tasks Count",
      default: 0,
    },
    sub_tasks_completed: {
      type: "integer",
      title: "Sub Tasks Completed",
      default: 0,
    },
    is_active: {
      type: "boolean",
      title: "Is Active",
      default: false,
    },
    auto_run: {
      type: "boolean",
      title: "Auto Run",
      default: false,
    },
    run_type: {
      type: "string",
      enum: ["underwriting", "test_run"],
      title: "Run Type",
      default: "underwriting",
    },
    term: {
      anyOf: [
        {
          type: "string",
          enum: ["annual", "policy"],
        },
        {
          type: "null",
        },
      ],
      title: "Term",
    },
  },
  type: "object",
  required: ["type", "batch_id", "status", "started_at", "finished_at", "term"],
  title: "CatJobHistoryItem",
} as const;

export const $CatJobHistoryResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/CatJobHistoryItem",
      },
      type: "array",
      title: "Jobs",
      default: [],
    },
  },
  type: "object",
  title: "CatJobHistoryResponse",
} as const;

export const $CatLayerResult = {
  properties: {
    layer_guid: {
      type: "string",
      title: "Layer Guid",
    },
    perils: {
      additionalProperties: {
        $ref: "#/components/schemas/CatPerilLayerData",
      },
      type: "object",
      title: "Perils",
      default: {},
    },
    totals: {
      $ref: "#/components/schemas/CatPerilLayerData",
      default: {
        pml_per_period: {},
      },
    },
    ep_curves: {
      items: {
        $ref: "#/components/schemas/EPRow",
      },
      type: "array",
      title: "Ep Curves",
      default: [],
    },
    locations: {
      items: {
        $ref: "#/components/schemas/CatLocationWithAddress",
      },
      type: "array",
      title: "Locations",
      default: [],
    },
  },
  type: "object",
  required: ["layer_guid"],
  title: "CatLayerResult",
} as const;

export const $CatLocationWithAddress = {
  properties: {
    aal_combined: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Combined",
    },
    aal_per_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Per Peril",
      default: {},
    },
    address: {
      anyOf: [
        {
          $ref: "#/components/schemas/LocationAddress",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  title: "CatLocationWithAddress",
} as const;

export const $CatMetadata = {
  properties: {
    enrichment_source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Enrichment Source",
    },
  },
  type: "object",
  required: ["enrichment_source"],
  title: "CatMetadata",
  description: "What a modeling or rating job ran under.",
} as const;

export const $CatPerilLayerData = {
  properties: {
    aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal",
    },
    pml_per_period: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["100", "250", "1000"],
      },
      type: "object",
      title: "Pml Per Period",
      default: {},
    },
  },
  type: "object",
  title: "CatPerilLayerData",
} as const;

export const $CatPmiData = {
  properties: {
    per_peril: {
      additionalProperties: {
        additionalProperties: {
          type: "number",
        },
        propertyNames: {
          enum: ["100", "250", "1000"],
        },
        type: "object",
      },
      type: "object",
      title: "Per Peril",
      default: {},
    },
    as_of: {
      type: "string",
      format: "date-time",
      title: "As Of",
    },
    portfolio_report_count: {
      type: "integer",
      title: "Portfolio Report Count",
    },
  },
  type: "object",
  required: ["as_of", "portfolio_report_count"],
  title: "CatPmiData",
  description: `Portfolio Marginal Impact: this account's contribution to the
combined in-force book's PML at each return period — its average loss
across the catalog years ranked around that PML's threshold, at 100%
of each enabled layer (gross, matching the PML columns; pinned against
participation edits). Account-wide, per peril only (no all-peril
figure — cross-peril year alignment in the catalog is undocumented);
PMIs do not sum across perils or layers.`,
} as const;

export const $CatPrecheckResponse = {
  properties: {
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    blocking_reasons: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Blocking Reasons",
    },
    icm: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
    rms: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
    rms_22: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
    spatialkat: {
      $ref: "#/components/schemas/VendorPrecheck",
    },
  },
  type: "object",
  required: [
    "warnings",
    "blocking_reasons",
    "icm",
    "rms",
    "rms_22",
    "spatialkat",
  ],
  title: "CatPrecheckResponse",
  description: `What the user sees on cat tab load — human-readable warnings about
foreign exposure, geocoding gaps, and location limits, per vendor.`,
} as const;

export const $CatRerunFinancialResult = {
  properties: {
    integration_type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Integration Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    source_batch_id: {
      type: "string",
      title: "Source Batch Id",
    },
  },
  type: "object",
  required: ["integration_type", "batch_id", "source_batch_id"],
  title: "CatRerunFinancialResult",
  description: `Result of kicking off a financial-only re-run for a cat integration.

\`\`batch_id\`\` is the new batch created for the re-run (poll it for
progress); \`\`source_batch_id\`\` is the original batch whose cached
model artifacts are reused.`,
} as const;

export const $CatResultsResponse = {
  properties: {
    rms_elt: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    rms_22: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    spatialkat: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
    icm_ylt: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatSourceData",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  title: "CatResultsResponse",
} as const;

export const $CatResumeResult = {
  properties: {
    integration_type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Integration Type",
    },
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["integration_type", "batch_id"],
  title: "CatResumeResult",
  description: `Result of resuming a cat integration's batch in place. \`\`batch_id\`\`
is the resumed batch — poll it for progress, exactly as for a normal
run.`,
} as const;

export const $CatRunChange = {
  type: "string",
  enum: [
    "no_complete_run",
    "unchanged",
    "terms_changed",
    "full_remodel",
    "no_baseline",
  ],
  title: "CatRunChange",
  description: `What has changed on a report since its last complete CAT run. A \`\`str\`\`
enum so it serializes to its value over the API.`,
} as const;

export const $CatRunChangeReason = {
  type: "string",
  enum: [
    "addresses",
    "effective_date",
    "expiration_date",
    "limits",
    "deductibles",
    "layers",
    "new_modelable_peril",
    "enrichment",
    "no_snapshot",
  ],
  title: "CatRunChangeReason",
  description: `A specific trigger behind a \`\`CatRunChange\`\`, for the UI to render into
user-facing copy. A \`\`str\`\` enum so it serializes to its value over the API.`,
} as const;

export const $CatRunChangeReasonDetail = {
  properties: {
    reason: {
      $ref: "#/components/schemas/CatRunChangeReason",
    },
    before: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Before",
    },
    after: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "After",
    },
  },
  type: "object",
  required: ["reason", "before", "after"],
  title: "CatRunChangeReasonDetail",
} as const;

export const $CatRunChangeResult = {
  properties: {
    change: {
      $ref: "#/components/schemas/CatRunChange",
    },
    reasons: {
      items: {
        $ref: "#/components/schemas/CatRunChangeReasonDetail",
      },
      type: "array",
      title: "Reasons",
    },
    is_auto_run_shadow: {
      type: "boolean",
      title: "Is Auto Run Shadow",
    },
  },
  type: "object",
  required: ["change", "reasons", "is_auto_run_shadow"],
  title: "CatRunChangeResult",
} as const;

export const $CatRunFailed = {
  properties: {
    status: {
      type: "string",
      const: "failed",
      title: "Status",
    },
    type: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Type",
    },
    detail: {
      type: "string",
      title: "Detail",
    },
  },
  type: "object",
  required: ["status", "type", "detail"],
  title: "CatRunFailed",
  description:
    "The run hit an unexpected error while starting. It has been reported.",
} as const;

export const $CatRunInFlight = {
  properties: {
    status: {
      type: "string",
      const: "in_flight",
      title: "Status",
    },
    type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Type",
    },
    detail: {
      type: "string",
      title: "Detail",
    },
  },
  type: "object",
  required: ["status", "type", "detail"],
  title: "CatRunInFlight",
  description: "A baseline run was refused because one is already in flight.",
} as const;

export const $CatRunRef = {
  properties: {
    type: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Type",
    },
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["type", "request_id"],
  title: "CatRunRef",
} as const;

export const $CatRunRefused = {
  properties: {
    status: {
      type: "string",
      const: "refused",
      title: "Status",
    },
    type: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Type",
    },
    detail: {
      type: "string",
      title: "Detail",
    },
  },
  type: "object",
  required: ["status", "type", "detail"],
  title: "CatRunRefused",
  description:
    "The run is not available to this user or client on this report.",
} as const;

export const $CatRunRequest = {
  properties: {
    runs: {
      items: {
        oneOf: [
          {
            $ref: "#/components/schemas/CatRunSpec",
          },
          {
            $ref: "#/components/schemas/RaterRunSpec",
          },
          {
            $ref: "#/components/schemas/EqbdRaterRunSpec",
          },
        ],
        discriminator: {
          propertyName: "type",
          mapping: {
            eqbd_rater: "#/components/schemas/EqbdRaterRunSpec",
            icm_ylt: "#/components/schemas/CatRunSpec",
            rater: "#/components/schemas/RaterRunSpec",
            rms_22: "#/components/schemas/CatRunSpec",
            rms_elt: "#/components/schemas/CatRunSpec",
            spatialkat: "#/components/schemas/CatRunSpec",
          },
        },
      },
      type: "array",
      minItems: 1,
      title: "Runs",
    },
  },
  type: "object",
  required: ["runs"],
  title: "CatRunRequest",
} as const;

export const $CatRunResult = {
  properties: {
    runs: {
      items: {
        oneOf: [
          {
            $ref: "#/components/schemas/CatRunStarted",
          },
          {
            $ref: "#/components/schemas/CatRunInFlight",
          },
          {
            $ref: "#/components/schemas/CatRunRefused",
          },
          {
            $ref: "#/components/schemas/CatRunFailed",
          },
        ],
        discriminator: {
          propertyName: "status",
          mapping: {
            failed: "#/components/schemas/CatRunFailed",
            in_flight: "#/components/schemas/CatRunInFlight",
            refused: "#/components/schemas/CatRunRefused",
            started: "#/components/schemas/CatRunStarted",
          },
        },
      },
      type: "array",
      title: "Runs",
    },
  },
  type: "object",
  required: ["runs"],
  title: "CatRunResult",
} as const;

export const $CatRunSpec = {
  properties: {
    type: {
      type: "string",
      enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
      title: "Type",
    },
    activate: {
      type: "boolean",
      title: "Activate",
    },
    enrichment_source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Enrichment Source",
    },
    mode: {
      type: "string",
      enum: ["default", "full", "finance"],
      title: "Mode",
    },
    run_type: {
      type: "string",
      enum: ["underwriting", "test_run"],
      title: "Run Type",
    },
  },
  type: "object",
  required: ["type", "activate", "enrichment_source", "mode", "run_type"],
  title: "CatRunSpec",
} as const;

export const $CatRunStarted = {
  properties: {
    status: {
      type: "string",
      const: "started",
      title: "Status",
    },
    type: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Type",
    },
    request_id: {
      type: "string",
      title: "Request Id",
    },
    action: {
      type: "string",
      enum: ["reprice", "activate", "unchanged", "full"],
      title: "Action",
    },
  },
  type: "object",
  required: ["status", "type", "request_id", "action"],
  title: "CatRunStarted",
} as const;

export const $CatRunStatus = {
  properties: {
    type: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Type",
    },
    request_id: {
      type: "string",
      title: "Request Id",
    },
    status: {
      anyOf: [
        {
          $ref: "#/components/schemas/IntegrationStatusResult",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["type", "request_id", "status"],
  title: "CatRunStatus",
} as const;

export const $CatSourceData = {
  properties: {
    aggregate: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatAggregateData",
        },
        {
          type: "null",
        },
      ],
    },
    top_locations_by_peril: {
      additionalProperties: {
        items: {
          $ref: "#/components/schemas/CatTopLocation",
        },
        type: "array",
      },
      type: "object",
      title: "Top Locations By Peril",
      default: {},
    },
    model_profiles: {
      items: {
        $ref: "#/components/schemas/PerilModelProfile",
      },
      type: "array",
      title: "Model Profiles",
      default: [],
    },
  },
  type: "object",
  title: "CatSourceData",
  description: "Aggregate + location results for one modeling source.",
} as const;

export const $CatStatusRequest = {
  properties: {
    runs: {
      items: {
        $ref: "#/components/schemas/CatRunRef",
      },
      type: "array",
      title: "Runs",
    },
  },
  type: "object",
  required: ["runs"],
  title: "CatStatusRequest",
} as const;

export const $CatStatusResult = {
  properties: {
    runs: {
      items: {
        $ref: "#/components/schemas/CatRunStatus",
      },
      type: "array",
      title: "Runs",
    },
  },
  type: "object",
  required: ["runs"],
  title: "CatStatusResult",
} as const;

export const $CatTopLocation = {
  properties: {
    aal: {
      type: "number",
      title: "Aal",
    },
    tiv_pct: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Pct",
    },
    aal_pct: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aal Pct",
    },
    address: {
      anyOf: [
        {
          $ref: "#/components/schemas/LocationAddress",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["aal"],
  title: "CatTopLocation",
} as const;

export const $Chart = {
  properties: {
    title: {
      type: "string",
      title: "Title",
    },
    data: {
      items: {
        $ref: "#/components/schemas/DataPoint",
      },
      type: "array",
      title: "Data",
    },
  },
  type: "object",
  required: ["title", "data"],
  title: "Chart",
} as const;

export const $ChartGroup = {
  properties: {
    title: {
      type: "string",
      title: "Title",
    },
    charts: {
      items: {
        $ref: "#/components/schemas/Chart",
      },
      type: "array",
      title: "Charts",
    },
  },
  type: "object",
  required: ["title", "charts"],
  title: "ChartGroup",
} as const;

export const $ClassifyStagedAttachmentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    staging_id: {
      type: "string",
      title: "Staging Id",
    },
    attachment_name: {
      type: "string",
      title: "Attachment Name",
    },
  },
  type: "object",
  required: ["report_id", "staging_id", "attachment_name"],
  title: "ClassifyStagedAttachmentRequest",
} as const;

export const $ClassifyStagedAttachmentResponse = {
  properties: {
    classification: {
      type: "string",
      enum: [
        "sov_spreadsheet",
        "acord_app",
        "loss_run",
        "none",
        "screenshot",
        "rater",
        "loss_control_report",
        "policy_document",
        "manuscript_form",
        "final_manuscript_form",
        "specs_sheet",
        "record_keeping",
        "luminor_quote",
        "luminor_tria",
        "luminor_binder",
        "luminor_policy",
        "lead_quote",
        "lead_binder",
        "lead_policy",
        "bound_sov",
        "sl_letter",
        "endorsement_file",
        "endorsement_sov",
        "engineering_report",
        "rate_matrix",
        "form_review",
      ],
      title: "Classification",
    },
  },
  type: "object",
  required: ["classification"],
  title: "ClassifyStagedAttachmentResponse",
} as const;

export const $ClearanceCheck = {
  properties: {
    id: {
      type: "string",
      enum: [
        "appetite",
        "tiv_matches_target",
        "addresses_reasonable",
        "file_classifications",
        "limits_and_deductibles",
        "functions_execute",
      ],
      title: "Id",
    },
    label: {
      type: "string",
      title: "Label",
    },
    status: {
      $ref: "#/components/schemas/ClearanceCheckStatus",
    },
    summary: {
      type: "string",
      title: "Summary",
    },
    details: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Details",
    },
  },
  type: "object",
  required: ["id", "label", "status", "summary"],
  title: "ClearanceCheck",
} as const;

export const $ClearanceCheckStatus = {
  type: "string",
  enum: ["pass", "fail", "unknown"],
  title: "ClearanceCheckStatus",
} as const;

export const $ClearanceEmailRecipientsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "ClearanceEmailRecipientsRequest",
} as const;

export const $ClearanceEmailRecipientsResponse = {
  properties: {
    recipients: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Recipients",
    },
    locked_emails: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Locked Emails",
    },
  },
  type: "object",
  required: ["recipients", "locked_emails"],
  title: "ClearanceEmailRecipientsResponse",
} as const;

export const $ClearanceReview = {
  properties: {
    outcome: {
      type: "string",
      enum: ["clear", "needs_review", "skipped"],
      title: "Outcome",
    },
    skip_reason: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Skip Reason",
    },
    checks: {
      items: {
        $ref: "#/components/schemas/ClearanceCheck",
      },
      type: "array",
      title: "Checks",
    },
    finished_at: {
      type: "string",
      format: "date-time",
      title: "Finished At",
    },
  },
  type: "object",
  required: ["outcome", "skip_reason", "checks", "finished_at"],
  title: "ClearanceReview",
  description: "Outcome of one general clearance review.",
} as const;

export const $Comment = {
  properties: {
    message: {
      type: "string",
      title: "Message",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    last_updated_ts: {
      type: "string",
      format: "date-time",
      title: "Last Updated Ts",
    },
    user_id: {
      type: "string",
      title: "User Id",
    },
    id: {
      type: "string",
      title: "Id",
    },
    deleted: {
      type: "boolean",
      title: "Deleted",
      default: false,
    },
    target_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/CommentTargetType",
        },
        {
          type: "null",
        },
      ],
    },
    target_key: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Target Key",
    },
  },
  type: "object",
  required: ["message", "created_at_ts", "last_updated_ts", "user_id", "id"],
  title: "Comment",
} as const;

export const $CommentTargetType = {
  type: "string",
  enum: ["loss_year", "attachment"],
  title: "CommentTargetType",
  description: `What a comment is attached to within a report.

A comment with no \`\`target_type\`\` (None) is report-level — the original
behavior. \`\`LOSS_YEAR\`\` scopes a comment to a single policy year of the
loss run; its \`\`target_key\`\` is the normalized \`\`"YYYY-YYYY"\`\` policy-year
string, which is stable across reprocess (unlike individual claims).
\`\`ATTACHMENT\`\` scopes a comment to one attachment; its \`\`target_key\`\` is the
attachment name.`,
} as const;

export const $Comments = {
  properties: {
    all_comments: {
      items: {
        $ref: "#/components/schemas/Comment",
      },
      type: "array",
      title: "All Comments",
    },
  },
  type: "object",
  required: ["all_comments"],
  title: "Comments",
} as const;

export const $CommercialReport = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    naics_info: {
      $ref: "#/components/schemas/NaicsInfo",
    },
    sovs: {
      items: {
        $ref: "#/components/schemas/SOV",
      },
      type: "array",
      title: "Sovs",
    },
    loss_run: {
      $ref: "#/components/schemas/LossRunInfo",
    },
    company_info: {
      $ref: "#/components/schemas/CompanyInfo",
    },
    layer_info: {
      items: {
        $ref: "#/components/schemas/Layer",
      },
      type: "array",
      title: "Layer Info",
    },
    ofac_result: {
      anyOf: [
        {
          $ref: "#/components/schemas/OFACResult",
        },
        {
          type: "null",
        },
      ],
    },
    policy_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    policy_questions: {
      anyOf: [
        {
          additionalProperties: {
            items: {
              $ref: "#/components/schemas/PolicyQuestion",
            },
            type: "array",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Questions",
    },
    additional_files_used: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Files Used",
    },
    loss_control_reports: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/LossControlReport",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Control Reports",
    },
    attachment_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AttachmentInfo",
        },
        {
          type: "null",
        },
      ],
    },
    parsed_sources: {
      anyOf: [
        {
          additionalProperties: {
            items: {
              type: "string",
            },
            type: "array",
          },
          propertyNames: {
            $ref: "#/components/schemas/RerunComponent",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Parsed Sources",
    },
    referral_text: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReferralText",
        },
        {
          type: "null",
        },
      ],
    },
    policy_questions_for_policy_documents: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyQuestionsForDocuments",
        },
        {
          type: "null",
        },
      ],
    },
    limit_and_sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LimitAndSublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedLimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/SublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    deductible_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedDeductibleInfo",
        },
        {
          type: "null",
        },
      ],
    },
    submission_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Submission Recipients",
    },
    policy_fly_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Fly Url",
    },
    policy_fly_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyFlyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    email_threads: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Email Threads",
    },
  },
  type: "object",
  required: [
    "report_id",
    "naics_info",
    "sovs",
    "loss_run",
    "company_info",
    "layer_info",
  ],
  title: "CommercialReport",
} as const;

export const $CommericalReportMetadata = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    naics_info: {
      $ref: "#/components/schemas/NaicsInfo",
    },
    company_info: {
      $ref: "#/components/schemas/CompanyInfo",
    },
    precomputed_metadata: {
      $ref: "#/components/schemas/PrecomputedMetadata",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "naics_info",
    "company_info",
    "precomputed_metadata",
  ],
  title: "CommericalReportMetadata",
} as const;

export const $CompanyInfo = {
  properties: {
    private_computed_values: {
      $ref: "#/components/schemas/RawCompanyInfo",
    },
    private_original_values: {
      additionalProperties: {
        anyOf: [
          {
            items: {
              type: "string",
            },
            type: "array",
          },
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Original Values",
    },
    private_overrides: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            items: {
              type: "string",
            },
            type: "array",
          },
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Private Overrides",
    },
    private_flags: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              type: "string",
              enum: [
                "low_confidence",
                "medium_confidence",
                "modified_by_sanitization",
                "default_used",
                "could_not_sanitize",
                "po_box_insured_address",
              ],
            },
            {
              $ref: "#/components/schemas/YearIncorporatedDerivedFromSearch",
            },
            {
              $ref: "#/components/schemas/MultipleCompanyNamesFlag",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Private Flags",
    },
    additional_interests: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/OverrideableListElement_RawAdditionalInterest_Literal__todo___",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Interests",
    },
  },
  type: "object",
  required: [
    "private_computed_values",
    "private_original_values",
    "private_overrides",
    "private_flags",
  ],
  title: "CompanyInfo",
} as const;

export const $CompetitorPricing = {
  properties: {
    carrier_name: {
      type: "string",
      title: "Carrier Name",
    },
    price: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Price",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["carrier_name", "price", "notes"],
  title: "CompetitorPricing",
} as const;

export const $ComputedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    source: {
      type: "string",
      const: "computed_from_claims",
      title: "Source",
    },
    claims: {
      items: {
        anyOf: [
          {
            $ref: "#/components/schemas/ParsedLoss",
          },
          {
            $ref: "#/components/schemas/UserGeneratedLoss",
          },
        ],
      },
      type: "array",
      title: "Claims",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "source",
    "claims",
  ],
  title: "ComputedLossRunByYear",
} as const;

export const $ConstructionMix = {
  properties: {
    construction_description: {
      type: "string",
      title: "Construction Description",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["construction_description", "tiv", "pct_tiv"],
  title: "ConstructionMix",
} as const;

export const $ContactType = {
  type: "string",
  enum: ["broker"],
  title: "ContactType",
  description: "Contact type enum for categorizing contacts.",
} as const;

export const $Coordinate = {
  properties: {
    lat: {
      type: "number",
      title: "Lat",
    },
    lon: {
      type: "number",
      title: "Lon",
    },
  },
  additionalProperties: false,
  type: "object",
  required: ["lat", "lon"],
  title: "Coordinate",
  description:
    "A bare position, for a ring or a path that carries nothing else.",
} as const;

export const $CoverageComputedFromColumnSum = {
  properties: {
    flag_id: {
      type: "string",
      const: "coverage_computed_from_column_sum",
      title: "Flag Id",
    },
    columns: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Columns",
    },
  },
  type: "object",
  required: ["flag_id", "columns"],
  title: "CoverageComputedFromColumnSum",
} as const;

export const $CreateBorLetterRequest = {
  properties: {
    cleared_report_id: {
      type: "string",
      title: "Cleared Report Id",
    },
    incoming_report_id: {
      type: "string",
      title: "Incoming Report Id",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["cleared_report_id", "incoming_report_id"],
  title: "CreateBorLetterRequest",
} as const;

export const $CreateContactRequest = {
  properties: {
    email: {
      type: "string",
      title: "Email",
    },
    contact_type: {
      $ref: "#/components/schemas/ContactType",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  required: ["email", "contact_type", "full_name"],
  title: "CreateContactRequest",
  description: "Request body for creating a contact.",
} as const;

export const $CreateContactResponse = {
  properties: {
    contact: {
      $ref: "#/components/schemas/ReportContact",
    },
  },
  type: "object",
  required: ["contact"],
  title: "CreateContactResponse",
} as const;

export const $DataPoint = {
  properties: {
    label: {
      type: "string",
      title: "Label",
    },
    value: {
      type: "number",
      title: "Value",
    },
    color_code: {
      type: "string",
      enum: [
        "green",
        "yellow",
        "red",
        "blue",
        "purple",
        "teal",
        "gray",
        "orange",
        "pink",
        "indigo",
        "cyan",
        "lime",
      ],
      title: "Color Code",
    },
    type: {
      type: "string",
      enum: ["percentage", "monetary", "count"],
      title: "Type",
    },
  },
  type: "object",
  required: ["label", "value", "color_code", "type"],
  title: "DataPoint",
} as const;

export const $DeductibleEntry = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["name", "description"],
  title: "DeductibleEntry",
} as const;

export const $DeductibleSummary = {
  properties: {
    kind: {
      type: "string",
      enum: ["site", "per_unit", "occurrence", "aggregate"],
      title: "Kind",
    },
    value: {
      type: "number",
      title: "Value",
    },
    zone: {
      type: "string",
      title: "Zone",
    },
  },
  type: "object",
  required: ["kind", "value", "zone"],
  title: "DeductibleSummary",
} as const;

export const $DeductibleSummaryRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "address_ids"],
  title: "DeductibleSummaryRequest",
} as const;

export const $DeductibleSummaryResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/DeductibleSummary",
        },
        propertyNames: {
          enum: ["PWH", "PES", "PFL", "PWB", "PWT", "AOP"],
        },
        type: "object",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "DeductibleSummaryResponse",
} as const;

export const $DeleteAdditionalFilesRequest = {
  properties: {
    files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "DeleteAdditionalFilesRequest",
} as const;

export const $DeleteAttachmentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: ["report_id", "filename"],
  title: "DeleteAttachmentRequest",
} as const;

export const $DeleteCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    comment_id: {
      type: "string",
      title: "Comment Id",
    },
    target_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/CommentTargetType",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["report_id", "comment_id", "target_type"],
  title: "DeleteCommentRequest",
} as const;

export const $DeleteCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "DeleteCommentResponse",
} as const;

export const $DeleteEmailThreadRequest = {
  properties: {
    conversation_id: {
      type: "string",
      title: "Conversation Id",
    },
  },
  type: "object",
  required: ["conversation_id"],
  title: "DeleteEmailThreadRequest",
} as const;

export const $DeleteEmailThreadResponse = {
  properties: {
    deleted_files: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Deleted Files",
    },
  },
  type: "object",
  required: ["deleted_files"],
  title: "DeleteEmailThreadResponse",
} as const;

export const $DeleteEndorsementResponse = {
  properties: {
    deleted_documents: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Deleted Documents",
    },
  },
  type: "object",
  required: ["deleted_documents"],
  title: "DeleteEndorsementResponse",
} as const;

export const $DeleteReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "DeleteReportRequest",
} as const;

export const $DeleteReportResponse = {
  properties: {},
  type: "object",
  title: "DeleteReportResponse",
} as const;

export const $DeleteSavedFilterRequest = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
  },
  type: "object",
  required: ["id"],
  title: "DeleteSavedFilterRequest",
} as const;

export const $DeleteTemplate = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
  },
  type: "object",
  required: ["template_id"],
  title: "DeleteTemplate",
} as const;

export const $DownloadAdditionalFileRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    file: {
      type: "string",
      title: "File",
    },
  },
  type: "object",
  required: ["report_id", "file"],
  title: "DownloadAdditionalFileRequest",
} as const;

export const $DownloadLossRunRequest = {
  properties: {
    loss_run_years: {
      items: {
        $ref: "#/components/schemas/UserGeneratedLossRunByYear",
      },
      type: "array",
      title: "Loss Run Years",
    },
  },
  type: "object",
  required: ["loss_run_years"],
  title: "DownloadLossRunRequest",
} as const;

export const $DownloadReportFileRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: ["report_id", "filename"],
  title: "DownloadReportFileRequest",
} as const;

export const $DownloadReportHistoryRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    download_type: {
      type: "string",
      enum: ["account", "simple_location", "complex_location"],
      title: "Download Type",
    },
    export_format: {
      type: "string",
      enum: ["xlsx", "csv"],
      title: "Export Format",
      default: "xlsx",
    },
  },
  type: "object",
  required: ["report_ids", "download_type"],
  title: "DownloadReportHistoryRequest",
} as const;

export const $DownloadTemplateRequest = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
  },
  type: "object",
  required: ["template_id"],
  title: "DownloadTemplateRequest",
} as const;

export const $DownloadThreadAttachmentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    thread_url: {
      type: "string",
      title: "Thread Url",
    },
    message_id: {
      type: "string",
      title: "Message Id",
    },
    attachment_id: {
      type: "string",
      title: "Attachment Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
  },
  type: "object",
  required: [
    "report_id",
    "thread_url",
    "message_id",
    "attachment_id",
    "filename",
  ],
  title: "DownloadThreadAttachmentRequest",
} as const;

export const $DraftResponse = {
  properties: {
    draft_url: {
      type: "string",
      title: "Draft Url",
    },
  },
  type: "object",
  required: ["draft_url"],
  title: "DraftResponse",
} as const;

export const $EPRow = {
  properties: {
    peril: {
      type: "string",
      title: "Peril",
    },
    perspective: {
      type: "string",
      title: "Perspective",
    },
    metric_type: {
      type: "string",
      title: "Metric Type",
    },
    return_period_values: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Return Period Values",
      default: {},
    },
  },
  type: "object",
  required: ["peril", "perspective", "metric_type"],
  title: "EPRow",
} as const;

export const $EditCommentRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    comment_id: {
      type: "string",
      title: "Comment Id",
    },
    message: {
      type: "string",
      title: "Message",
    },
    target_type: {
      anyOf: [
        {
          $ref: "#/components/schemas/CommentTargetType",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["report_id", "comment_id", "message", "target_type"],
  title: "EditCommentRequest",
} as const;

export const $EditCommentResponse = {
  properties: {
    comments: {
      $ref: "#/components/schemas/Comments",
    },
  },
  type: "object",
  required: ["comments"],
  title: "EditCommentResponse",
} as const;

export const $EmailThread = {
  properties: {
    thread_url: {
      type: "string",
      title: "Thread Url",
    },
    messages: {
      items: {
        $ref: "#/components/schemas/EmailThreadMessage",
      },
      type: "array",
      title: "Messages",
    },
  },
  type: "object",
  required: ["thread_url", "messages"],
  title: "EmailThread",
} as const;

export const $EmailThreadAttachment = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    mime_type: {
      type: "string",
      title: "Mime Type",
    },
    size: {
      type: "integer",
      title: "Size",
    },
    attachment_id: {
      type: "string",
      title: "Attachment Id",
    },
    message_id: {
      type: "string",
      title: "Message Id",
    },
  },
  type: "object",
  required: ["filename", "mime_type", "size", "attachment_id", "message_id"],
  title: "EmailThreadAttachment",
} as const;

export const $EmailThreadMessage = {
  properties: {
    from: {
      type: "string",
      title: "From",
      default: "",
    },
    to: {
      type: "string",
      title: "To",
      default: "",
    },
    cc: {
      type: "string",
      title: "Cc",
      default: "",
    },
    subject: {
      type: "string",
      title: "Subject",
      default: "",
    },
    date: {
      type: "string",
      title: "Date",
      default: "",
    },
    body_text: {
      type: "string",
      title: "Body Text",
      default: "",
    },
    body_html: {
      type: "string",
      title: "Body Html",
      default: "",
    },
    attachments: {
      items: {
        $ref: "#/components/schemas/EmailThreadAttachment",
      },
      type: "array",
      title: "Attachments",
      default: [],
    },
  },
  type: "object",
  title: "EmailThreadMessage",
} as const;

export const $EmailThreadsResponse = {
  properties: {
    threads: {
      items: {
        $ref: "#/components/schemas/EmailThread",
      },
      type: "array",
      title: "Threads",
    },
  },
  type: "object",
  required: ["threads"],
  title: "EmailThreadsResponse",
} as const;

export const $EmlPreviewRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "EmlPreviewRequest",
} as const;

export const $EmlPreviewResponse = {
  properties: {
    subject: {
      type: "string",
      title: "Subject",
    },
    eml: {
      type: "string",
      title: "Eml",
    },
  },
  type: "object",
  required: ["subject", "eml"],
  title: "EmlPreviewResponse",
} as const;

export const $EndorsementLedgerTotals = {
  properties: {
    policy_application_id: {
      type: "string",
      title: "Policy Application Id",
    },
    base_premium: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Base Premium",
    },
    owed_premium: {
      type: "integer",
      title: "Owed Premium",
    },
    term_premium: {
      type: "integer",
      title: "Term Premium",
    },
  },
  type: "object",
  required: [
    "policy_application_id",
    "base_premium",
    "owed_premium",
    "term_premium",
  ],
  title: "EndorsementLedgerTotals",
  description: `A policy's premium position: the live base (the resolved layer premium,
i.e. the Layers tab number) plus the sums over verified ledger entries.
\`\`owed_premium\`\` = base + prorated deltas (what is billed for the term);
\`\`term_premium\`\` = base + full-term deltas (the in-force premium for the
whole term and the account-rate numerator). \`\`base_premium\`\` is None when the layer has
neither a resolved premium nor a target — the sums are deltas-only then.`,
} as const;

export const $EndorsementPremiumBasis = {
  type: "string",
  enum: ["account_rate", "no_change", "custom"],
  title: "EndorsementPremiumBasis",
} as const;

export const $EndorsementPremiumChange = {
  properties: {
    term_premium_delta: {
      type: "integer",
      title: "Term Premium Delta",
    },
    prorated_premium_delta: {
      type: "integer",
      title: "Prorated Premium Delta",
    },
    rate_used: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Rate Used",
    },
    proration_factor: {
      type: "number",
      title: "Proration Factor",
    },
    edited: {
      type: "boolean",
      title: "Edited",
    },
  },
  type: "object",
  required: [
    "term_premium_delta",
    "prorated_premium_delta",
    "rate_used",
    "proration_factor",
    "edited",
  ],
  title: "EndorsementPremiumChange",
  description: `One endorsement's premium delta, negative for a return premium.

\`\`term_premium_delta\`\` is the full-term amount (annual only when the policy
term is twelve months) and \`\`prorated_premium_delta\`\` is what is charged
for the remainder of the policy. Both are stored (not derived on read): the ledger must re-read years
later without re-running date math against records that may have changed.
They are linked by \`\`proration_factor\`\` = days from the endorsement's
effective date to the policy expiration / days in the term.`,
} as const;

export const $EndorsementRequest = {
  properties: {
    endorsement_id: {
      type: "string",
      format: "uuid",
      title: "Endorsement Id",
    },
  },
  type: "object",
  required: ["endorsement_id"],
  title: "EndorsementRequest",
} as const;

export const $EndorsementSovDiffResponse = {
  properties: {
    added: {
      items: {
        $ref: "#/components/schemas/SovDiffLocation",
      },
      type: "array",
      title: "Added",
    },
    removed: {
      items: {
        $ref: "#/components/schemas/SovDiffLocation",
      },
      type: "array",
      title: "Removed",
    },
    revalued: {
      items: {
        $ref: "#/components/schemas/SovDiffRevaluedLocation",
      },
      type: "array",
      title: "Revalued",
    },
    unchanged_count: {
      type: "integer",
      title: "Unchanged Count",
    },
    baseline_description: {
      type: "string",
      title: "Baseline Description",
    },
  },
  type: "object",
  required: [
    "added",
    "removed",
    "revalued",
    "unchanged_count",
    "baseline_description",
  ],
  title: "EndorsementSovDiffResponse",
} as const;

export const $EndorsementStatus = {
  type: "string",
  enum: ["draft", "generating", "needs_review", "verified", "voided"],
  title: "EndorsementStatus",
} as const;

export const $EndorsementView = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    policy_application_id: {
      type: "string",
      title: "Policy Application Id",
    },
    endorsement_number: {
      type: "integer",
      title: "Endorsement Number",
    },
    status: {
      $ref: "#/components/schemas/EndorsementStatus",
    },
    effective_date: {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    description: {
      type: "string",
      title: "Description",
    },
    tiv_target: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Target",
    },
    premium_basis: {
      $ref: "#/components/schemas/EndorsementPremiumBasis",
    },
    premium_change: {
      anyOf: [
        {
          $ref: "#/components/schemas/EndorsementPremiumChange",
        },
        {
          type: "null",
        },
      ],
    },
    tiv_before: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Before",
    },
    tiv_achieved: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Achieved",
    },
    generation_job_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Generation Job Id",
    },
    generation_summary: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Generation Summary",
    },
    generation_error: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Generation Error",
    },
    document_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Document Ids",
    },
    has_generated_sov: {
      type: "boolean",
      title: "Has Generated Sov",
    },
    created_by: {
      type: "string",
      title: "Created By",
    },
    verified_by: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Verified By",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
  },
  type: "object",
  required: [
    "id",
    "report_id",
    "policy_application_id",
    "endorsement_number",
    "status",
    "effective_date",
    "description",
    "tiv_target",
    "premium_basis",
    "premium_change",
    "tiv_before",
    "tiv_achieved",
    "generation_job_id",
    "generation_summary",
    "generation_error",
    "document_ids",
    "has_generated_sov",
    "created_by",
    "verified_by",
    "created_at_ts",
    "modified_at_ts",
  ],
  title: "EndorsementView",
  description: `API shape for one ledger entry. \`\`new_sov\`\` stays server-side (it can be
large); the view carries whether a generated schedule exists.`,
} as const;

export const $EqbdAccountResult = {
  properties: {
    pd_total: {
      type: "number",
      title: "Pd Total",
    },
    bi_total: {
      type: "number",
      title: "Bi Total",
    },
    pd_options_total: {
      type: "number",
      title: "Pd Options Total",
    },
    bi_options_total: {
      type: "number",
      title: "Bi Options Total",
    },
    utility_total: {
      type: "number",
      title: "Utility Total",
    },
    other_options_total: {
      type: "number",
      title: "Other Options Total",
    },
    structural_total: {
      type: "number",
      title: "Structural Total",
    },
    locations_subtotal: {
      type: "number",
      title: "Locations Subtotal",
    },
    non_owned_premium: {
      type: "number",
      title: "Non Owned Premium",
    },
    grand_total: {
      type: "number",
      title: "Grand Total",
    },
    min_premium_applied: {
      type: "boolean",
      title: "Min Premium Applied",
    },
    refer_count: {
      type: "integer",
      title: "Refer Count",
    },
    warning_counts: {
      additionalProperties: {
        type: "integer",
      },
      type: "object",
      title: "Warning Counts",
    },
    by_layer: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "By Layer",
    },
  },
  type: "object",
  required: [
    "pd_total",
    "bi_total",
    "pd_options_total",
    "bi_options_total",
    "utility_total",
    "other_options_total",
    "structural_total",
    "locations_subtotal",
    "non_owned_premium",
    "grand_total",
    "min_premium_applied",
    "refer_count",
  ],
  title: "EqbdAccountResult",
} as const;

export const $EqbdBiComponents = {
  properties: {
    base_rate: {
      type: "number",
      title: "Base Rate",
    },
    coverage_mod: {
      type: "number",
      title: "Coverage Mod",
    },
    limit_factor: {
      type: "number",
      title: "Limit Factor",
    },
    deductible_factor: {
      type: "number",
      title: "Deductible Factor",
    },
    exposure_factor: {
      type: "number",
      title: "Exposure Factor",
    },
    risk_factor: {
      type: "number",
      title: "Risk Factor",
    },
    coinsurance_factor: {
      type: "number",
      title: "Coinsurance Factor",
    },
    location_discount: {
      type: "number",
      title: "Location Discount",
    },
    final_rate: {
      type: "number",
      title: "Final Rate",
    },
    annual_value: {
      type: "number",
      title: "Annual Value",
    },
    credit_factor: {
      type: "number",
      title: "Credit Factor",
    },
    state_multiplier: {
      type: "number",
      title: "State Multiplier",
    },
    uw_modifier: {
      type: "number",
      title: "Uw Modifier",
    },
  },
  type: "object",
  required: [
    "base_rate",
    "coverage_mod",
    "limit_factor",
    "deductible_factor",
    "exposure_factor",
    "risk_factor",
    "coinsurance_factor",
    "location_discount",
    "final_rate",
    "annual_value",
    "credit_factor",
    "state_multiplier",
    "uw_modifier",
  ],
  title: "EqbdBiComponents",
} as const;

export const $EqbdLocationResult = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    premises_number: {
      type: "string",
      title: "Premises Number",
    },
    building_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Name",
    },
    state: {
      type: "string",
      title: "State",
    },
    sic_code: {
      type: "string",
      title: "Sic Code",
    },
    occupancy_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Code",
    },
    pd_premium: {
      type: "number",
      title: "Pd Premium",
    },
    bi_premium: {
      type: "number",
      title: "Bi Premium",
    },
    pd_options_premium: {
      type: "number",
      title: "Pd Options Premium",
    },
    bi_options_premium: {
      type: "number",
      title: "Bi Options Premium",
    },
    utility_premium: {
      type: "number",
      title: "Utility Premium",
    },
    other_options_premium: {
      type: "number",
      title: "Other Options Premium",
    },
    structural_premium: {
      type: "number",
      title: "Structural Premium",
    },
    total_premium: {
      type: "number",
      title: "Total Premium",
    },
    pd_components: {
      anyOf: [
        {
          $ref: "#/components/schemas/EqbdPdComponents",
        },
        {
          type: "null",
        },
      ],
    },
    bi_components: {
      anyOf: [
        {
          $ref: "#/components/schemas/EqbdBiComponents",
        },
        {
          type: "null",
        },
      ],
    },
    refer: {
      type: "boolean",
      title: "Refer",
    },
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
  },
  type: "object",
  required: [
    "address_id",
    "premises_number",
    "building_name",
    "state",
    "sic_code",
    "occupancy_code",
    "pd_premium",
    "bi_premium",
    "pd_options_premium",
    "bi_options_premium",
    "utility_premium",
    "other_options_premium",
    "structural_premium",
    "total_premium",
    "pd_components",
    "bi_components",
    "refer",
  ],
  title: "EqbdLocationResult",
} as const;

export const $EqbdPdComponents = {
  properties: {
    base_rate: {
      type: "number",
      title: "Base Rate",
    },
    coverage_mod: {
      type: "number",
      title: "Coverage Mod",
    },
    limit_factor: {
      type: "number",
      title: "Limit Factor",
    },
    deductible_factor: {
      type: "number",
      title: "Deductible Factor",
    },
    risk_factor: {
      type: "number",
      title: "Risk Factor",
    },
    location_discount: {
      type: "number",
      title: "Location Discount",
    },
    acv_adjustment: {
      type: "number",
      title: "Acv Adjustment",
    },
    final_rate: {
      type: "number",
      title: "Final Rate",
    },
    exposure: {
      type: "number",
      title: "Exposure",
    },
    credit_factor: {
      type: "number",
      title: "Credit Factor",
    },
    state_multiplier: {
      type: "number",
      title: "State Multiplier",
    },
    uw_modifier: {
      type: "number",
      title: "Uw Modifier",
    },
  },
  type: "object",
  required: [
    "base_rate",
    "coverage_mod",
    "limit_factor",
    "deductible_factor",
    "risk_factor",
    "location_discount",
    "acv_adjustment",
    "final_rate",
    "exposure",
    "credit_factor",
    "state_multiplier",
    "uw_modifier",
  ],
  title: "EqbdPdComponents",
  description:
    "Property-damage rate breakdown (each is a multiplier unless noted).",
} as const;

export const $EqbdRaterResultsResponse = {
  properties: {
    locations: {
      items: {
        $ref: "#/components/schemas/EqbdLocationResult",
      },
      type: "array",
      title: "Locations",
    },
    account: {
      anyOf: [
        {
          $ref: "#/components/schemas/EqbdAccountResult",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["locations", "account"],
  title: "EqbdRaterResultsResponse",
} as const;

export const $EqbdRaterRunSpec = {
  properties: {
    type: {
      type: "string",
      const: "eqbd_rater",
      title: "Type",
    },
    enrichment_source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Enrichment Source",
    },
  },
  type: "object",
  required: ["type", "enrichment_source"],
  title: "EqbdRaterRunSpec",
} as const;

export const $EstimateEndorsementPremiumRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    policy_application_id: {
      type: "string",
      format: "uuid",
      title: "Policy Application Id",
    },
    effective_date: {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    tiv_target: {
      type: "number",
      title: "Tiv Target",
    },
  },
  type: "object",
  required: [
    "report_id",
    "policy_application_id",
    "effective_date",
    "tiv_target",
  ],
  title: "EstimateEndorsementPremiumRequest",
} as const;

export const $ExcerptSortUpdate = {
  properties: {
    group: {
      type: "string",
      enum: ["manual", "extracted"],
      title: "Group",
    },
    filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Filename",
    },
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    excerpt_keys: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Excerpt Keys",
    },
  },
  type: "object",
  required: ["group", "filename", "peril_type", "excerpt_keys"],
  title: "ExcerptSortUpdate",
  description: `A reorder of the excerpt rows within one peril group of a limit/deductible.

The target \`\`AdvancedLimit\`\`/\`\`AdvancedDeductible\`\` is identified by
(\`\`group\`\`, \`\`filename\`\`, \`\`peril_type\`\`): \`\`group="manual"\`\` targets the
manual entry (\`\`filename\`\` must be None); \`\`group="extracted"\`\` targets a
source file's entry. \`\`excerpt_keys\`\` maps excerpt name -> new fractional
key, carrying only the rows whose key changed (one for a single move, or the
whole group when seeding). Keys for excerpts not listed are left untouched.`,
} as const;

export const $ExposureData = {
  properties: {
    fema_flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Flood Zone",
    },
    wind_pool_score: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Pool Score",
    },
  },
  type: "object",
  title: "ExposureData",
  description:
    "Exposure (E) from COPE — external hazard exposure beyond peril scores.",
} as const;

export const $ExposureMapLocation = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    lat: {
      type: "number",
      title: "Lat",
    },
    lon: {
      type: "number",
      title: "Lon",
    },
    tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    named_insured: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Named Insured",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    state: {
      type: "string",
      title: "State",
    },
  },
  type: "object",
  required: [
    "address_id",
    "lat",
    "lon",
    "tiv",
    "status",
    "report_id",
    "named_insured",
    "city",
    "county",
    "state",
  ],
  title: "ExposureMapLocation",
} as const;

export const $ExposureMapLocations = {
  properties: {
    locations: {
      items: {
        $ref: "#/components/schemas/ExposureMapLocation",
      },
      type: "array",
      title: "Locations",
    },
    total_matching: {
      type: "integer",
      title: "Total Matching",
    },
    truncated: {
      type: "boolean",
      title: "Truncated",
    },
  },
  type: "object",
  required: ["locations", "total_matching", "truncated"],
  title: "ExposureMapLocations",
} as const;

export const $ExposureMapRequest = {
  properties: {
    lob: {
      type: "string",
      title: "Lob",
    },
    statuses: {
      anyOf: [
        {
          items: {
            type: "string",
            enum: [
              "pre_underwriting_review",
              "blocked",
              "not_cleared_prior_submission",
              "not_cleared_incomplete_submission",
              "not_cleared_out_of_appetite",
              "not_cleared_effective_date_too_far",
              "not_cleared_unapproved_broker",
              "not_cleared_low_tiv",
              "not_cleared_foreign_exposure",
              "cleared",
              "pending",
              "modeling_complete",
              "referral_sent",
              "flagged_for_review",
              "indicated",
              "quoted",
              "declined",
              "closed",
              "closed_bor",
              "not_reviewed",
              "lost",
              "quoted_not_taken_up",
              "bound",
              "issued",
            ],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Statuses",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Southeast Florida",
            "Southwest Florida",
            "Central Florida",
            "Northeast Florida",
            "Panhandle Florida",
            "Georgia / South Carolina",
            "North Carolina",
            "Texas incl. Harris County",
            "Louisiana",
            "Mississippi",
            "Alabama",
            "Mid-Atlantic (VA/MD/DE)",
            "Northeast (NY/NJ/CT/RI/MA/NH/ME)",
          ],
        },
        {
          type: "string",
          enum: [
            "CA High Hazard",
            "Pacific NW",
            "Intermountain West",
            "New Madrid",
            "Northeast",
            "Alabama EQ",
            "Alaska EQ",
            "District of Columbia EQ",
            "Florida EQ",
            "Georgia EQ",
            "Guam EQ",
            "Hawaii EQ",
            "Iowa EQ",
            "Kansas EQ",
            "Louisiana EQ",
            "Michigan EQ",
            "Minnesota EQ",
            "Mississippi EQ",
            "Nebraska EQ",
            "New Hampshire EQ",
            "North Carolina EQ",
            "North Dakota EQ",
            "Ohio EQ",
            "Oklahoma EQ",
            "Puerto Rico EQ",
            "South Carolina EQ",
            "South Dakota EQ",
            "Texas EQ",
            "US Virgin Islands EQ",
            "Wisconsin EQ",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Gate",
    },
  },
  type: "object",
  required: ["lob", "statuses", "state", "county", "gate"],
  title: "ExposureMapRequest",
} as const;

export const $ExposureMapSummary = {
  properties: {
    total_locations: {
      type: "integer",
      title: "Total Locations",
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    policy_count: {
      type: "integer",
      title: "Policy Count",
    },
    by_state: {
      items: {
        $ref: "#/components/schemas/PlaceExposure",
      },
      type: "array",
      title: "By State",
    },
    by_county: {
      items: {
        $ref: "#/components/schemas/PlaceExposure",
      },
      type: "array",
      title: "By County",
    },
    by_gate: {
      items: {
        $ref: "#/components/schemas/GateRollup",
      },
      type: "array",
      title: "By Gate",
    },
    top_policies: {
      items: {
        $ref: "#/components/schemas/PolicyExposure",
      },
      type: "array",
      title: "Top Policies",
    },
    status_breakdown: {
      items: {
        $ref: "#/components/schemas/StatusExposure",
      },
      type: "array",
      title: "Status Breakdown",
    },
    locations_without_coordinates: {
      type: "integer",
      title: "Locations Without Coordinates",
    },
    last_refreshed_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Refreshed At",
    },
    reachable_line: {
      type: "number",
      title: "Reachable Line",
    },
    blocked_line: {
      type: "number",
      title: "Blocked Line",
    },
    policies_without_layers: {
      type: "integer",
      title: "Policies Without Layers",
    },
  },
  type: "object",
  required: [
    "total_locations",
    "total_tiv",
    "policy_count",
    "by_state",
    "by_county",
    "by_gate",
    "top_policies",
    "status_breakdown",
    "locations_without_coordinates",
    "last_refreshed_at",
    "reachable_line",
    "blocked_line",
    "policies_without_layers",
  ],
  title: "ExposureMapSummary",
} as const;

export const $ExtractStagedAttachmentsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    selections: {
      items: {
        $ref: "#/components/schemas/StagedAttachmentSelection",
      },
      type: "array",
      title: "Selections",
    },
  },
  type: "object",
  required: ["report_id", "selections"],
  title: "ExtractStagedAttachmentsRequest",
} as const;

export const $ExtractStagedAttachmentsResponse = {
  properties: {
    added: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Added",
    },
    rerun_enqueued: {
      type: "boolean",
      title: "Rerun Enqueued",
    },
  },
  type: "object",
  required: ["added", "rerun_enqueued"],
  title: "ExtractStagedAttachmentsResponse",
} as const;

export const $FieldSource = {
  type: "string",
  enum: ["inherited", "overridden", "added", "removed"],
  title: "FieldSource",
} as const;

export const $FinancialModelAudit = {
  properties: {
    schema_version: {
      type: "integer",
      title: "Schema Version",
    },
    perils: {
      items: {
        $ref: "#/components/schemas/FinancialModelAuditPeril",
      },
      type: "array",
      title: "Perils",
    },
  },
  type: "object",
  required: ["schema_version", "perils"],
  title: "FinancialModelAudit",
} as const;

export const $FinancialModelAuditGroup = {
  properties: {
    limit_zone: {
      type: "string",
      title: "Limit Zone",
    },
    ground_up_aal: {
      type: "number",
      title: "Ground Up Aal",
    },
    deductible_savings_aal: {
      type: "number",
      title: "Deductible Savings Aal",
    },
    aggregate_deductible_savings_aal: {
      type: "number",
      title: "Aggregate Deductible Savings Aal",
    },
    retained_below_attachment_aal: {
      type: "number",
      title: "Retained Below Attachment Aal",
    },
    limit_savings_aal: {
      type: "number",
      title: "Limit Savings Aal",
    },
    aggregate_limit_savings_aal: {
      type: "number",
      title: "Aggregate Limit Savings Aal",
    },
    gross_aal: {
      type: "number",
      title: "Gross Aal",
    },
  },
  type: "object",
  required: [
    "limit_zone",
    "ground_up_aal",
    "deductible_savings_aal",
    "aggregate_deductible_savings_aal",
    "retained_below_attachment_aal",
    "limit_savings_aal",
    "aggregate_limit_savings_aal",
    "gross_aal",
  ],
  title: "FinancialModelAuditGroup",
  description: `Averaged loss waterfall for one limit zone within a peril+layer.

Holds exactly (in AAL terms):
    ground_up_aal == deductible_savings_aal
                     + aggregate_deductible_savings_aal
                     + retained_below_attachment_aal
                     + limit_savings_aal
                     + aggregate_limit_savings_aal
                     + gross_aal`,
} as const;

export const $FinancialModelAuditLayer = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    groups: {
      items: {
        $ref: "#/components/schemas/FinancialModelAuditGroup",
      },
      type: "array",
      title: "Groups",
    },
  },
  type: "object",
  required: ["layer_id", "groups"],
  title: "FinancialModelAuditLayer",
} as const;

export const $FinancialModelAuditPeril = {
  properties: {
    peril: {
      type: "string",
      enum: [
        "PWH",
        "PSH",
        "PWH_PSH",
        "PES",
        "PFL",
        "PFL_PSH",
        "PWB",
        "PWW",
        "PWT",
      ],
      title: "Peril",
    },
    total_periods: {
      type: "integer",
      title: "Total Periods",
    },
    deductible_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible Description",
    },
    deductible_function_str: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible Function Str",
    },
    limit_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Limit Description",
    },
    limit_function_str: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Limit Function Str",
    },
    layers: {
      items: {
        $ref: "#/components/schemas/FinancialModelAuditLayer",
      },
      type: "array",
      title: "Layers",
    },
  },
  type: "object",
  required: [
    "peril",
    "total_periods",
    "deductible_description",
    "deductible_function_str",
    "limit_description",
    "limit_function_str",
    "layers",
  ],
  title: "FinancialModelAuditPeril",
  description: `One peril's audit. \`\`ground_up_aal\`\` / \`\`deductible_savings_aal\`\` are
layer-invariant (computed before any layer clipping) so they repeat across
this peril's layers; only the limit/gross figures differ per layer.

The deductible/limit function strings are the resolved functions actually
used for this peril, captured so a reader can tie the numbers back to the
terms that produced them.`,
} as const;

export const $FinancialModelAuditRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    source: {
      type: "string",
      enum: ["air", "rms", "spatialkat", "rms_22", "rms_22_air_50_50"],
      title: "Source",
    },
    batch_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["report_id", "source", "batch_id"],
  title: "FinancialModelAuditRequest",
} as const;

export const $FixSovRunSummary = {
  properties: {
    completed: {
      type: "boolean",
      title: "Completed",
    },
    end_reason: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "End Reason",
    },
    reupload_invoked: {
      type: "boolean",
      title: "Reupload Invoked",
    },
    reupload_succeeded: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Reupload Succeeded",
    },
    summary: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Summary",
    },
    tool_errors: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Tool Errors",
    },
    cost_usd: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Cost Usd",
    },
    num_turns: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Num Turns",
    },
    artifact_path: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Artifact Path",
    },
    error: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error",
    },
    finished_at: {
      type: "string",
      format: "date-time",
      title: "Finished At",
    },
  },
  type: "object",
  required: [
    "completed",
    "end_reason",
    "reupload_invoked",
    "summary",
    "tool_errors",
    "cost_usd",
    "num_turns",
    "artifact_path",
    "error",
    "finished_at",
  ],
  title: "FixSovRunSummary",
  description: "Outcome of one ``fix_sov`` sandbox run.",
} as const;

export const $FormGroup = {
  type: "string",
  enum: ["mandatory", "on_by_default", "off_by_default", "tria"],
  title: "FormGroup",
  description: "Display grouping for a resolved policy form.",
} as const;

export const $FormPairView = {
  properties: {
    default_form_id: {
      type: "string",
      title: "Default Form Id",
    },
    alternate_form_id: {
      type: "string",
      title: "Alternate Form Id",
    },
    topic: {
      type: "string",
      title: "Topic",
    },
    applicable_sublimits: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Applicable Sublimits",
    },
  },
  type: "object",
  required: [
    "default_form_id",
    "alternate_form_id",
    "topic",
    "applicable_sublimits",
  ],
  title: "FormPairView",
  description:
    "A default exclusion and its alternate, both present in ``forms``.",
} as const;

export const $FormSelection = {
  properties: {
    form_id: {
      type: "string",
      title: "Form Id",
    },
    form_number: {
      type: "string",
      title: "Form Number",
    },
    form_name: {
      type: "string",
      title: "Form Name",
    },
    group: {
      $ref: "#/components/schemas/FormGroup",
    },
    locked: {
      type: "boolean",
      title: "Locked",
    },
    note: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Note",
    },
    default_enabled: {
      type: "boolean",
      title: "Default Enabled",
    },
    enabled: {
      type: "boolean",
      title: "Enabled",
    },
  },
  type: "object",
  required: [
    "form_id",
    "form_number",
    "form_name",
    "group",
    "locked",
    "note",
    "default_enabled",
    "enabled",
  ],
  title: "FormSelection",
  description: `A single form within an application's materialized selections.

\`\`form_id\`\` is a forms_catalog.FormId value, stored as a string so a snapshot
survives catalog edits. form_number/form_name/group/note/default_enabled are
snapshotted from the catalog at generation and never re-derived. \`\`enabled\`\`
is the current state; it differs from \`\`default_enabled\`\` exactly when an
underwriter has changed this form. Locked forms keep
\`\`enabled == default_enabled\`\`.`,
} as const;

export const $FormattedText = {
  properties: {
    text: {
      type: "string",
      title: "Text",
    },
  },
  type: "object",
  required: ["text"],
  title: "FormattedText",
} as const;

export const $FreshnessRequest = {
  properties: {
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    client_modified_at_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Client Modified At Ts",
    },
    client_comments_modified_at_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Client Comments Modified At Ts",
    },
  },
  type: "object",
  required: [
    "report_id",
    "client_modified_at_ts",
    "client_comments_modified_at_ts",
  ],
  title: "FreshnessRequest",
} as const;

export const $FreshnessResponse = {
  properties: {
    needs_refresh: {
      type: "boolean",
      title: "Needs Refresh",
    },
    comments_need_refresh: {
      type: "boolean",
      title: "Comments Need Refresh",
    },
    modified_at_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Modified At Ts",
    },
    comments_modified_at_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Comments Modified At Ts",
    },
  },
  type: "object",
  required: [
    "needs_refresh",
    "comments_need_refresh",
    "modified_at_ts",
    "comments_modified_at_ts",
  ],
  title: "FreshnessResponse",
} as const;

export const $GateBreakpoint = {
  properties: {
    percent: {
      type: "number",
      title: "Percent",
    },
    label: {
      type: "string",
      title: "Label",
    },
    color: {
      type: "string",
      title: "Color",
    },
  },
  type: "object",
  required: ["percent", "label", "color"],
  title: "GateBreakpoint",
} as const;

export const $GateExposure = {
  properties: {
    gate: {
      type: "string",
      title: "Gate",
    },
    peril_family: {
      type: "string",
      enum: ["wind", "eq"],
      title: "Peril Family",
    },
    gate_tiv: {
      type: "number",
      title: "Gate Tiv",
    },
    gate_cap: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Gate Cap",
    },
    gross_exposure: {
      type: "number",
      title: "Gross Exposure",
    },
    net_exposure: {
      type: "number",
      title: "Net Exposure",
    },
    location_count: {
      type: "integer",
      title: "Location Count",
    },
    reasoning: {
      type: "string",
      title: "Reasoning",
    },
  },
  type: "object",
  required: [
    "gate",
    "peril_family",
    "gate_tiv",
    "gate_cap",
    "gross_exposure",
    "net_exposure",
    "location_count",
    "reasoning",
  ],
  title: "GateExposure",
} as const;

export const $GateExposureRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
  },
  type: "object",
  required: ["report_id", "layer_id"],
  title: "GateExposureRequest",
} as const;

export const $GateExposureResponse = {
  properties: {
    layer: {
      $ref: "#/components/schemas/LayerGateExposureResult",
    },
  },
  type: "object",
  required: ["layer"],
  title: "GateExposureResponse",
} as const;

export const $GateRollup = {
  properties: {
    gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Southeast Florida",
            "Southwest Florida",
            "Central Florida",
            "Northeast Florida",
            "Panhandle Florida",
            "Georgia / South Carolina",
            "North Carolina",
            "Texas incl. Harris County",
            "Louisiana",
            "Mississippi",
            "Alabama",
            "Mid-Atlantic (VA/MD/DE)",
            "Northeast (NY/NJ/CT/RI/MA/NH/ME)",
          ],
        },
        {
          type: "string",
          enum: [
            "CA High Hazard",
            "Pacific NW",
            "Intermountain West",
            "New Madrid",
            "Northeast",
            "Alabama EQ",
            "Alaska EQ",
            "District of Columbia EQ",
            "Florida EQ",
            "Georgia EQ",
            "Guam EQ",
            "Hawaii EQ",
            "Iowa EQ",
            "Kansas EQ",
            "Louisiana EQ",
            "Michigan EQ",
            "Minnesota EQ",
            "Mississippi EQ",
            "Nebraska EQ",
            "New Hampshire EQ",
            "North Carolina EQ",
            "North Dakota EQ",
            "Ohio EQ",
            "Oklahoma EQ",
            "Puerto Rico EQ",
            "South Carolina EQ",
            "South Dakota EQ",
            "Texas EQ",
            "US Virgin Islands EQ",
            "Wisconsin EQ",
          ],
        },
      ],
      title: "Gate",
    },
    peril_family: {
      type: "string",
      enum: ["wind", "eq"],
      title: "Peril Family",
    },
    locations: {
      type: "integer",
      title: "Locations",
    },
    policies: {
      type: "integer",
      title: "Policies",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    reachable_line: {
      type: "number",
      title: "Reachable Line",
    },
    blocked_line: {
      type: "number",
      title: "Blocked Line",
    },
    policies_without_layers: {
      type: "integer",
      title: "Policies Without Layers",
    },
  },
  type: "object",
  required: [
    "gate",
    "peril_family",
    "locations",
    "policies",
    "tiv",
    "reachable_line",
    "blocked_line",
    "policies_without_layers",
  ],
  title: "GateRollup",
  description: `What sits in one catastrophe accumulation gate.

Not \`\`cat.gate_exposure.GateExposure\`\`, which answers a harder question for
one layer: capped by per-occurrence limits, grossed up, netted down.`,
} as const;

export const $GateTrackingBar = {
  properties: {
    gate: {
      type: "string",
      title: "Gate",
    },
    peril_family: {
      type: "string",
      enum: ["wind", "eq"],
      title: "Peril Family",
    },
    is_per_state: {
      type: "boolean",
      title: "Is Per State",
    },
    tracking_base: {
      type: "number",
      title: "Tracking Base",
    },
    bound_contribution: {
      type: "number",
      title: "Bound Contribution",
    },
    quoted_contribution: {
      type: "number",
      title: "Quoted Contribution",
    },
    current_layer_contribution: {
      type: "number",
      title: "Current Layer Contribution",
    },
    current_layer_reasoning: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Current Layer Reasoning",
    },
  },
  type: "object",
  required: [
    "gate",
    "peril_family",
    "is_per_state",
    "tracking_base",
    "bound_contribution",
    "quoted_contribution",
    "current_layer_contribution",
    "current_layer_reasoning",
  ],
  title: "GateTrackingBar",
} as const;

export const $GateTrackingBaseRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
  },
  type: "object",
  required: ["report_id", "layer_id"],
  title: "GateTrackingBaseRequest",
} as const;

export const $GateTrackingBaseResponse = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    wind_shown: {
      type: "boolean",
      title: "Wind Shown",
    },
    eq_shown: {
      type: "boolean",
      title: "Eq Shown",
    },
    breakpoints: {
      items: {
        $ref: "#/components/schemas/GateBreakpoint",
      },
      type: "array",
      title: "Breakpoints",
    },
    bars: {
      items: {
        $ref: "#/components/schemas/GateTrackingBar",
      },
      type: "array",
      title: "Bars",
    },
  },
  type: "object",
  required: ["layer_id", "wind_shown", "eq_shown", "breakpoints", "bars"],
  title: "GateTrackingBaseResponse",
} as const;

export const $GeneratePolicyFlyApplicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    perils_by_layer: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Perils By Layer",
    },
    additional_layer_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Layer Id",
    },
  },
  type: "object",
  required: ["report_id", "perils_by_layer", "additional_layer_id"],
  title: "GeneratePolicyFlyApplicationRequest",
} as const;

export const $GeneratePolicyFlyApplicationResponse = {
  properties: {
    task_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Task Ids",
    },
  },
  type: "object",
  required: ["task_ids"],
  title: "GeneratePolicyFlyApplicationResponse",
} as const;

export const $GeneratePolicyNumbersRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "GeneratePolicyNumbersRequest",
} as const;

export const $GenerateQuoteIndicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    perils_insured: {
      type: "string",
      title: "Perils Insured",
    },
    premium_range: {
      type: "string",
      title: "Premium Range",
    },
  },
  type: "object",
  required: ["report_id", "layer_id", "perils_insured", "premium_range"],
  title: "GenerateQuoteIndicationRequest",
} as const;

export const $GenerateReferralDraftRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    html_content: {
      type: "string",
      title: "Html Content",
    },
  },
  type: "object",
  required: ["report_id", "html_content"],
  title: "GenerateReferralDraftRequest",
  description: `\`html_content\` is the referral tab's editor HTML, sent as-is so the
draft matches any manual edits the underwriter has made.`,
} as const;

export const $GenerateUnderwritingPdfRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    html_content: {
      type: "string",
      title: "Html Content",
    },
  },
  type: "object",
  required: ["report_id", "html_content"],
  title: "GenerateUnderwritingPdfRequest",
} as const;

export const $GeneratedPolicyNumbers = {
  properties: {
    numbers: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Numbers",
    },
  },
  type: "object",
  required: ["numbers"],
  title: "GeneratedPolicyNumbers",
} as const;

export const $GeographicEnrichmentData = {
  properties: {
    flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Zone",
    },
    earthquake_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Earthquake Zone",
    },
  },
  type: "object",
  title: "GeographicEnrichmentData",
} as const;

export const $GetBorLetterRequest = {
  properties: {
    bor_id: {
      type: "string",
      title: "Bor Id",
    },
  },
  type: "object",
  required: ["bor_id"],
  title: "GetBorLetterRequest",
} as const;

export const $GetBorLettersByReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "GetBorLettersByReportRequest",
} as const;

export const $GetBrokerAnalyticsResponse = {
  properties: {
    chart_groups: {
      items: {
        $ref: "#/components/schemas/ChartGroup",
      },
      type: "array",
      title: "Chart Groups",
    },
  },
  type: "object",
  required: ["chart_groups"],
  title: "GetBrokerAnalyticsResponse",
} as const;

export const $GetReportActionLogRequest = {
  properties: {
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
  },
  type: "object",
  title: "GetReportActionLogRequest",
} as const;

export const $GetReportActionLogResponse = {
  properties: {
    company_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Name",
    },
    email_subject: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Subject",
    },
    actions: {
      items: {
        $ref: "#/components/schemas/ReportActionLogEntryResponse",
      },
      type: "array",
      title: "Actions",
    },
  },
  type: "object",
  required: ["actions"],
  title: "GetReportActionLogResponse",
} as const;

export const $GoogleGroupStats = {
  properties: {
    google_group_email: {
      type: "string",
      title: "Google Group Email",
    },
    ytd_year: {
      type: "integer",
      title: "Ytd Year",
    },
    submitted_count: {
      type: "integer",
      title: "Submitted Count",
    },
    quoted_count: {
      type: "integer",
      title: "Quoted Count",
    },
    bound_count: {
      type: "integer",
      title: "Bound Count",
    },
    not_cleared_count: {
      type: "integer",
      title: "Not Cleared Count",
    },
    avg_tiv: {
      type: "number",
      title: "Avg Tiv",
    },
    quoted_premium_ytd: {
      type: "integer",
      title: "Quoted Premium Ytd",
    },
    bound_premium_ytd: {
      type: "integer",
      title: "Bound Premium Ytd",
    },
    avg_bound_commission_ytd: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Avg Bound Commission Ytd",
    },
  },
  type: "object",
  required: [
    "google_group_email",
    "ytd_year",
    "submitted_count",
    "quoted_count",
    "bound_count",
    "not_cleared_count",
    "avg_tiv",
    "quoted_premium_ytd",
    "bound_premium_ytd",
    "avg_bound_commission_ytd",
  ],
  title: "GoogleGroupStats",
} as const;

export const $GoogleGroupStatsRequest = {
  properties: {
    google_group_email: {
      type: "string",
      title: "Google Group Email",
    },
  },
  type: "object",
  required: ["google_group_email"],
  title: "GoogleGroupStatsRequest",
} as const;

export const $HTTPValidationError = {
  properties: {
    detail: {
      items: {
        $ref: "#/components/schemas/ValidationError",
      },
      type: "array",
      title: "Detail",
    },
  },
  type: "object",
  title: "HTTPValidationError",
} as const;

export const $HazardHubData = {
  properties: {
    year_built: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Built",
    },
    number_of_stories: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Stories",
    },
    number_of_buildings: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Buildings",
    },
    building_condition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Condition",
    },
    basement: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Basement",
    },
    square_footage: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Square Footage",
    },
    replacement_cost: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Replacement Cost",
    },
    construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Quality",
    },
    construction_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Type",
    },
    primary_exterior: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Primary Exterior",
    },
    primary_roof_covering: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Primary Roof Covering",
    },
    roof_configuration: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Configuration",
    },
    distance_to_coast_km: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Distance To Coast Km",
    },
    assessment: {
      $ref: "#/components/schemas/AssessmentData",
    },
    occupancy: {
      $ref: "#/components/schemas/OccupancyData",
    },
    protection: {
      $ref: "#/components/schemas/ProtectionData",
    },
    exposure: {
      $ref: "#/components/schemas/ExposureData",
    },
    peril_scores: {
      $ref: "#/components/schemas/PerilScores",
    },
    derived_modifiers: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Derived Modifiers",
      default: {},
    },
  },
  type: "object",
  title: "HazardHubData",
  description:
    "Normalized subset of HazardHub response fields mapped to address fields.",
} as const;

export const $IcmJobProgress = {
  properties: {
    submitted: {
      type: "boolean",
      title: "Submitted",
    },
    request_status: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Request Status",
    },
    stage: {
      anyOf: [
        {
          $ref: "#/components/schemas/IcmStage",
        },
        {
          type: "null",
        },
      ],
    },
    location_count: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Location Count",
    },
  },
  type: "object",
  required: ["submitted", "request_status", "stage", "location_count"],
  title: "IcmJobProgress",
} as const;

export const $IcmStage = {
  type: "string",
  enum: ["submitted", "cat_modeling", "scoring", "complete"],
  title: "IcmStage",
  description: `Coarse ICM-side progress for a rating request, derived from which
pipeline timestamps the status response has populated.`,
} as const;

export const $IntegrationDataRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    types: {
      items: {
        type: "string",
        enum: [
          "rms",
          "air",
          "spatialkat",
          "geographic_enrichment",
          "hazard_hub",
          "nearmap",
          "nearmap_ai",
          "cape",
          "sindri",
        ],
      },
      type: "array",
      title: "Types",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "types", "address_ids"],
  title: "IntegrationDataRequest",
} as const;

export const $IntegrationDataResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        $ref: "#/components/schemas/AddressIntegrationData",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "IntegrationDataResponse",
} as const;

export const $IntegrationStatusResult = {
  properties: {
    is_complete: {
      type: "boolean",
      title: "Is Complete",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    error_detail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Detail",
    },
  },
  type: "object",
  required: ["is_complete", "status"],
  title: "IntegrationStatusResult",
} as const;

export const $LatLon = {
  properties: {
    lat: {
      type: "number",
      title: "Lat",
    },
    lon: {
      type: "number",
      title: "Lon",
    },
  },
  type: "object",
  required: ["lat", "lon"],
  title: "LatLon",
} as const;

export const $Layer = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    target: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Target",
    },
    rated: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Rated",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
    layer_source: {
      anyOf: [
        {
          type: "string",
          enum: ["extracted", "default", "manual"],
        },
        {
          type: "null",
        },
      ],
      title: "Layer Source",
    },
    is_enabled: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Enabled",
    },
    peril_overrides: {
      anyOf: [
        {
          additionalProperties: {
            $ref: "#/components/schemas/PerilOverride",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Peril Overrides",
    },
    competitor_pricing: {
      items: {
        $ref: "#/components/schemas/CompetitorPricing",
      },
      type: "array",
      title: "Competitor Pricing",
    },
    included_perils_override: {
      anyOf: [
        {
          items: {
            anyOf: [
              {
                type: "string",
                enum: [
                  "aop",
                  "earthquake",
                  "earth_movement",
                  "named_storm",
                  "scs",
                  "flood",
                  "wildfire",
                  "equipment_breakdown",
                ],
              },
              {
                type: "string",
                const: "wind_and_hail",
              },
            ],
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Included Perils Override",
    },
    form_selection_override: {
      anyOf: [
        {
          type: "string",
          enum: ["ISO", "Co-Participation", "Manuscript"],
        },
        {
          type: "null",
        },
      ],
      title: "Form Selection Override",
    },
    broker_commission_percentage_override: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Commission Percentage Override",
    },
  },
  type: "object",
  required: ["starting_point", "range", "target", "rated"],
  title: "Layer",
} as const;

export const $LayerGateExposureResult = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    participation: {
      type: "integer",
      title: "Participation",
    },
    wind_shown: {
      type: "boolean",
      title: "Wind Shown",
    },
    eq_shown: {
      type: "boolean",
      title: "Eq Shown",
    },
    gates: {
      items: {
        $ref: "#/components/schemas/GateExposure",
      },
      type: "array",
      title: "Gates",
    },
  },
  type: "object",
  required: [
    "layer_id",
    "starting_point",
    "range",
    "participation",
    "wind_shown",
    "eq_shown",
    "gates",
  ],
  title: "LayerGateExposureResult",
} as const;

export const $LayerPmiResponse = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    share: {
      type: "number",
      title: "Share",
    },
    rows: {
      items: {
        $ref: "#/components/schemas/LayerPmiRow",
      },
      type: "array",
      title: "Rows",
      default: [],
    },
    portfolio_report_count: {
      type: "integer",
      title: "Portfolio Report Count",
    },
    as_of: {
      type: "string",
      format: "date-time",
      title: "As Of",
    },
    subject_vectors_from_shadow_run: {
      type: "boolean",
      title: "Subject Vectors From Shadow Run",
    },
  },
  type: "object",
  required: [
    "layer_id",
    "share",
    "portfolio_report_count",
    "as_of",
    "subject_vectors_from_shadow_run",
  ],
  title: "LayerPmiResponse",
  description: `On-demand per-layer PMI at a caller-chosen participation share,
computed against the current in-force book (not the persisted job-time
snapshot).`,
} as const;

export const $LayerPmiRow = {
  properties: {
    peril: {
      type: "string",
      title: "Peril",
    },
    pmi_at_share: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: ["100", "250", "1000"],
      },
      type: "object",
      title: "Pmi At Share",
      default: {},
    },
  },
  type: "object",
  required: ["peril"],
  title: "LayerPmiRow",
} as const;

export const $LayerPremiumBreakdown = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    peril_types: {
      additionalProperties: {
        $ref: "#/components/schemas/PerilTypeBreakdown",
      },
      type: "object",
      title: "Peril Types",
    },
    totals: {
      additionalProperties: {
        $ref: "#/components/schemas/LayerTotals",
      },
      type: "object",
      title: "Totals",
    },
    commission_adjustment_factor: {
      type: "number",
      title: "Commission Adjustment Factor",
      default: 1,
    },
    broker_commission_percentage: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Commission Percentage",
    },
  },
  type: "object",
  required: ["layer_id", "peril_types", "totals"],
  title: "LayerPremiumBreakdown",
} as const;

export const $LayerSummary = {
  properties: {
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
  },
  type: "object",
  required: ["starting_point", "range", "participation"],
  title: "LayerSummary",
} as const;

export const $LayerTotals = {
  properties: {
    layer_total: {
      type: "number",
      title: "Layer Total",
    },
    share_total: {
      type: "number",
      title: "Share Total",
    },
    has_missing_data: {
      type: "boolean",
      title: "Has Missing Data",
    },
  },
  type: "object",
  required: ["layer_total", "share_total", "has_missing_data"],
  title: "LayerTotals",
  description: "Precomputed totals for one source strategy on one layer.",
} as const;

export const $Limit = {
  properties: {
    limit_name: {
      type: "string",
      enum: [
        "earthquake",
        "earthmovement",
        "flood",
        "flood_high_hazard_sfha",
        "windstorm_named_windstorm_hurricane",
        "building_ordinance_coverage_a",
        "building_ordinance_coverage_b",
        "building_ordinance_coverage_c",
        "building_ordinance_coverage_d",
        "civil_or_military_authority",
        "ingress_egress",
        "debris_removal",
        "service_interruption",
        "contingent_time_element",
        "evacuation_expense",
        "electronic_data_and_media",
        "expediting_expenses",
        "fines_and_penalties",
        "property_in_the_open",
        "pairs_and_sets",
        "trees_shrubs_and_plants",
        "off_premises_storage",
        "outdoor_property",
        "land_improvements",
        "spoilage_perishable_foods",
        "piers_docks_wharfs_seawalls",
        "property_in_course_of_construction",
        "protection_and_preservation_of_property",
        "professional_fees",
        "animals_held_for_research",
        "research_and_development",
        "fire_brigade_and_extinguishing_expenses",
        "soft_costs",
        "vehicles_licensed_for_highway_use",
        "waterway_access",
        "extra_expense",
        "fine_arts",
        "land_water_contamination_and_cleanup_expense",
        "decontamination_costs",
        "leasehold_interest",
        "loss_adjustment_expenses",
        "personal_property_of_officers_and_employees",
        "employee_tools",
        "transit",
        "accounts_receivable",
        "mold_and_fungus",
        "errors_and_omissions",
        "miscellaneous_unnamed_locations",
        "newly_acquired_automatic_coverage",
        "extended_period_of_indemnity",
        "backup_of_sewers_and_drains_sump_overflow",
        "brands_and_labels",
        "code_upgrade_upgrade_to_green",
        "employee_personal_effects",
        "exhibition_trade_show_property",
        "freeze",
        "leader_property",
        "money_and_securities",
        "off_premises_property_temporary_locations",
        "refrigerated_property_temperature_change",
        "sprinkler_leakage",
        "strikes_riots_and_civil_commotion",
        "valuable_papers_and_records",
        "ordinary_payroll",
        "impounded_water",
        "land_and_water_cleanup_expense",
        "limited_pollution",
        "contractors_equipment",
        "rental_value",
        "royalties",
        "cyber",
        "asbestos",
        "equipment_breakdown",
        "consequential_loss",
        "cancellation_of_bookings",
      ],
      title: "Limit Name",
    },
    limit_status: {
      anyOf: [
        {
          type: "string",
          enum: ["included", "excluded"],
        },
        {
          type: "null",
        },
      ],
      title: "Limit Status",
    },
    applicability: {
      anyOf: [
        {
          type: "string",
          enum: ["per_occurrence", "per_occurrence_and_annual_aggregate"],
        },
        {
          type: "null",
        },
      ],
      title: "Applicability",
    },
    amount: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Amount",
    },
    time_limit_days: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Time Limit Days",
    },
    mile_limitation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Mile Limitation",
    },
    qualifying_period_hours: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Qualifying Period Hours",
    },
    document_excerpt: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Document Excerpt",
    },
  },
  type: "object",
  required: [
    "limit_name",
    "limit_status",
    "applicability",
    "amount",
    "time_limit_days",
    "mile_limitation",
    "qualifying_period_hours",
    "document_excerpt",
  ],
  title: "Limit",
} as const;

export const $LimitAndSublimitInfo = {
  properties: {
    extracted_limits: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/Limit",
        },
        propertyNames: {
          enum: [
            "earthquake",
            "earthmovement",
            "flood",
            "flood_high_hazard_sfha",
            "windstorm_named_windstorm_hurricane",
            "building_ordinance_coverage_a",
            "building_ordinance_coverage_b",
            "building_ordinance_coverage_c",
            "building_ordinance_coverage_d",
            "civil_or_military_authority",
            "ingress_egress",
            "debris_removal",
            "service_interruption",
            "contingent_time_element",
            "evacuation_expense",
            "electronic_data_and_media",
            "expediting_expenses",
            "fines_and_penalties",
            "property_in_the_open",
            "pairs_and_sets",
            "trees_shrubs_and_plants",
            "off_premises_storage",
            "outdoor_property",
            "land_improvements",
            "spoilage_perishable_foods",
            "piers_docks_wharfs_seawalls",
            "property_in_course_of_construction",
            "protection_and_preservation_of_property",
            "professional_fees",
            "animals_held_for_research",
            "research_and_development",
            "fire_brigade_and_extinguishing_expenses",
            "soft_costs",
            "vehicles_licensed_for_highway_use",
            "waterway_access",
            "extra_expense",
            "fine_arts",
            "land_water_contamination_and_cleanup_expense",
            "decontamination_costs",
            "leasehold_interest",
            "loss_adjustment_expenses",
            "personal_property_of_officers_and_employees",
            "employee_tools",
            "transit",
            "accounts_receivable",
            "mold_and_fungus",
            "errors_and_omissions",
            "miscellaneous_unnamed_locations",
            "newly_acquired_automatic_coverage",
            "extended_period_of_indemnity",
            "backup_of_sewers_and_drains_sump_overflow",
            "brands_and_labels",
            "code_upgrade_upgrade_to_green",
            "employee_personal_effects",
            "exhibition_trade_show_property",
            "freeze",
            "leader_property",
            "money_and_securities",
            "off_premises_property_temporary_locations",
            "refrigerated_property_temperature_change",
            "sprinkler_leakage",
            "strikes_riots_and_civil_commotion",
            "valuable_papers_and_records",
            "ordinary_payroll",
            "impounded_water",
            "land_and_water_cleanup_expense",
            "limited_pollution",
            "contractors_equipment",
            "rental_value",
            "royalties",
            "cyber",
            "asbestos",
            "equipment_breakdown",
            "consequential_loss",
            "cancellation_of_bookings",
          ],
        },
        type: "object",
      },
      type: "object",
      title: "Extracted Limits",
    },
    manual_limits: {
      additionalProperties: {
        $ref: "#/components/schemas/Limit",
      },
      propertyNames: {
        enum: [
          "earthquake",
          "earthmovement",
          "flood",
          "flood_high_hazard_sfha",
          "windstorm_named_windstorm_hurricane",
          "building_ordinance_coverage_a",
          "building_ordinance_coverage_b",
          "building_ordinance_coverage_c",
          "building_ordinance_coverage_d",
          "civil_or_military_authority",
          "ingress_egress",
          "debris_removal",
          "service_interruption",
          "contingent_time_element",
          "evacuation_expense",
          "electronic_data_and_media",
          "expediting_expenses",
          "fines_and_penalties",
          "property_in_the_open",
          "pairs_and_sets",
          "trees_shrubs_and_plants",
          "off_premises_storage",
          "outdoor_property",
          "land_improvements",
          "spoilage_perishable_foods",
          "piers_docks_wharfs_seawalls",
          "property_in_course_of_construction",
          "protection_and_preservation_of_property",
          "professional_fees",
          "animals_held_for_research",
          "research_and_development",
          "fire_brigade_and_extinguishing_expenses",
          "soft_costs",
          "vehicles_licensed_for_highway_use",
          "waterway_access",
          "extra_expense",
          "fine_arts",
          "land_water_contamination_and_cleanup_expense",
          "decontamination_costs",
          "leasehold_interest",
          "loss_adjustment_expenses",
          "personal_property_of_officers_and_employees",
          "employee_tools",
          "transit",
          "accounts_receivable",
          "mold_and_fungus",
          "errors_and_omissions",
          "miscellaneous_unnamed_locations",
          "newly_acquired_automatic_coverage",
          "extended_period_of_indemnity",
          "backup_of_sewers_and_drains_sump_overflow",
          "brands_and_labels",
          "code_upgrade_upgrade_to_green",
          "employee_personal_effects",
          "exhibition_trade_show_property",
          "freeze",
          "leader_property",
          "money_and_securities",
          "off_premises_property_temporary_locations",
          "refrigerated_property_temperature_change",
          "sprinkler_leakage",
          "strikes_riots_and_civil_commotion",
          "valuable_papers_and_records",
          "ordinary_payroll",
          "impounded_water",
          "land_and_water_cleanup_expense",
          "limited_pollution",
          "contractors_equipment",
          "rental_value",
          "royalties",
          "cyber",
          "asbestos",
          "equipment_breakdown",
          "consequential_loss",
          "cancellation_of_bookings",
        ],
      },
      type: "object",
      title: "Manual Limits",
    },
    active_filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Active Filename",
    },
  },
  type: "object",
  required: ["extracted_limits", "manual_limits"],
  title: "LimitAndSublimitInfo",
} as const;

export const $LimitSummary = {
  properties: {
    occurrence: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Occurrence",
    },
    aggregate: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Aggregate",
    },
    zone: {
      type: "string",
      title: "Zone",
    },
  },
  type: "object",
  required: ["occurrence", "aggregate", "zone"],
  title: "LimitSummary",
} as const;

export const $LimitSummaryRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    address_ids: {
      items: {
        type: "string",
      },
      type: "array",
      maxItems: 5000,
      title: "Address Ids",
    },
  },
  type: "object",
  required: ["report_id", "address_ids"],
  title: "LimitSummaryRequest",
} as const;

export const $LimitSummaryResponse = {
  properties: {
    addresses: {
      additionalProperties: {
        additionalProperties: {
          $ref: "#/components/schemas/LimitSummary",
        },
        propertyNames: {
          enum: ["PWH", "PES", "PFL", "PWB", "PWT", "AOP"],
        },
        type: "object",
      },
      type: "object",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "LimitSummaryResponse",
} as const;

export const $LinkPolicyFlyApplicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
    url: {
      type: "string",
      title: "Url",
    },
  },
  type: "object",
  required: ["report_id", "layer_id", "suffix", "url"],
  title: "LinkPolicyFlyApplicationRequest",
} as const;

export const $LinkPolicyFlyApplicationResponse = {
  properties: {
    policy_fly_info: {
      $ref: "#/components/schemas/PolicyFlyInfo",
    },
  },
  type: "object",
  required: ["policy_fly_info"],
  title: "LinkPolicyFlyApplicationResponse",
} as const;

export const $ListAdditionalFilesResponse = {
  properties: {
    files: {
      items: {
        $ref: "#/components/schemas/AdditionalFile",
      },
      type: "array",
      title: "Files",
    },
  },
  type: "object",
  required: ["files"],
  title: "ListAdditionalFilesResponse",
} as const;

export const $ListBorLettersRequest = {
  properties: {
    active_only: {
      type: "boolean",
      title: "Active Only",
      default: false,
    },
  },
  type: "object",
  title: "ListBorLettersRequest",
} as const;

export const $ListClearanceMetadataRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
  },
  type: "object",
  required: ["report_ids"],
  title: "ListClearanceMetadataRequest",
} as const;

export const $ListClearanceMetadataResponse = {
  properties: {
    items: {
      items: {
        $ref: "#/components/schemas/ReportClearanceEntry",
      },
      type: "array",
      title: "Items",
    },
  },
  type: "object",
  required: ["items"],
  title: "ListClearanceMetadataResponse",
} as const;

export const $ListContactsResponse = {
  properties: {
    contacts: {
      items: {
        $ref: "#/components/schemas/ReportContact",
      },
      type: "array",
      title: "Contacts",
    },
  },
  type: "object",
  required: ["contacts"],
  title: "ListContactsResponse",
} as const;

export const $ListEndorsementsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "ListEndorsementsRequest",
} as const;

export const $ListEndorsementsResponse = {
  properties: {
    endorsements: {
      items: {
        $ref: "#/components/schemas/EndorsementView",
      },
      type: "array",
      title: "Endorsements",
    },
    totals: {
      items: {
        $ref: "#/components/schemas/EndorsementLedgerTotals",
      },
      type: "array",
      title: "Totals",
    },
    current_tiv: {
      type: "number",
      title: "Current Tiv",
    },
  },
  type: "object",
  required: ["endorsements", "totals", "current_tiv"],
  title: "ListEndorsementsResponse",
} as const;

export const $ListPolicyFlyApplicationsResponse = {
  properties: {
    applications: {
      items: {
        $ref: "#/components/schemas/PolicyFlyApplicationRow",
      },
      type: "array",
      title: "Applications",
    },
  },
  type: "object",
  required: ["applications"],
  title: "ListPolicyFlyApplicationsResponse",
} as const;

export const $ListReportActionLogsRequest = {
  properties: {},
  type: "object",
  title: "ListReportActionLogsRequest",
} as const;

export const $ListReportActionLogsResponse = {
  properties: {
    summaries: {
      items: {
        $ref: "#/components/schemas/ReportActionSummaryWithName",
      },
      type: "array",
      title: "Summaries",
    },
  },
  type: "object",
  required: ["summaries"],
  title: "ListReportActionLogsResponse",
} as const;

export const $ListReportJobsRequest = {
  properties: {
    report_ids: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Report Ids",
    },
    statuses: {
      items: {
        $ref: "#/components/schemas/WorkStatus",
      },
      type: "array",
      title: "Statuses",
    },
    include_all_runs: {
      type: "boolean",
      title: "Include All Runs",
      default: false,
    },
  },
  type: "object",
  required: ["report_ids", "statuses"],
  title: "ListReportJobsRequest",
} as const;

export const $ListReportJobsResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/ReportJobBatchEntry",
      },
      type: "array",
      title: "Jobs",
    },
  },
  type: "object",
  required: ["jobs"],
  title: "ListReportJobsResponse",
} as const;

export const $ListReportsRequest = {
  properties: {
    lobs: {
      items: {
        type: "string",
        enum: ["property", "builders_risk", "cat", "property_renewal"],
      },
      type: "array",
      title: "Lobs",
    },
  },
  type: "object",
  required: ["lobs"],
  title: "ListReportsRequest",
} as const;

export const $ListReportsResponse = {
  properties: {
    reports: {
      items: {
        $ref: "#/components/schemas/ReportMetadataResponse",
      },
      type: "array",
      title: "Reports",
    },
  },
  type: "object",
  required: ["reports"],
  title: "ListReportsResponse",
} as const;

export const $ListSavedFiltersResponse = {
  properties: {
    filters: {
      items: {
        $ref: "#/components/schemas/SavedFilter",
      },
      type: "array",
      title: "Filters",
    },
  },
  type: "object",
  required: ["filters"],
  title: "ListSavedFiltersResponse",
} as const;

export const $ListTemplatesResponse = {
  properties: {
    templates: {
      items: {
        $ref: "#/components/schemas/Template",
      },
      type: "array",
      title: "Templates",
    },
  },
  type: "object",
  required: ["templates"],
  title: "ListTemplatesResponse",
} as const;

export const $ListUpdatingReportsRequest = {
  properties: {
    since: {
      type: "string",
      format: "date-time",
      title: "Since",
    },
  },
  type: "object",
  required: ["since"],
  title: "ListUpdatingReportsRequest",
} as const;

export const $ListUpdatingReportsResponse = {
  properties: {
    updates: {
      items: {
        $ref: "#/components/schemas/ReportBeingUpdated",
      },
      type: "array",
      title: "Updates",
    },
  },
  type: "object",
  required: ["updates"],
  title: "ListUpdatingReportsResponse",
} as const;

export const $ListUserResponse = {
  properties: {
    current_user: {
      $ref: "#/components/schemas/User",
    },
    all_company_users: {
      items: {
        $ref: "#/components/schemas/User",
      },
      type: "array",
      title: "All Company Users",
    },
  },
  type: "object",
  required: ["current_user", "all_company_users"],
  title: "ListUserResponse",
} as const;

export const $LoadAddressesForMapRequest = {
  properties: {
    lobs: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Lobs",
    },
  },
  type: "object",
  required: ["lobs"],
  title: "LoadAddressesForMapRequest",
} as const;

export const $LoadAddressesForMapResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/SpatialKeyAddress",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "LoadAddressesForMapResponse",
} as const;

export const $LocationAddress = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    street_address: {
      type: "string",
      title: "Street Address",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    lat: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lat",
    },
    long: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Long",
    },
  },
  type: "object",
  required: ["address_id", "street_address", "tiv"],
  title: "LocationAddress",
} as const;

export const $LocationClassification = {
  properties: {
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    wind_tier: {
      anyOf: [
        {
          type: "string",
          enum: ["tier_1", "tier_2"],
        },
        {
          type: "null",
        },
      ],
      title: "Wind Tier",
    },
    wind_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Southeast Florida",
            "Southwest Florida",
            "Central Florida",
            "Northeast Florida",
            "Panhandle Florida",
            "Georgia / South Carolina",
            "North Carolina",
            "Texas incl. Harris County",
            "Louisiana",
            "Mississippi",
            "Alabama",
            "Mid-Atlantic (VA/MD/DE)",
            "Northeast (NY/NJ/CT/RI/MA/NH/ME)",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Wind Gate",
    },
    eq_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "CA High Hazard",
            "Pacific NW",
            "Intermountain West",
            "New Madrid",
            "Northeast",
            "Alabama EQ",
            "Alaska EQ",
            "District of Columbia EQ",
            "Florida EQ",
            "Georgia EQ",
            "Guam EQ",
            "Hawaii EQ",
            "Iowa EQ",
            "Kansas EQ",
            "Louisiana EQ",
            "Michigan EQ",
            "Minnesota EQ",
            "Mississippi EQ",
            "Nebraska EQ",
            "New Hampshire EQ",
            "North Carolina EQ",
            "North Dakota EQ",
            "Ohio EQ",
            "Oklahoma EQ",
            "Puerto Rico EQ",
            "South Carolina EQ",
            "South Dakota EQ",
            "Texas EQ",
            "US Virgin Islands EQ",
            "Wisconsin EQ",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Eq Gate",
    },
  },
  type: "object",
  required: ["state", "county", "wind_tier", "wind_gate", "eq_gate"],
  title: "LocationClassification",
} as const;

export const $LocationClassificationsRequest = {
  properties: {
    locations: {
      items: {
        $ref: "#/components/schemas/LocationKey",
      },
      type: "array",
      maxItems: 10000,
      title: "Locations",
    },
  },
  type: "object",
  required: ["locations"],
  title: "LocationClassificationsRequest",
} as const;

export const $LocationClassificationsResponse = {
  properties: {
    results: {
      items: {
        $ref: "#/components/schemas/LocationClassification",
      },
      type: "array",
      title: "Results",
    },
  },
  type: "object",
  required: ["results"],
  title: "LocationClassificationsResponse",
} as const;

export const $LocationKey = {
  properties: {
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
  },
  type: "object",
  required: ["state", "county"],
  title: "LocationKey",
} as const;

export const $LogEventRequest = {
  properties: {
    event_name: {
      type: "string",
      title: "Event Name",
    },
    event_properties: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
          {
            type: "number",
          },
        ],
      },
      type: "object",
      title: "Event Properties",
    },
  },
  type: "object",
  required: ["event_name", "event_properties"],
  title: "LogEventRequest",
} as const;

export const $LoginResponse = {
  properties: {
    access_token: {
      type: "string",
      title: "Access Token",
    },
    token_type: {
      type: "string",
      title: "Token Type",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    user: {
      $ref: "#/components/schemas/User",
    },
  },
  type: "object",
  required: ["access_token", "token_type", "client_id", "user"],
  title: "LoginResponse",
} as const;

export const $LossControlAnswer = {
  properties: {
    short_answer: {
      type: "string",
      title: "Short Answer",
    },
    long_answer: {
      type: "string",
      title: "Long Answer",
    },
  },
  type: "object",
  required: ["short_answer", "long_answer"],
  title: "LossControlAnswer",
} as const;

export const $LossControlReport = {
  properties: {
    entity_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Entity Name",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    fields: {
      additionalProperties: {
        anyOf: [
          {
            $ref: "#/components/schemas/LossControlAnswer",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Fields",
    },
  },
  type: "object",
  required: ["filename", "fields"],
  title: "LossControlReport",
} as const;

export const $LossRunInfo = {
  properties: {
    loss_runs_by_year: {
      additionalProperties: {
        items: {
          anyOf: [
            {
              $ref: "#/components/schemas/UserGeneratedLossRunByYear",
            },
            {
              $ref: "#/components/schemas/ComputedLossRunByYear",
            },
            {
              $ref: "#/components/schemas/ParsedLossRunByYear",
            },
          ],
        },
        type: "array",
      },
      type: "object",
      title: "Loss Runs By Year",
    },
    enabled_by_source: {
      additionalProperties: {
        $ref: "#/components/schemas/SourceDetailInfo",
      },
      type: "object",
      title: "Enabled By Source",
    },
  },
  type: "object",
  required: ["loss_runs_by_year", "enabled_by_source"],
  title: "LossRunInfo",
} as const;

export const $MappingInfo = {
  properties: {
    original_col_name: {
      type: "string",
      title: "Original Col Name",
    },
    confidence: {
      type: "number",
      title: "Confidence",
    },
  },
  type: "object",
  required: ["original_col_name", "confidence"],
  title: "MappingInfo",
} as const;

export const $MarkBorStepRequest = {
  properties: {
    bor_id: {
      type: "string",
      title: "Bor Id",
    },
    step: {
      type: "string",
      enum: [
        "outgoing_broker_notified_at",
        "incoming_broker_notified_at",
        "rescind_letter_received_at",
        "finalized_at",
        "outgoing_broker_resolution_sent_at",
        "incoming_broker_resolution_sent_at",
      ],
      title: "Step",
    },
    timestamp: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Timestamp",
    },
  },
  type: "object",
  required: ["bor_id", "step"],
  title: "MarkBorStepRequest",
} as const;

export const $MatchingReportInfo = {
  properties: {
    report_name: {
      type: "string",
      title: "Report Name",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    matching_addresses: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Matching Addresses",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    matching_tiv: {
      type: "number",
      title: "Matching Tiv",
      default: 0,
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
      default: 0,
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    prior_submission_result: {
      anyOf: [
        {
          type: "string",
          enum: ["prior_submission", "updated_submission"],
        },
        {
          type: "null",
        },
      ],
      title: "Prior Submission Result",
    },
  },
  type: "object",
  required: ["report_name", "report_id", "matching_addresses", "created_at_ts"],
  title: "MatchingReportInfo",
} as const;

export const $MatchingReportsByAddresses = {
  properties: {
    matching_report_info: {
      items: {
        $ref: "#/components/schemas/MatchingReportInfo",
      },
      type: "array",
      title: "Matching Report Info",
    },
  },
  type: "object",
  required: ["matching_report_info"],
  title: "MatchingReportsByAddresses",
} as const;

export const $MaterialShare = {
  properties: {
    material: {
      type: "string",
      title: "Material",
    },
    ratio: {
      type: "number",
      title: "Ratio",
    },
    area_sqm: {
      type: "number",
      title: "Area Sqm",
    },
    confidence: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Confidence",
    },
  },
  type: "object",
  required: ["material", "ratio", "area_sqm", "confidence"],
  title: "MaterialShare",
} as const;

export const $MultipleCompanyNamesFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "multiple_company_names",
      title: "Flag Id",
    },
    company_names: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Company Names",
    },
  },
  type: "object",
  required: ["flag_id", "company_names"],
  title: "MultipleCompanyNamesFlag",
} as const;

export const $NaicsInfo = {
  properties: {
    code_type: {
      type: "string",
      enum: ["sic", "naics"],
      title: "Code Type",
      default: "naics",
    },
    code: {
      type: "string",
      title: "Code",
    },
    description: {
      type: "string",
      title: "Description",
    },
  },
  type: "object",
  required: ["code", "description"],
  title: "NaicsInfo",
} as const;

export const $NearmapAiData = {
  properties: {
    roof_materials: {
      $ref: "#/components/schemas/RoofMaterialBreakdown",
    },
    derived_modifiers: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Derived Modifiers",
    },
  },
  type: "object",
  required: ["roof_materials", "derived_modifiers"],
  title: "NearmapAiData",
  description: `The \`\`IntegrationType.NEARMAP_AI\`\` row for one address: the material mix
plus the RMS modifier codes derived from it at fetch time (e.g.
\`\`{"roof_covering": "7"}\`\`), so the enhanced cat run reads stored codes
instead of re-deriving.`,
} as const;

export const $NearmapData = {
  properties: {
    solar_panels: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Solar Panels",
    },
    structural_damage: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Structural Damage",
    },
    ponding: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Ponding",
    },
    staining: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Staining",
    },
    missing_shingles: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Missing Shingles",
    },
    storm_report_count: {
      type: "integer",
      title: "Storm Report Count",
      default: 0,
    },
    hail_event_count: {
      type: "integer",
      title: "Hail Event Count",
      default: 0,
    },
    max_wind_gust_mph: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Wind Gust Mph",
    },
    latest_storm_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Latest Storm Date",
    },
    buildings: {
      items: {
        $ref: "#/components/schemas/BuildingData",
      },
      type: "array",
      title: "Buildings",
      default: [],
    },
    derived_modifiers: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Derived Modifiers",
      default: {},
    },
  },
  type: "object",
  title: "NearmapData",
  description: `Curated subset of the Betterview Property Profile response.

Construct from a validated Betterview envelope with :meth:\`from_betterview\`.
The model stays a plain round-trippable struct (\`\`model_validate\`\` /
\`\`model_dump\`\`) so it can be persisted and re-read without re-parsing.`,
} as const;

export const $NearmapInitiateRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "NearmapInitiateRequest",
} as const;

export const $NearmapInitiateResponse = {
  properties: {
    request_id: {
      type: "string",
      title: "Request Id",
    },
  },
  type: "object",
  required: ["request_id"],
  title: "NearmapInitiateResponse",
} as const;

export const $NearmapJobHistoryItem = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    num_addresses: {
      type: "integer",
      title: "Num Addresses",
    },
    enriched_count: {
      type: "integer",
      title: "Enriched Count",
    },
    unavailable_sources: {
      items: {
        type: "string",
        enum: ["betterview", "nearmap_ai"],
      },
      type: "array",
      title: "Unavailable Sources",
    },
  },
  type: "object",
  required: [
    "batch_id",
    "status",
    "started_at",
    "finished_at",
    "num_addresses",
    "enriched_count",
    "unavailable_sources",
  ],
  title: "NearmapJobHistoryItem",
} as const;

export const $NearmapJobHistoryResponse = {
  properties: {
    jobs: {
      items: {
        $ref: "#/components/schemas/NearmapJobHistoryItem",
      },
      type: "array",
      title: "Jobs",
      default: [],
    },
  },
  type: "object",
  title: "NearmapJobHistoryResponse",
} as const;

export const $OFACHit = {
  properties: {
    sanction_lists: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Sanction Lists",
    },
    entity_description: {
      type: "string",
      title: "Entity Description",
    },
  },
  type: "object",
  required: ["sanction_lists", "entity_description"],
  title: "OFACHit",
} as const;

export const $OFACResult = {
  properties: {
    hits: {
      items: {
        $ref: "#/components/schemas/OFACHit",
      },
      type: "array",
      title: "Hits",
    },
  },
  type: "object",
  required: ["hits"],
  title: "OFACResult",
} as const;

export const $OccupancyData = {
  properties: {
    use_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Use Code",
    },
    standardized_land_use_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Standardized Land Use Code",
    },
    number_of_units: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Units",
    },
  },
  type: "object",
  title: "OccupancyData",
  description: "Occupancy (O) from COPE — how the building is used.",
} as const;

export const $OccupancyMix = {
  properties: {
    occupancy_description: {
      type: "string",
      title: "Occupancy Description",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["occupancy_description", "tiv", "pct_tiv"],
  title: "OccupancyMix",
} as const;

export const $OverrideableListElement_RawAdditionalInterest_Literal__todo___ = {
  properties: {
    original: {
      anyOf: [
        {
          $ref: "#/components/schemas/RawAdditionalInterest",
        },
        {
          type: "null",
        },
      ],
    },
    deleted: {
      type: "boolean",
      title: "Deleted",
    },
    inserted: {
      anyOf: [
        {
          $ref: "#/components/schemas/RawAdditionalInterest",
        },
        {
          type: "null",
        },
      ],
    },
    flags: {
      additionalProperties: {
        type: "string",
        const: "todo",
      },
      type: "object",
      title: "Flags",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
  },
  type: "object",
  required: ["original", "deleted", "inserted", "flags", "overrides"],
  title: "OverrideableListElement[RawAdditionalInterest, Literal['todo']]",
} as const;

export const $ParsedLoss = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    date_of_loss: {
      type: "string",
      title: "Date Of Loss",
    },
    address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Address",
    },
    claim_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Claim Id",
    },
    loss_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    deductible: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    is_cat_event: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Cat Event",
    },
    claim_type: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Claim Type",
    },
    source: {
      type: "string",
      const: "parsed",
      title: "Source",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
    flags: {
      additionalProperties: {
        items: {
          type: "string",
          const: "could_not_parse",
        },
        type: "array",
      },
      type: "object",
      title: "Flags",
    },
    original_values: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Original Values",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "date_of_loss",
    "address",
    "claim_id",
    "loss_id",
    "status",
    "description",
    "ground_up_loss",
    "deductible",
    "net_incurred",
    "is_cat_event",
    "claim_type",
    "source",
    "source_details",
    "overrides",
    "flags",
    "original_values",
  ],
  title: "ParsedLoss",
} as const;

export const $ParsedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    source: {
      type: "string",
      const: "parsed_year",
      title: "Source",
    },
    open_claims: {
      type: "integer",
      title: "Open Claims",
    },
    closed_claims: {
      type: "integer",
      title: "Closed Claims",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    carrier: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Carrier",
    },
    flags: {
      additionalProperties: {
        items: {
          type: "string",
          const: "could_not_parse",
        },
        type: "array",
      },
      type: "object",
      title: "Flags",
    },
    original_values: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Original Values",
    },
    overrides: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Overrides",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "source",
    "open_claims",
    "closed_claims",
    "ground_up_loss",
    "net_incurred",
    "carrier",
    "flags",
    "original_values",
    "overrides",
  ],
  title: "ParsedLossRunByYear",
} as const;

export const $PastStorm = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    name: {
      type: "string",
      title: "Name",
    },
    peak_intensity_kt: {
      type: "integer",
      title: "Peak Intensity Kt",
    },
    peaked: {
      type: "string",
      format: "date",
      title: "Peaked",
    },
  },
  additionalProperties: false,
  type: "object",
  required: ["id", "name", "peak_intensity_kt", "peaked"],
  title: "PastStorm",
  description: "A storm the NHC has finished advising on.",
} as const;

export const $PastStormWithTrack = {
  properties: {
    storm: {
      $ref: "#/components/schemas/PastStorm",
    },
    track: {
      items: {
        $ref: "#/components/schemas/TrackPoint",
      },
      type: "array",
      title: "Track",
    },
  },
  type: "object",
  required: ["storm", "track"],
  title: "PastStormWithTrack",
  description: `One finished storm and the path it actually took.

No cone: every position is observed, so there is nothing left to be
uncertain about.`,
} as const;

export const $PastStorms = {
  properties: {
    storms: {
      items: {
        $ref: "#/components/schemas/PastStormWithTrack",
      },
      type: "array",
      title: "Storms",
    },
  },
  type: "object",
  required: ["storms"],
  title: "PastStorms",
  description: "The season's named storms within reach, most recent first.",
} as const;

export const $PerilCodePremium = {
  properties: {
    peril_code: {
      type: "string",
      title: "Peril Code",
    },
    aal: {
      type: "number",
      title: "Aal",
    },
    annual_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Annual Aal",
    },
    share_aal: {
      type: "number",
      title: "Share Aal",
    },
    multiplier: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiplier",
    },
    multiplier_reason: {
      type: "string",
      title: "Multiplier Reason",
    },
    layer_premium: {
      type: "number",
      title: "Layer Premium",
    },
    share_premium: {
      type: "number",
      title: "Share Premium",
    },
    layer_effective: {
      type: "number",
      title: "Layer Effective",
    },
    share_effective: {
      type: "number",
      title: "Share Effective",
    },
    effective_base_premium: {
      type: "number",
      title: "Effective Base Premium",
    },
    missing: {
      type: "boolean",
      title: "Missing",
    },
    missing_reason: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Missing Reason",
    },
    warnings: {
      additionalProperties: {
        type: "integer",
      },
      type: "object",
      title: "Warnings",
    },
    override_type: {
      anyOf: [
        {
          type: "string",
          enum: ["multiple", "premium"],
        },
        {
          type: "null",
        },
      ],
      title: "Override Type",
    },
    override_multiple: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Override Multiple",
    },
    override_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Override Premium",
    },
  },
  type: "object",
  required: [
    "peril_code",
    "aal",
    "annual_aal",
    "share_aal",
    "multiplier",
    "multiplier_reason",
    "layer_premium",
    "share_premium",
    "layer_effective",
    "share_effective",
    "effective_base_premium",
    "missing",
    "missing_reason",
    "warnings",
  ],
  title: "PerilCodePremium",
} as const;

export const $PerilModelProfile = {
  properties: {
    peril: {
      type: "string",
      enum: [
        "PWH",
        "PSH",
        "PWH_PSH",
        "PES",
        "PFL",
        "PFL_PSH",
        "PWB",
        "PWW",
        "PWT",
      ],
      title: "Peril",
    },
    model_profile_id: {
      type: "integer",
      title: "Model Profile Id",
    },
    version: {
      anyOf: [
        {
          type: "string",
          enum: ["22", "25"],
        },
        {
          type: "null",
        },
      ],
      title: "Version",
    },
  },
  type: "object",
  required: ["peril", "model_profile_id", "version"],
  title: "PerilModelProfile",
  description: `The RMS model profile a peril's results were produced on, for display.

\`\`version\`\` is None when the stored \`\`model_profile_id\`\` isn't in current
config (historical/unknown) or is a version-agnostic HD profile — the
caller shows the peril with no version badge rather than failing.`,
} as const;

export const $PerilMultipleCategories = {
  properties: {
    ns: {
      type: "string",
      enum: ["tri_county", "fl", "gulf_x_fl", "baseline"],
      title: "Ns",
    },
    ns_reason: {
      type: "string",
      title: "Ns Reason",
    },
    eq: {
      type: "string",
      enum: ["eq_ca_a", "eq_ca_b", "ca", "pnw", "baseline"],
      title: "Eq",
    },
    eq_reason: {
      type: "string",
      title: "Eq Reason",
    },
  },
  type: "object",
  required: ["ns", "ns_reason", "eq", "eq_reason"],
  title: "PerilMultipleCategories",
} as const;

export const $PerilOverride = {
  properties: {
    multiple: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiple",
    },
    premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Premium",
    },
  },
  type: "object",
  title: "PerilOverride",
  description: `User override for one peril code on a layer, applied whichever modeling
source prices the layer.

Exactly one of multiple or premium should be set.
When multiple is set: effective_premium = AAL * multiple.
When premium is set: effective_multiple = premium / AAL.`,
} as const;

export const $PerilScores = {
  properties: {
    hurricane: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hurricane",
    },
    storm_surge: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Storm Surge",
    },
    earthquake: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Earthquake",
    },
    flood: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood",
    },
    wildfire: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wildfire",
    },
    snow_load: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Snow Load",
    },
    ground_snow_load: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Snow Load",
    },
    wind: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind",
    },
    hail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hail",
    },
    tornado: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tornado",
    },
    lightning: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lightning",
    },
  },
  type: "object",
  title: "PerilScores",
  description:
    "Letter grades from the HazardHub risks section for modeled perils.",
} as const;

export const $PerilTypeBreakdown = {
  properties: {
    resolved: {
      $ref: "#/components/schemas/PerilTypePremium",
    },
    luminor_blend: {
      $ref: "#/components/schemas/PerilTypePremium",
    },
    by_source: {
      additionalProperties: {
        $ref: "#/components/schemas/PerilTypePremium",
      },
      propertyNames: {
        enum: ["air", "rms", "spatialkat", "rms_22", "rms_22_air_50_50"],
      },
      type: "object",
      title: "By Source",
    },
    offerable_sources: {
      items: {
        type: "string",
        enum: ["air", "rms", "spatialkat", "rms_22", "rms_22_air_50_50"],
      },
      type: "array",
      title: "Offerable Sources",
    },
  },
  type: "object",
  required: ["resolved", "luminor_blend", "by_source", "offerable_sources"],
  title: "PerilTypeBreakdown",
  description: `Per-peril-type slice of LayerPremiumBreakdown.

Each peril type carries three views of the same parts:

- \`\`resolved\`\` is the cross-source rollup: data from whichever source
  was picked for this peril type (\`\`PerilTypePremium.source\`\` points at
  that real vendor), with \`\`share_effective\`\` re-distributed via a
  second largest-remainder pass so the per-peril shares across the
  whole layer reconcile to \`\`share_total\`\` exactly. Always present.
- \`\`luminor_blend\`\` is the same rollup over a fixed source per peril
  type rather than the report's picks. Always present.
- \`\`by_source\`\` is the per-real-source breakdown. Entries are only
  present for sources that have data (or stubs) for this peril type.`,
} as const;

export const $PerilTypePremium = {
  properties: {
    peril_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "aop",
            "earthquake",
            "earth_movement",
            "named_storm",
            "scs",
            "flood",
            "wildfire",
            "equipment_breakdown",
          ],
        },
        {
          type: "string",
          const: "wind_and_hail",
        },
      ],
      title: "Peril Type",
    },
    source: {
      type: "string",
      enum: ["air", "rms", "spatialkat", "rms_22", "rms_22_air_50_50"],
      title: "Source",
    },
    parts: {
      items: {
        $ref: "#/components/schemas/PerilCodePremium",
      },
      type: "array",
      title: "Parts",
    },
    total_aal: {
      type: "number",
      title: "Total Aal",
      default: 0,
    },
    total_annual_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Annual Aal",
    },
    total_share_aal: {
      type: "number",
      title: "Total Share Aal",
    },
    share_effective: {
      type: "number",
      title: "Share Effective",
    },
    layer_effective: {
      type: "number",
      title: "Layer Effective",
    },
    multiple_effective: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Multiple Effective",
    },
    model_profile: {
      anyOf: [
        {
          $ref: "#/components/schemas/PerilModelProfile",
        },
        {
          type: "null",
        },
      ],
    },
    run_term: {
      anyOf: [
        {
          type: "string",
          enum: ["annual", "policy"],
        },
        {
          type: "null",
        },
      ],
      title: "Run Term",
    },
  },
  type: "object",
  required: [
    "peril_type",
    "source",
    "parts",
    "total_annual_aal",
    "total_share_aal",
    "share_effective",
    "layer_effective",
    "multiple_effective",
    "model_profile",
    "run_term",
  ],
  title: "PerilTypePremium",
} as const;

export const $PlaceExposure = {
  properties: {
    state: {
      type: "string",
      title: "State",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    locations: {
      type: "integer",
      title: "Locations",
    },
    policies: {
      type: "integer",
      title: "Policies",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    lat: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lat",
    },
    lon: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lon",
    },
    min_lat: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Lat",
    },
    max_lat: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Lat",
    },
    min_lon: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Min Lon",
    },
    max_lon: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Max Lon",
    },
    wind_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Southeast Florida",
            "Southwest Florida",
            "Central Florida",
            "Northeast Florida",
            "Panhandle Florida",
            "Georgia / South Carolina",
            "North Carolina",
            "Texas incl. Harris County",
            "Louisiana",
            "Mississippi",
            "Alabama",
            "Mid-Atlantic (VA/MD/DE)",
            "Northeast (NY/NJ/CT/RI/MA/NH/ME)",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Wind Gate",
    },
    eq_gate: {
      anyOf: [
        {
          type: "string",
          enum: [
            "CA High Hazard",
            "Pacific NW",
            "Intermountain West",
            "New Madrid",
            "Northeast",
            "Alabama EQ",
            "Alaska EQ",
            "District of Columbia EQ",
            "Florida EQ",
            "Georgia EQ",
            "Guam EQ",
            "Hawaii EQ",
            "Iowa EQ",
            "Kansas EQ",
            "Louisiana EQ",
            "Michigan EQ",
            "Minnesota EQ",
            "Mississippi EQ",
            "Nebraska EQ",
            "New Hampshire EQ",
            "North Carolina EQ",
            "North Dakota EQ",
            "Ohio EQ",
            "Oklahoma EQ",
            "Puerto Rico EQ",
            "South Carolina EQ",
            "South Dakota EQ",
            "Texas EQ",
            "US Virgin Islands EQ",
            "Wisconsin EQ",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Eq Gate",
    },
  },
  type: "object",
  required: [
    "state",
    "county",
    "locations",
    "policies",
    "tiv",
    "lat",
    "lon",
    "min_lat",
    "max_lat",
    "min_lon",
    "max_lon",
    "wind_gate",
    "eq_gate",
  ],
  title: "PlaceExposure",
} as const;

export const $PolicyApplicationFieldsRequest = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
  },
  type: "object",
  required: ["application_id"],
  title: "PolicyApplicationFieldsRequest",
} as const;

export const $PolicyApplicationFieldsResponse = {
  properties: {
    application: {
      $ref: "#/components/schemas/PolicyApplicationView",
    },
    fields: {
      items: {
        $ref: "#/components/schemas/ResolvedField",
      },
      type: "array",
      title: "Fields",
    },
  },
  type: "object",
  required: ["application", "fields"],
  title: "PolicyApplicationFieldsResponse",
} as const;

export const $PolicyApplicationFormsRequest = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
  },
  type: "object",
  required: ["application_id"],
  title: "PolicyApplicationFormsRequest",
} as const;

export const $PolicyApplicationFormsResponse = {
  properties: {
    policy_type: {
      anyOf: [
        {
          type: "string",
          enum: ["ISO", "Co-Participation", "Manuscript"],
        },
        {
          type: "null",
        },
      ],
      title: "Policy Type",
    },
    tria_selection: {
      anyOf: [
        {
          type: "string",
          enum: ["Accepted", "Rejected"],
        },
        {
          type: "null",
        },
      ],
      title: "Tria Selection",
    },
    forms: {
      items: {
        $ref: "#/components/schemas/FormSelection",
      },
      type: "array",
      title: "Forms",
    },
    pairs: {
      items: {
        $ref: "#/components/schemas/FormPairView",
      },
      type: "array",
      title: "Pairs",
    },
  },
  type: "object",
  required: ["policy_type", "tria_selection", "forms", "pairs"],
  title: "PolicyApplicationFormsResponse",
} as const;

export const $PolicyApplicationStatus = {
  type: "string",
  enum: [
    "draft",
    "quoted",
    "bound",
    "issued",
    "in_force",
    "expired",
    "declined",
    "lost",
    "withdrawn",
    "renewed",
  ],
  title: "PolicyApplicationStatus",
} as const;

export const $PolicyApplicationView = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
    policy_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Number",
    },
    status: {
      $ref: "#/components/schemas/PolicyApplicationStatus",
    },
    working_set: {
      $ref: "#/components/schemas/ApplicationWorkingSet",
    },
    prior_application_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Prior Application Id",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    expiration_date: {
      anyOf: [
        {
          type: "string",
          format: "date",
        },
        {
          type: "null",
        },
      ],
      title: "Expiration Date",
    },
    created_by: {
      type: "string",
      title: "Created By",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
  },
  type: "object",
  required: [
    "id",
    "client_id",
    "report_id",
    "layer_id",
    "suffix",
    "policy_number",
    "status",
    "working_set",
    "prior_application_id",
    "effective_date",
    "expiration_date",
    "created_by",
    "created_at_ts",
    "modified_at_ts",
  ],
  title: "PolicyApplicationView",
  description: "API-facing view of a policy application row.",
} as const;

export const $PolicyApplicationsResponse = {
  properties: {
    applications: {
      items: {
        $ref: "#/components/schemas/PolicyApplicationView",
      },
      type: "array",
      title: "Applications",
    },
  },
  type: "object",
  required: ["applications"],
  title: "PolicyApplicationsResponse",
} as const;

export const $PolicyExposure = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    named_insured: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Named Insured",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    locations: {
      type: "integer",
      title: "Locations",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    line: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Line",
    },
    reachable_line: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Reachable Line",
    },
    lowest_attachment: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Lowest Attachment",
    },
    layers_overlap: {
      type: "boolean",
      title: "Layers Overlap",
    },
    layers: {
      items: {
        $ref: "#/components/schemas/Layer",
      },
      type: "array",
      title: "Layers",
    },
  },
  type: "object",
  required: [
    "report_id",
    "named_insured",
    "status",
    "locations",
    "tiv",
    "line",
    "reachable_line",
    "lowest_attachment",
    "layers_overlap",
    "layers",
  ],
  title: "PolicyExposure",
} as const;

export const $PolicyFieldOverlay = {
  properties: {
    upserts: {
      additionalProperties: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
          {
            type: "number",
          },
          {
            type: "boolean",
          },
          {
            type: "null",
          },
        ],
      },
      type: "object",
      title: "Upserts",
    },
    removals: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Removals",
    },
  },
  type: "object",
  required: ["upserts", "removals"],
  title: "PolicyFieldOverlay",
  description: `Sparse patch over the report-derived base.

\`\`upserts\`\` maps a field key to the policy-local value that wins over the
report; \`\`removals\`\` lists suppressed keys. A key in neither tracks the
report live. \`\`removals\`\` is a list (not a set) so it serializes to JSONB —
treat it as a set of keys.`,
} as const;

export const $PolicyFlyApplication = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
    url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Url",
    },
    request_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Request Id",
    },
  },
  type: "object",
  required: ["layer_id", "suffix"],
  title: "PolicyFlyApplication",
} as const;

export const $PolicyFlyApplicationRow = {
  properties: {
    base_policy_id: {
      type: "string",
      title: "Base Policy Id",
    },
    total_premium: {
      type: "integer",
      title: "Total Premium",
    },
    policy_status: {
      type: "string",
      title: "Policy Status",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    report_metadata: {
      $ref: "#/components/schemas/CommericalReportMetadata",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
    layer: {
      anyOf: [
        {
          $ref: "#/components/schemas/LayerSummary",
        },
        {
          type: "null",
        },
      ],
    },
    application_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Application Url",
    },
  },
  type: "object",
  required: [
    "base_policy_id",
    "total_premium",
    "policy_status",
    "report_id",
    "lob",
    "report_metadata",
    "created_at_ts",
    "assignee",
    "status",
    "broker_contact",
    "google_group_email",
    "layer",
    "application_url",
  ],
  title: "PolicyFlyApplicationRow",
} as const;

export const $PolicyFlyInfo = {
  properties: {
    applications: {
      items: {
        $ref: "#/components/schemas/PolicyFlyApplication",
      },
      type: "array",
      title: "Applications",
    },
  },
  type: "object",
  required: ["applications"],
  title: "PolicyFlyInfo",
} as const;

export const $PolicyFootprint = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    named_insured: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Named Insured",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    locations: {
      type: "integer",
      title: "Locations",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    by_state: {
      items: {
        $ref: "#/components/schemas/PlaceExposure",
      },
      type: "array",
      title: "By State",
    },
    by_county: {
      items: {
        $ref: "#/components/schemas/PlaceExposure",
      },
      type: "array",
      title: "By County",
    },
  },
  type: "object",
  required: [
    "report_id",
    "named_insured",
    "status",
    "locations",
    "tiv",
    "by_state",
    "by_county",
  ],
  title: "PolicyFootprint",
  description: `Where one policy's locations actually sit.

Deliberately unfiltered by geography or status: the question is the whole
spread of this policy, which is what makes a concentrated schedule
distinguishable from a national one.`,
} as const;

export const $PolicyFootprintRequest = {
  properties: {
    lob: {
      type: "string",
      title: "Lob",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["lob", "report_id"],
  title: "PolicyFootprintRequest",
} as const;

export const $PolicyInfo = {
  properties: {
    selected_policy_form_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Selected Policy Form Name",
    },
    included_perils: {
      items: {
        anyOf: [
          {
            type: "string",
            enum: [
              "aop",
              "earthquake",
              "earth_movement",
              "named_storm",
              "scs",
              "flood",
              "wildfire",
              "equipment_breakdown",
            ],
          },
          {
            type: "string",
            const: "wind_and_hail",
          },
        ],
      },
      type: "array",
      title: "Included Perils",
    },
    peril_sentence_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Peril Sentence Override",
    },
    home_state_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Home State Override",
    },
    deal_broker_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Deal Broker Name",
    },
    valuation_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/ValuationInfo",
        },
        {
          type: "null",
        },
      ],
    },
    form_selection: {
      anyOf: [
        {
          type: "string",
          enum: ["ISO", "Co-Participation", "Manuscript"],
        },
        {
          type: "null",
        },
      ],
      title: "Form Selection",
    },
    tria_selection: {
      anyOf: [
        {
          type: "string",
          enum: ["Accepted", "Rejected"],
        },
        {
          type: "null",
        },
      ],
      title: "Tria Selection",
    },
    broker_commission_percentage: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Commission Percentage",
    },
    reinsurer_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReinsurerInfo",
        },
        {
          type: "null",
        },
      ],
    },
    peril_sources: {
      anyOf: [
        {
          additionalProperties: {
            type: "string",
            enum: ["air", "rms", "spatialkat", "rms_22", "rms_22_air_50_50"],
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Peril Sources",
    },
    surge_association: {
      type: "string",
      enum: ["wind", "flood", "none", "pinned"],
      title: "Surge Association",
      default: "wind",
    },
    edited_fields: {
      items: {
        type: "string",
      },
      type: "array",
      uniqueItems: true,
      title: "Edited Fields",
    },
  },
  type: "object",
  required: ["selected_policy_form_name", "included_perils"],
  title: "PolicyInfo",
} as const;

export const $PolicyQuestion = {
  properties: {
    question: {
      type: "string",
      title: "Question",
    },
    short_answer: {
      type: "string",
      title: "Short Answer",
    },
    long_answer: {
      type: "string",
      title: "Long Answer",
    },
    question_id: {
      type: "string",
      title: "Question Id",
    },
    excerpt: {
      type: "string",
      title: "Excerpt",
    },
    confidence: {
      type: "string",
      title: "Confidence",
    },
    page_location: {
      type: "string",
      title: "Page Location",
    },
  },
  type: "object",
  required: [
    "question",
    "short_answer",
    "long_answer",
    "question_id",
    "excerpt",
    "confidence",
    "page_location",
  ],
  title: "PolicyQuestion",
} as const;

export const $PolicyQuestionAndAnswer = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    question: {
      type: "string",
      title: "Question",
    },
    answer: {
      type: "string",
      title: "Answer",
    },
    answer_type: {
      type: "string",
      enum: ["Yes", "No", "N/A"],
      title: "Answer Type",
    },
    excerpt: {
      type: "string",
      title: "Excerpt",
    },
  },
  type: "object",
  required: ["id", "question", "answer", "answer_type", "excerpt"],
  title: "PolicyQuestionAndAnswer",
} as const;

export const $PolicyQuestionsForDocuments = {
  properties: {
    questions_by_file: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionsForFile",
      },
      type: "array",
      title: "Questions By File",
    },
  },
  type: "object",
  required: ["questions_by_file"],
  title: "PolicyQuestionsForDocuments",
} as const;

export const $PolicyQuestionsForFile = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    questions_by_section: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionsForSection",
      },
      type: "array",
      title: "Questions By Section",
    },
  },
  type: "object",
  required: ["filename", "questions_by_section"],
  title: "PolicyQuestionsForFile",
} as const;

export const $PolicyQuestionsForSection = {
  properties: {
    section: {
      type: "string",
      title: "Section",
    },
    questions: {
      items: {
        $ref: "#/components/schemas/PolicyQuestionAndAnswer",
      },
      type: "array",
      title: "Questions",
    },
  },
  type: "object",
  required: ["section", "questions"],
  title: "PolicyQuestionsForSection",
} as const;

export const $PortfolioGateAccumulationResponse = {
  properties: {
    breakpoints: {
      items: {
        $ref: "#/components/schemas/GateBreakpoint",
      },
      type: "array",
      title: "Breakpoints",
    },
    bars: {
      items: {
        $ref: "#/components/schemas/GateTrackingBar",
      },
      type: "array",
      title: "Bars",
    },
  },
  type: "object",
  required: ["breakpoints", "bars"],
  title: "PortfolioGateAccumulationResponse",
} as const;

export const $PrecheckResponse = {
  properties: {
    cat: {
      $ref: "#/components/schemas/CatPrecheckResponse",
    },
    rater: {
      $ref: "#/components/schemas/RatePrecheckResponse",
    },
  },
  type: "object",
  required: ["cat", "rater"],
  title: "PrecheckResponse",
} as const;

export const $PrecomputedMetadata = {
  properties: {
    num_locations: {
      type: "integer",
      title: "Num Locations",
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    unique_location_states: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Unique Location States",
    },
    appetite: {
      anyOf: [
        {
          $ref: "#/components/schemas/Appetite",
        },
        {
          type: "null",
        },
      ],
    },
    matching_reports_by_addresses: {
      anyOf: [
        {
          $ref: "#/components/schemas/MatchingReportsByAddresses",
        },
        {
          type: "null",
        },
      ],
    },
    premium_categories: {
      $ref: "#/components/schemas/PerilMultipleCategories",
    },
    foreign_exposure_pct: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Foreign Exposure Pct",
    },
  },
  type: "object",
  required: ["num_locations", "total_tiv"],
  title: "PrecomputedMetadata",
} as const;

export const $PremiumError = {
  properties: {
    code: {
      type: "string",
      title: "Code",
    },
    message: {
      type: "string",
      title: "Message",
    },
  },
  type: "object",
  required: ["code", "message"],
  title: "PremiumError",
} as const;

export const $ProtectionData = {
  properties: {
    fire_protection_grade: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Protection Grade",
    },
    fire_protection_class: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Protection Class",
    },
    hydrant_score: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Hydrant Score",
    },
    drive_distance_to_fire_station_miles: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Drive Distance To Fire Station Miles",
    },
    drive_time_to_fire_station_minutes: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Drive Time To Fire Station Minutes",
    },
    fire_station_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Station Type",
    },
  },
  type: "object",
  title: "ProtectionData",
  description: "Protection (P) from COPE — fire protection characteristics.",
} as const;

export const $QuoteIndicationHtmlResponse = {
  properties: {
    subject: {
      type: "string",
      title: "Subject",
    },
    body_html: {
      type: "string",
      title: "Body Html",
    },
  },
  type: "object",
  required: ["subject", "body_html"],
  title: "QuoteIndicationHtmlResponse",
  description: `Rendered quote indication email for the copy-to-clipboard flow.

\`body_html\` matches the Outlook draft body exactly.`,
} as const;

export const $QuoteIndicationPreflight = {
  properties: {
    account_name: {
      type: "string",
      title: "Account Name",
    },
    effective_date: {
      type: "string",
      title: "Effective Date",
    },
    expiration_date: {
      type: "string",
      title: "Expiration Date",
    },
    limit_of_liability: {
      type: "string",
      title: "Limit Of Liability",
    },
    total_insured_value: {
      type: "string",
      title: "Total Insured Value",
    },
    deductibles: {
      items: {
        $ref: "#/components/schemas/DeductibleEntry",
      },
      type: "array",
      title: "Deductibles",
    },
    commission: {
      type: "string",
      title: "Commission",
    },
    bcc: {
      type: "string",
      title: "Bcc",
    },
  },
  type: "object",
  required: [
    "account_name",
    "effective_date",
    "expiration_date",
    "limit_of_liability",
    "total_insured_value",
    "deductibles",
    "commission",
    "bcc",
  ],
  title: "QuoteIndicationPreflight",
} as const;

export const $QuoteIndicationPreflightRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    perils_insured: {
      type: "string",
      title: "Perils Insured",
    },
  },
  type: "object",
  required: ["report_id", "layer_id", "perils_insured"],
  title: "QuoteIndicationPreflightRequest",
  description: `Inputs the frontend computes locally and ships to the backend.

\`perils_insured\` is the peril sentence derived by the frontend's
\`perilSentenceFromEnabledPerils\` helper. The quote letter builder carries
a Python port of the same helper for the letter.`,
} as const;

export const $QuoteUnknownsResponse = {
  properties: {
    unknowns: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Unknowns",
    },
  },
  type: "object",
  required: ["unknowns"],
  title: "QuoteUnknownsResponse",
} as const;

export const $RMSLocationDetail = {
  properties: {
    locationWsDetail: {
      $ref: "#/components/schemas/RMSLocationWsDetail",
    },
    address: {
      $ref: "#/components/schemas/RmsAddressDetail",
    },
  },
  type: "object",
  title: "RMSLocationDetail",
  description: "Subset of the RMS GET location response we care about.",
} as const;

export const $RMSLocationResult = {
  properties: {
    location_id: {
      type: "string",
      title: "Location Id",
      default: "",
    },
    location_number: {
      type: "string",
      title: "Location Number",
      default: "",
    },
    location_name: {
      type: "string",
      title: "Location Name",
      default: "",
    },
    street_address: {
      type: "string",
      title: "Street Address",
      default: "",
    },
    city: {
      type: "string",
      title: "City",
      default: "",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    aal_rl_by_peril: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "object",
      title: "Aal Rl By Peril",
      default: {},
    },
    location_detail: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSLocationDetail",
        },
        {
          type: "null",
        },
      ],
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
  },
  type: "object",
  required: ["address_id"],
  title: "RMSLocationResult",
} as const;

export const $RMSLocationWsDetail = {
  properties: {
    distToCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Disttocoast",
    },
    sysDistToCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sysdisttocoast",
    },
    distToCoastCov: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Disttocoastcov",
    },
    distToCoastMatch: {
      anyOf: [
        {
          $ref: "#/components/schemas/RMSMatchInfo",
        },
        {
          type: "null",
        },
      ],
    },
    distanceToInnerCoast: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Distancetoinnercoast",
    },
    coastalSegment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Coastalsegment",
    },
    windPool: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Windpool",
    },
  },
  type: "object",
  title: "RMSLocationWsDetail",
  description: "Wind-storm detail from the RMS location detail response.",
} as const;

export const $RMSMatchInfo = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
  },
  type: "object",
  required: ["name"],
  title: "RMSMatchInfo",
  description: "RMS hazard match quality indicator (e.g. distToCoastMatch).",
} as const;

export const $RateComponentsAddressEntry = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    premises_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Premises Number",
    },
    location_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Name",
    },
    street_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street Address",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    sic_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sic Code",
    },
    components: {
      additionalProperties: {
        $ref: "#/components/schemas/RateCoverageComponents",
      },
      propertyNames: {
        enum: ["BGI", "BGII", "SCL"],
      },
      type: "object",
      title: "Components",
    },
  },
  type: "object",
  required: ["address_id", "components"],
  title: "RateComponentsAddressEntry",
} as const;

export const $RateComponentsResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/RateComponentsAddressEntry",
      },
      type: "array",
      title: "Addresses",
    },
    coverage_keys: {
      items: {
        type: "string",
        enum: ["BGI", "BGII", "SCL"],
      },
      type: "array",
      title: "Coverage Keys",
    },
  },
  type: "object",
  required: ["addresses", "coverage_keys"],
  title: "RateComponentsResponse",
} as const;

export const $RateCoverageComponents = {
  properties: {
    base_rate: {
      type: "number",
      title: "Base Rate",
    },
    factors: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Factors",
    },
    building_value: {
      type: "number",
      title: "Building Value",
    },
  },
  type: "object",
  required: ["base_rate", "factors", "building_value"],
  title: "RateCoverageComponents",
  description: `Breakdown of a single building coverage (BGI, BGII, SCL).

base_rate is the ISO Loss Cost in dollars per $100 of building value.
factors maps factor name -> multiplier (both Building Premium factors and
the Adj Building factors). A factor > 1 is a debit, < 1 is a credit.
building_value is the insured building exposure in dollars.
The adjusted premium = base_rate * product(factors) * building_value / 100.`,
} as const;

export const $RatePrecheckResponse = {
  properties: {
    warnings: {
      items: {
        $ref: "#/components/schemas/RatePrecheckWarning",
      },
      type: "array",
      title: "Warnings",
    },
  },
  type: "object",
  required: ["warnings"],
  title: "RatePrecheckResponse",
} as const;

export const $RatePrecheckWarning = {
  properties: {
    summary: {
      type: "string",
      title: "Summary",
    },
    detail: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Detail",
    },
    blocking: {
      type: "boolean",
      title: "Blocking",
    },
  },
  type: "object",
  required: ["summary", "detail", "blocking"],
  title: "RatePrecheckWarning",
} as const;

export const $RaterRunSpec = {
  properties: {
    type: {
      type: "string",
      const: "rater",
      title: "Type",
    },
    template_override_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Template Override Id",
    },
    enrichment_source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Enrichment Source",
    },
  },
  type: "object",
  required: ["type", "template_override_id", "enrichment_source"],
  title: "RaterRunSpec",
} as const;

export const $RawAdditionalInterest = {
  properties: {
    entity_name: {
      type: "string",
      title: "Entity Name",
    },
    entity_address: {
      type: "string",
      title: "Entity Address",
    },
    form_name: {
      type: "string",
      title: "Form Name",
    },
    linked_address_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Linked Address Id",
    },
  },
  type: "object",
  required: ["entity_name", "entity_address", "form_name", "linked_address_id"],
  title: "RawAdditionalInterest",
} as const;

export const $RawAddress = {
  properties: {
    street_address: {
      type: "string",
      title: "Street Address",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    country: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country",
    },
    country_scheme: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country Scheme",
    },
    country_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Country Code",
    },
    year_built: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Built",
    },
    sprinkler: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sprinkler",
    },
    building_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Value",
    },
    bpp_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bpp Value",
    },
    tenant_betterments_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tenant Betterments Value",
    },
    signs_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Signs Value",
    },
    bi_excl_ee_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Excl Ee Value",
    },
    bi_incl_ee_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Incl Ee Value",
    },
    furniture_and_fixtures_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Furniture And Fixtures Value",
    },
    inventory_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Inventory Value",
    },
    contractors_equipment_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Contractors Equipment Value",
    },
    outdoor_property_and_autos_value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Outdoor Property And Autos Value",
    },
    number_of_stories: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Stories",
    },
    construction_code_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Code Type",
    },
    construction_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Code",
    },
    construction_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Construction Description",
    },
    occupancy_code_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Code Type",
    },
    occupancy_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Code",
    },
    occupancy_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Description",
    },
    occupancy_description_other: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Occupancy Description Other",
    },
    sic_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sic Code",
    },
    location_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Name",
    },
    location_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location Description",
    },
    lat: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Lat",
    },
    long: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Long",
    },
    number_of_buildings: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Number Of Buildings",
    },
    square_footage: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Square Footage",
    },
    plan_irregularity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Plan Irregularity",
    },
    soft_story: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Soft Story",
    },
    vertical_irregularity: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vertical Irregularity",
    },
    eq_cladding_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eq Cladding Type",
    },
    short_column: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Short Column",
    },
    urm_chimney: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Chimney",
    },
    urm_partition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Partition",
    },
    ornamentation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ornamentation",
    },
    cripple_walls: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cripple Walls",
    },
    frame_bolted_down: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Frame Bolted Down",
    },
    anchoring: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Anchoring",
    },
    urm_retrofit: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Urm Retrofit",
    },
    structural_upgrade: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Structural Upgrade",
    },
    engineered_foundation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Engineered Foundation",
    },
    equipment_eq_bracing: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Eq Bracing",
    },
    eq_construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eq Construction Quality",
    },
    equipment_support_maintenance: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Support Maintenance",
    },
    pounding: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Pounding",
    },
    base_isolation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Base Isolation",
    },
    sprinkler_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sprinkler Type",
    },
    eqsl_susceptibility: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eqsl Susceptibility",
    },
    ws_construction_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ws Construction Quality",
    },
    roof_geometry: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Geometry",
    },
    roof_anchor: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Anchor",
    },
    roof_equipment_hurricane_bracing: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Equipment Hurricane Bracing",
    },
    commercial_appurtenant_structures: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Commercial Appurtenant Structures",
    },
    roof_covering: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Covering",
    },
    roof_age_or_condition: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Age Or Condition",
    },
    ws_cladding_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ws Cladding Type",
    },
    roof_sheathing_attachment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roof Sheathing Attachment",
    },
    frame_foundation_connection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Frame Foundation Connection",
    },
    residential_appurtenant_structures: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Residential Appurtenant Structures",
    },
    ground_level_equipment: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Level Equipment",
    },
    opening_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Opening Protection",
    },
    flashing_and_coping_quality: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flashing And Coping Quality",
    },
    floor_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Floor Type",
    },
    flood_missiles: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Missiles",
    },
    flood_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Protection",
    },
    basement_protection: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Basement Protection",
    },
    vertical_exposure_distribution: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Vertical Exposure Distribution",
    },
    bi_preparedness: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Preparedness",
    },
    bi_redundancy: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Redundancy",
    },
    flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Zone",
    },
    wiring_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wiring Year",
    },
    plumbing_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Plumbing Year",
    },
    roofing_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Roofing Year",
    },
    heating_year: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Heating Year",
    },
    fire_alarm_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fire Alarm Type",
    },
    burglar_alarm_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Burglar Alarm Type",
    },
    premises_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Premises Number",
    },
    building_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Building Number",
    },
    geocoded_street_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Street Address",
    },
    geocoded_city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded City",
    },
    geocoded_county: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded County",
    },
    geocoded_state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded State",
    },
    geocoded_zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Zip",
    },
    geocoded_country: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoded Country",
    },
  },
  type: "object",
  required: ["street_address", "tiv"],
  title: "RawAddress",
} as const;

export const $RawCompanyInfo = {
  properties: {
    company_name: {
      type: "string",
      title: "Company Name",
    },
    company_description: {
      type: "string",
      title: "Company Description",
    },
    company_industry: {
      type: "string",
      title: "Company Industry",
    },
    effective_date: {
      type: "string",
      title: "Effective Date",
    },
    broker_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Name",
    },
    broker_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Email",
    },
    broker_agent_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Agent Name",
    },
    named_insured: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Named Insured",
    },
    additional_named_insureds: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Additional Named Insureds",
    },
    dba: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Dba",
    },
    entity_type: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Entity Type",
    },
    expiration_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Expiration Date",
    },
    files_received_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Files Received Date",
    },
    business_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Business Description",
    },
    years_in_business: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Years In Business",
    },
    company_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Address",
    },
    company_city: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company City",
    },
    company_state: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company State",
    },
    company_zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Zip",
    },
    target_premium: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Target Premium",
    },
    quote_by_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Quote By Date",
    },
    year_of_incorporation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Year Of Incorporation",
    },
  },
  type: "object",
  required: [
    "company_name",
    "company_description",
    "company_industry",
    "effective_date",
  ],
  title: "RawCompanyInfo",
} as const;

export const $ReferralText = {
  properties: {
    text: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Text",
    },
  },
  type: "object",
  required: ["text"],
  title: "ReferralText",
} as const;

export const $ReinsurerInfo = {
  properties: {
    ren_percentage: {
      type: "number",
      title: "Ren Percentage",
      default: 50,
    },
    nephila_percentage: {
      type: "number",
      title: "Nephila Percentage",
      default: 35,
    },
    starr_percentage: {
      type: "number",
      title: "Starr Percentage",
      default: 15,
    },
  },
  type: "object",
  required: ["ren_percentage", "nephila_percentage", "starr_percentage"],
  title: "ReinsurerInfo",
  description: `Per-account reinsurer participation percentages, sent to PolicyFly as the
application's insuring companies.`,
} as const;

export const $RenderedBorEmail = {
  properties: {
    email_type: {
      type: "string",
      enum: [
        "notice_to_current",
        "ack_to_blocked",
        "finalized_clear_to_new",
        "finalized_block_to_former",
        "rescind_to_current",
        "rescind_to_blocked",
      ],
      title: "Email Type",
    },
    target_report_id: {
      type: "string",
      title: "Target Report Id",
    },
    subject: {
      type: "string",
      title: "Subject",
    },
    body_html: {
      type: "string",
      title: "Body Html",
    },
    recipients: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Recipients",
    },
  },
  type: "object",
  required: [
    "email_type",
    "target_report_id",
    "subject",
    "body_html",
    "recipients",
  ],
  title: "RenderedBorEmail",
} as const;

export const $ReportActionLogEntryResponse = {
  properties: {
    id: {
      type: "integer",
      title: "Id",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "User Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    timestamp: {
      type: "string",
      title: "Timestamp",
    },
    action_type: {
      type: "string",
      enum: [
        "EMAIL_RECEIVED",
        "REPORT_CREATED",
        "EMAIL_ADDED_TO_REPORT",
        "EMAIL_REJECTED_INVALID_SENDER",
        "EMAIL_REJECTED_DUPLICATE",
        "EMAIL_REJECTED_NO_ATTACHMENTS",
        "EMAIL_REJECTED_REPLY_THREAD",
        "UPDATE_REPORT",
        "STATUS_CHANGED",
        "ASSIGNEE_CHANGED",
        "UPDATE_ADDRESSES",
        "INTEGRATION_JOB_ENQUEUED",
        "INTEGRATION_JOB_STARTED",
        "INTEGRATION_JOB_COMPLETED",
        "INTEGRATION_JOB_FAILED",
        "CLEARANCE_EMAIL_SENT",
        "QUOTE_INDICATION_DRAFTED",
        "REFERRAL_DRAFTED",
        "ATTACHMENT_UPLOADED",
        "ATTACHMENT_DELETED",
        "COMMENT_ADDED",
        "COMMENT_EDITED",
        "COMMENT_DELETED",
        "BOR_CREATED",
        "BOR_FINALIZED",
        "BOR_RESCINDED",
        "BOR_EMAIL_SENT",
        "CAT_RUN_ACTIVATED",
        "QUEUE_PRIORITY_CHANGED",
      ],
      title: "Action Type",
    },
    metadata: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Metadata",
    },
  },
  type: "object",
  required: [
    "id",
    "email_message_id",
    "report_id",
    "user_id",
    "client_id",
    "timestamp",
    "action_type",
    "metadata",
  ],
  title: "ReportActionLogEntryResponse",
} as const;

export const $ReportActionSummaryWithName = {
  properties: {
    report_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Report Id",
    },
    company_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Company Name",
    },
    email_message_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Message Id",
    },
    email_subject: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Email Subject",
    },
    sender: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sender",
    },
    latest_action_type: {
      type: "string",
      enum: [
        "EMAIL_RECEIVED",
        "REPORT_CREATED",
        "EMAIL_ADDED_TO_REPORT",
        "EMAIL_REJECTED_INVALID_SENDER",
        "EMAIL_REJECTED_DUPLICATE",
        "EMAIL_REJECTED_NO_ATTACHMENTS",
        "EMAIL_REJECTED_REPLY_THREAD",
        "UPDATE_REPORT",
        "STATUS_CHANGED",
        "ASSIGNEE_CHANGED",
        "UPDATE_ADDRESSES",
        "INTEGRATION_JOB_ENQUEUED",
        "INTEGRATION_JOB_STARTED",
        "INTEGRATION_JOB_COMPLETED",
        "INTEGRATION_JOB_FAILED",
        "CLEARANCE_EMAIL_SENT",
        "QUOTE_INDICATION_DRAFTED",
        "REFERRAL_DRAFTED",
        "ATTACHMENT_UPLOADED",
        "ATTACHMENT_DELETED",
        "COMMENT_ADDED",
        "COMMENT_EDITED",
        "COMMENT_DELETED",
        "BOR_CREATED",
        "BOR_FINALIZED",
        "BOR_RESCINDED",
        "BOR_EMAIL_SENT",
        "CAT_RUN_ACTIVATED",
        "QUEUE_PRIORITY_CHANGED",
      ],
      title: "Latest Action Type",
    },
    latest_timestamp: {
      type: "string",
      title: "Latest Timestamp",
    },
    action_count: {
      type: "integer",
      title: "Action Count",
    },
  },
  type: "object",
  required: ["latest_action_type", "latest_timestamp", "action_count"],
  title: "ReportActionSummaryWithName",
} as const;

export const $ReportBeingUpdated = {
  properties: {
    update_id: {
      type: "string",
      title: "Update Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    running_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Running User Id",
    },
    start_time: {
      type: "string",
      format: "date-time",
      title: "Start Time",
    },
    outcome: {
      anyOf: [
        {
          type: "string",
          enum: ["success", "failure"],
        },
        {
          type: "null",
        },
      ],
      title: "Outcome",
    },
    integration_type: {
      type: "string",
      title: "Integration Type",
    },
    policy_fly_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Fly Url",
    },
    error_description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Error Description",
    },
  },
  type: "object",
  required: [
    "update_id",
    "report_id",
    "running_user_id",
    "start_time",
    "outcome",
    "integration_type",
  ],
  title: "ReportBeingUpdated",
} as const;

export const $ReportClearanceEntry = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    fix_sov: {
      anyOf: [
        {
          $ref: "#/components/schemas/FixSovRunSummary",
        },
        {
          type: "null",
        },
      ],
    },
    review: {
      anyOf: [
        {
          $ref: "#/components/schemas/ClearanceReview",
        },
        {
          type: "null",
        },
      ],
    },
    updated_at_ts: {
      type: "string",
      format: "date-time",
      title: "Updated At Ts",
    },
  },
  type: "object",
  required: ["report_id", "fix_sov", "review", "updated_at_ts"],
  title: "ReportClearanceEntry",
} as const;

export const $ReportContact = {
  properties: {
    id: {
      type: "string",
      format: "uuid",
      title: "Id",
    },
    contact_type: {
      $ref: "#/components/schemas/ContactType",
    },
    email: {
      type: "string",
      title: "Email",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  required: [
    "id",
    "contact_type",
    "email",
    "organization_name",
    "full_name",
    "office_phone",
    "cell_phone",
    "role",
  ],
  title: "ReportContact",
} as const;

export const $ReportJobBatchEntry = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    report_id: {
      type: "string",
      title: "Report Id",
    },
    integration_type: {
      type: "string",
      title: "Integration Type",
    },
    outcome: {
      anyOf: [
        {
          type: "string",
          enum: ["success", "failure"],
        },
        {
          type: "null",
        },
      ],
      title: "Outcome",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    finished_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Finished At",
    },
    env: {
      type: "string",
      title: "Env",
    },
    initiating_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Initiating User Id",
    },
    jobs: {
      items: {
        $ref: "#/components/schemas/ReportJobEntry",
      },
      type: "array",
      title: "Jobs",
    },
    priority: {
      type: "integer",
      title: "Priority",
    },
    blocked_by_kinds: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Blocked By Kinds",
    },
  },
  type: "object",
  required: [
    "batch_id",
    "report_id",
    "integration_type",
    "outcome",
    "started_at",
    "finished_at",
    "env",
    "initiating_user_id",
    "jobs",
    "priority",
    "blocked_by_kinds",
  ],
  title: "ReportJobBatchEntry",
} as const;

export const $ReportJobEntry = {
  properties: {
    report_integration_id: {
      type: "string",
      title: "Report Integration Id",
    },
    topic: {
      type: "string",
      title: "Topic",
    },
    status: {
      $ref: "#/components/schemas/WorkStatus",
    },
    started_at: {
      type: "string",
      format: "date-time",
      title: "Started At",
    },
    queue_position: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Queue Position",
    },
    sleeping_until: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Sleeping Until",
    },
    priority: {
      type: "integer",
      title: "Priority",
    },
    response: {
      anyOf: [
        {
          additionalProperties: true,
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Response",
    },
    icm_progress: {
      anyOf: [
        {
          $ref: "#/components/schemas/IcmJobProgress",
        },
        {
          type: "null",
        },
      ],
    },
    cat_metadata: {
      anyOf: [
        {
          $ref: "#/components/schemas/CatMetadata",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "report_integration_id",
    "topic",
    "status",
    "started_at",
    "queue_position",
    "sleeping_until",
    "priority",
    "response",
    "icm_progress",
    "cat_metadata",
  ],
  title: "ReportJobEntry",
} as const;

export const $ReportMetadataResponse = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    report_metadata: {
      $ref: "#/components/schemas/CommericalReportMetadata",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
    attachment_mappings: {
      items: {
        type: "string",
        enum: [
          "sov_spreadsheet",
          "acord_app",
          "loss_run",
          "none",
          "screenshot",
          "rater",
          "loss_control_report",
          "policy_document",
          "manuscript_form",
          "final_manuscript_form",
          "specs_sheet",
          "record_keeping",
          "luminor_quote",
          "luminor_tria",
          "luminor_binder",
          "luminor_policy",
          "lead_quote",
          "lead_binder",
          "lead_policy",
          "bound_sov",
          "sl_letter",
          "endorsement_file",
          "endorsement_sov",
          "engineering_report",
          "rate_matrix",
          "form_review",
        ],
      },
      type: "array",
      title: "Attachment Mappings",
    },
    ready_for_issuance: {
      type: "boolean",
      title: "Ready For Issuance",
    },
    share_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Share Premium",
    },
    has_underwriting_rationale: {
      type: "boolean",
      title: "Has Underwriting Rationale",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "report_metadata",
    "created_at_ts",
    "modified_at_ts",
    "assignee",
    "status",
    "additional_assignees",
    "broker_contact",
    "google_group_email",
    "attachment_mappings",
    "ready_for_issuance",
    "share_premium",
    "has_underwriting_rationale",
  ],
  title: "ReportMetadataResponse",
} as const;

export const $ReportPolicyApplicationsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "ReportPolicyApplicationsRequest",
} as const;

export const $ReportResponse = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    policy_number: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Policy Number",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    email_subject: {
      type: "string",
      title: "Email Subject",
    },
    report_json: {
      $ref: "#/components/schemas/CommercialReport",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    modified_at_ts: {
      type: "string",
      format: "date-time",
      title: "Modified At Ts",
    },
    review_info: {
      $ref: "#/components/schemas/ReviewInfo",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    precomputed_metadata: {
      $ref: "#/components/schemas/PrecomputedMetadata",
    },
    auto_assignment_style: {
      anyOf: [
        {
          $ref: "#/components/schemas/AutoAssignmentStyle",
        },
        {
          type: "null",
        },
      ],
    },
    broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReportContact",
        },
        {
          type: "null",
        },
      ],
    },
    google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Google Group Email",
    },
    underwriting_rationale: {
      anyOf: [
        {
          $ref: "#/components/schemas/UnderwritingRationale",
        },
        {
          type: "null",
        },
      ],
    },
    term_wording: {
      $ref: "#/components/schemas/TermWording",
    },
  },
  type: "object",
  required: [
    "report_id",
    "policy_number",
    "lob",
    "email_subject",
    "report_json",
    "created_at_ts",
    "modified_at_ts",
    "review_info",
    "assignee",
    "status",
    "additional_assignees",
    "precomputed_metadata",
    "auto_assignment_style",
    "broker_contact",
    "google_group_email",
    "underwriting_rationale",
    "term_wording",
  ],
  title: "ReportResponse",
} as const;

export const $RerunAttachmentOption = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    is_parsed: {
      type: "boolean",
      title: "Is Parsed",
    },
  },
  type: "object",
  required: ["name", "is_parsed"],
  title: "RerunAttachmentOption",
} as const;

export const $RerunComponent = {
  type: "string",
  enum: ["sov", "loss_run", "loss_control", "policy_terms", "policy_questions"],
  title: "RerunComponent",
  description: `A report component that a partial rerun can reprocess in isolation.

The mapping of which attachment types each component reads, and which
attachment changes can be narrowed to which components, lives next to the
parsers in \`\`parse_attachments.py\`\`.`,
} as const;

export const $RerunComponentOptions = {
  properties: {
    component: {
      $ref: "#/components/schemas/RerunComponent",
    },
    attachments: {
      items: {
        $ref: "#/components/schemas/RerunAttachmentOption",
      },
      type: "array",
      title: "Attachments",
    },
  },
  type: "object",
  required: ["component", "attachments"],
  title: "RerunComponentOptions",
} as const;

export const $RerunOptionsResponse = {
  properties: {
    components: {
      items: {
        $ref: "#/components/schemas/RerunComponentOptions",
      },
      type: "array",
      title: "Components",
    },
  },
  type: "object",
  required: ["components"],
  title: "RerunOptionsResponse",
} as const;

export const $ResolvedField = {
  properties: {
    key: {
      type: "string",
      title: "Key",
    },
    section: {
      type: "string",
      title: "Section",
    },
    order: {
      type: "integer",
      title: "Order",
    },
    label: {
      type: "string",
      title: "Label",
    },
    value: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "integer",
        },
        {
          type: "number",
        },
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Value",
    },
    editable: {
      type: "boolean",
      title: "Editable",
    },
    input_type: {
      type: "string",
      enum: ["text", "number", "boolean", "select"],
      title: "Input Type",
    },
    options: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Options",
    },
    removable: {
      type: "boolean",
      title: "Removable",
    },
    required: {
      type: "boolean",
      title: "Required",
    },
    source: {
      $ref: "#/components/schemas/FieldSource",
    },
  },
  type: "object",
  required: [
    "key",
    "section",
    "order",
    "label",
    "value",
    "editable",
    "input_type",
    "options",
    "removable",
    "required",
    "source",
  ],
  title: "ResolvedField",
  description:
    "A projected field after the overlay is applied, carrying its source.",
} as const;

export const $ResolvedLayerPremium = {
  properties: {
    layer_id: {
      type: "string",
      title: "Layer Id",
    },
    starting_point: {
      type: "integer",
      title: "Starting Point",
    },
    range: {
      type: "integer",
      title: "Range",
    },
    participation: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Participation",
    },
    target: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Target",
    },
    layer_total: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Layer Total",
    },
    share_total: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Share Total",
    },
    has_missing_data: {
      type: "boolean",
      title: "Has Missing Data",
    },
    peril_types: {
      additionalProperties: {
        $ref: "#/components/schemas/ResolvedPerilPremium",
      },
      type: "object",
      title: "Peril Types",
    },
    cat_loss_ratio_by_strategy: {
      additionalProperties: {
        type: "number",
      },
      propertyNames: {
        enum: [
          "rms25+katrisk",
          "air+katrisk",
          "rms22+katrisk",
          "rms22/air+katrisk",
        ],
      },
      type: "object",
      title: "Cat Loss Ratio By Strategy",
      description: `
    Cat loss ratio (modeled AAL / premium) for each modeling "strategy."
    This only includes AAL and premium allocated to cat perils.
    Strategies with incomplete modeling results are omitted entirely.`,
    },
  },
  type: "object",
  required: [
    "layer_id",
    "starting_point",
    "range",
    "participation",
    "target",
    "layer_total",
    "share_total",
    "has_missing_data",
    "peril_types",
    "cat_loss_ratio_by_strategy",
  ],
  title: "ResolvedLayerPremium",
} as const;

export const $ResolvedPerilPremium = {
  properties: {
    resolved_layer_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Resolved Layer Aal",
    },
    resolved_share_aal: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Resolved Share Aal",
    },
    layer_premium: {
      type: "number",
      title: "Layer Premium",
    },
    share_premium: {
      type: "number",
      title: "Share Premium",
    },
  },
  type: "object",
  required: [
    "resolved_layer_aal",
    "resolved_share_aal",
    "layer_premium",
    "share_premium",
  ],
  title: "ResolvedPerilPremium",
  description: `Resolved view of one peril type, stripped of vendor data: no source
names, no per-vendor breakdowns. The resolved AAL is deliberately
unattributed — callers can't tell which model produced it.`,
} as const;

export const $ResolvedPremiumsResponse = {
  properties: {
    layers: {
      items: {
        $ref: "#/components/schemas/ResolvedLayerPremium",
      },
      type: "array",
      title: "Layers",
    },
    errors: {
      items: {
        $ref: "#/components/schemas/PremiumError",
      },
      type: "array",
      title: "Errors",
      default: [],
    },
  },
  type: "object",
  required: ["layers"],
  title: "ResolvedPremiumsResponse",
} as const;

export const $ReviewInfo = {
  properties: {
    responses: {
      additionalProperties: {
        $ref: "#/components/schemas/ReviewQuestionResponse",
      },
      type: "object",
      title: "Responses",
      default: {},
    },
  },
  type: "object",
  title: "ReviewInfo",
} as const;

export const $ReviewQuestionResponse = {
  properties: {
    question_id: {
      type: "string",
      title: "Question Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    warning_message: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Warning Message",
    },
    last_updated_ts: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Updated Ts",
    },
    last_updated_user_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Last Updated User Id",
    },
  },
  type: "object",
  required: ["question_id", "status"],
  title: "ReviewQuestionResponse",
} as const;

export const $RmsAddressDetail = {
  properties: {
    zone1: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone1",
    },
    zone2: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone2",
    },
    zone3: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zone3",
    },
  },
  type: "object",
  title: "RmsAddressDetail",
} as const;

export const $RoofMaterialBreakdown = {
  properties: {
    survey_date: {
      type: "string",
      title: "Survey Date",
    },
    system_version: {
      type: "string",
      title: "System Version",
    },
    geomatched_address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geomatched Address",
    },
    roofs: {
      items: {
        $ref: "#/components/schemas/RoofMaterials",
      },
      type: "array",
      title: "Roofs",
    },
    shares: {
      items: {
        $ref: "#/components/schemas/MaterialShare",
      },
      type: "array",
      title: "Shares",
    },
    unclassified_ratio: {
      type: "number",
      title: "Unclassified Ratio",
    },
  },
  type: "object",
  required: [
    "survey_date",
    "system_version",
    "geomatched_address",
    "roofs",
    "shares",
    "unclassified_ratio",
  ],
  title: "RoofMaterialBreakdown",
  description: `Roof materials for one location.

\`\`roofs\`\` holds the roofs attributed to the location, largest-roof-first:
every roof on the parcel for a parcel query, only the roof containing the
point (else the nearest) for a point query. \`\`shares\`\` is the area-weighted
mix across those roofs and \`\`top_material\`\` the material holding the most
of that area.`,
} as const;

export const $RoofMaterials = {
  properties: {
    roof_id: {
      type: "string",
      title: "Roof Id",
    },
    area_sqm: {
      type: "number",
      title: "Area Sqm",
    },
    confidence: {
      type: "number",
      title: "Confidence",
    },
    shares: {
      items: {
        $ref: "#/components/schemas/MaterialShare",
      },
      type: "array",
      title: "Shares",
    },
    unclassified_ratio: {
      type: "number",
      title: "Unclassified Ratio",
    },
  },
  type: "object",
  required: [
    "roof_id",
    "area_sqm",
    "confidence",
    "shares",
    "unclassified_ratio",
  ],
  title: "RoofMaterials",
  description: `Material mix of one roof. \`\`shares\`\` lists detected materials only,
largest share first (ties broken by confidence).`,
} as const;

export const $RunFixSovRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    instructions: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Instructions",
    },
  },
  type: "object",
  required: ["report_id", "instructions"],
  title: "RunFixSovRequest",
} as const;

export const $RunFixSovResponse = {
  properties: {
    task_id: {
      type: "string",
      title: "Task Id",
    },
  },
  type: "object",
  required: ["task_id"],
  title: "RunFixSovResponse",
} as const;

export const $SOV = {
  properties: {
    sov_id: {
      type: "string",
      title: "Sov Id",
    },
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
    is_enabled: {
      type: "boolean",
      title: "Is Enabled",
    },
    is_manual: {
      type: "boolean",
      title: "Is Manual",
      default: false,
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    sov_type: {
      anyOf: [
        {
          type: "string",
          enum: ["bound", "submission", "endorsement"],
        },
        {
          type: "null",
        },
      ],
      title: "Sov Type",
    },
    all_document_headers: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "All Document Headers",
    },
    column_mappings: {
      anyOf: [
        {
          additionalProperties: {
            $ref: "#/components/schemas/MappingInfo",
          },
          type: "object",
        },
        {
          type: "null",
        },
      ],
      title: "Column Mappings",
    },
    tiv_totals_match_on_ingest: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Totals Match On Ingest",
    },
    tiv_target_source: {
      anyOf: [
        {
          type: "string",
          enum: ["email", "spreadsheet"],
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Target Source",
    },
    reconciliation_function: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Reconciliation Function",
    },
    tiv_reconciliation_explanation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tiv Reconciliation Explanation",
    },
  },
  type: "object",
  required: ["sov_id", "addresses", "is_enabled", "filename"],
  title: "SOV",
} as const;

export const $SaveQuoteTemplateResponse = {
  properties: {
    customized: {
      type: "boolean",
      title: "Customized",
    },
  },
  type: "object",
  required: ["customized"],
  title: "SaveQuoteTemplateResponse",
} as const;

export const $SavedFilter = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    url: {
      type: "string",
      title: "Url",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
  },
  type: "object",
  required: ["id", "url", "nickname", "is_default"],
  title: "SavedFilter",
} as const;

export const $SendClearanceEmailRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
  },
  type: "object",
  required: ["report_id", "status"],
  title: "SendClearanceEmailRequest",
} as const;

export const $SetBatchPriorityRequest = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
    priority: {
      type: "integer",
      enum: [-20, -10, 0, 10],
      title: "Priority",
    },
  },
  type: "object",
  required: ["batch_id", "priority"],
  title: "SetBatchPriorityRequest",
} as const;

export const $SetBatchPriorityResponse = {
  properties: {},
  type: "object",
  title: "SetBatchPriorityResponse",
} as const;

export const $SetFunctionInstructionsRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    function_type: {
      type: "string",
      enum: ["limit", "deductible"],
      title: "Function Type",
    },
    instructions: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Instructions",
    },
  },
  type: "object",
  required: ["report_id", "filename", "function_type", "instructions"],
  title: "SetFunctionInstructionsRequest",
} as const;

export const $SetFunctionInstructionsResponse = {
  properties: {
    instructions: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Instructions",
    },
  },
  type: "object",
  required: ["instructions"],
  title: "SetFunctionInstructionsResponse",
} as const;

export const $SindriEnqueueRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
  },
  type: "object",
  required: ["report_id"],
  title: "SindriEnqueueRequest",
} as const;

export const $SindriEnqueueResponse = {
  properties: {
    batch_id: {
      type: "string",
      title: "Batch Id",
    },
  },
  type: "object",
  required: ["batch_id"],
  title: "SindriEnqueueResponse",
} as const;

export const $SindriExplanation = {
  properties: {
    itv_ratio: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Itv Ratio",
    },
    itv_ratio_reason: {
      anyOf: [
        {
          type: "string",
          enum: [
            "no_signal",
            "no_building_value",
            "contents_or_leased_indicator",
            "withheld",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Itv Ratio Reason",
    },
    itv_band: {
      anyOf: [
        {
          $ref: "#/components/schemas/SindriItvBand",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: ["itv_ratio", "itv_ratio_reason", "itv_band"],
  title: "SindriExplanation",
} as const;

export const $SindriItvBand = {
  properties: {
    es_low_psf: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Es Low Psf",
    },
    es_high_psf: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Es High Psf",
    },
    position: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Position",
    },
  },
  type: "object",
  required: ["es_low_psf", "es_high_psf", "position"],
  title: "SindriItvBand",
} as const;

export const $SindriRow = {
  properties: {
    address_id: {
      type: "string",
      title: "Address Id",
    },
    luminor_rc: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Luminor Rc",
    },
    display_status: {
      anyOf: [
        {
          type: "string",
          enum: ["show", "show_with_caution", "withhold_pending_review"],
        },
        {
          type: "null",
        },
      ],
      title: "Display Status",
    },
    display_reasons: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Display Reasons",
    },
    display_confidence: {
      anyOf: [
        {
          type: "string",
          enum: ["High", "Standard"],
        },
        {
          type: "null",
        },
      ],
      title: "Display Confidence",
    },
    explanation_text: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Explanation Text",
    },
    insured_building: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Insured Building",
    },
    explanation: {
      anyOf: [
        {
          $ref: "#/components/schemas/SindriExplanation",
        },
        {
          type: "null",
        },
      ],
    },
    failure_reason: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Failure Reason",
    },
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    text_truncated: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Text Truncated",
    },
    error: {
      anyOf: [
        {
          $ref: "#/components/schemas/SindriRowError",
        },
        {
          type: "null",
        },
      ],
    },
  },
  type: "object",
  required: [
    "address_id",
    "luminor_rc",
    "display_status",
    "display_reasons",
    "display_confidence",
    "explanation_text",
    "insured_building",
    "explanation",
    "failure_reason",
    "warnings",
    "text_truncated",
    "error",
  ],
  title: "SindriRow",
  description: `One location's result. A row that failed validation or scoring has
\`\`error\`\` set and null display fields; a row with no value has a null
\`\`luminor_rc\`\` and a \`\`failure_reason\`\`.`,
} as const;

export const $SindriRowError = {
  properties: {
    reason: {
      type: "string",
      title: "Reason",
    },
  },
  type: "object",
  required: ["reason"],
  title: "SindriRowError",
} as const;

export const $SourceDetailInfo = {
  properties: {
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    enabled: {
      type: "boolean",
      title: "Enabled",
    },
  },
  type: "object",
  required: ["source_details", "enabled"],
  title: "SourceDetailInfo",
} as const;

export const $SourceDetails = {
  properties: {
    filename: {
      type: "string",
      title: "Filename",
    },
    sheet_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sheet Name",
    },
    data_type: {
      type: "string",
      enum: ["claim", "summary"],
      title: "Data Type",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    carrier: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Carrier",
    },
  },
  type: "object",
  required: ["filename", "sheet_name", "data_type", "calc_mode", "carrier"],
  title: "SourceDetails",
} as const;

export const $SovDiffLocation = {
  properties: {
    address: {
      type: "string",
      title: "Address",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
  },
  type: "object",
  required: ["address", "tiv"],
  title: "SovDiffLocation",
} as const;

export const $SovDiffRevaluedLocation = {
  properties: {
    address: {
      type: "string",
      title: "Address",
    },
    tiv_before: {
      type: "number",
      title: "Tiv Before",
    },
    tiv_after: {
      type: "number",
      title: "Tiv After",
    },
  },
  type: "object",
  required: ["address", "tiv_before", "tiv_after"],
  title: "SovDiffRevaluedLocation",
} as const;

export const $SpatialKatLocationResult = {
  properties: {
    site_id: {
      type: "string",
      title: "Site Id",
    },
    address_id: {
      type: "string",
      title: "Address Id",
    },
    aal_gu: {
      type: "number",
      title: "Aal Gu",
      default: 0,
    },
    aal_gr: {
      type: "number",
      title: "Aal Gr",
      default: 0,
    },
    aal_net: {
      type: "number",
      title: "Aal Net",
      default: 0,
    },
    aal_gu_by_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Gu By Peril",
      default: {},
    },
    aal_gr_by_peril: {
      additionalProperties: {
        type: "number",
      },
      type: "object",
      title: "Aal Gr By Peril",
      default: {},
    },
    is_foreign_exposure: {
      type: "boolean",
      title: "Is Foreign Exposure",
      default: false,
    },
    fema_flood_zone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Flood Zone",
    },
    fema_zone_subty: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Fema Zone Subty",
    },
    flood_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Flood Score",
    },
    surge_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Surge Score",
    },
    wind_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Score",
    },
    hail_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Hail Score",
    },
    to_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "To Score",
    },
    slw_score: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Slw Score",
    },
  },
  type: "object",
  required: ["site_id", "address_id"],
  title: "SpatialKatLocationResult",
  description: "Per-location AAL result stored in integration_data.",
} as const;

export const $SpatialKeyAddress = {
  properties: {
    "Policy Number": {
      type: "string",
      title: "Policy Number",
    },
    "Named Insured": {
      type: "string",
      title: "Named Insured",
    },
    "Effective Date": {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    "Expiration Date": {
      type: "string",
      format: "date",
      title: "Expiration Date",
    },
    "Location #": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Location #",
    },
    "Bulding#": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bulding#",
    },
    "Street 1": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street 1",
    },
    "Street 2": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Street 2",
    },
    City: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "City",
    },
    State: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "State",
    },
    Zip: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Zip",
    },
    County: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "County",
    },
    BLDG: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bldg",
    },
    BPP: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bpp",
    },
    BI_EE: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Ee",
    },
    BI: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Bi",
    },
    TIB: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Tib",
    },
    SIGNS: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Signs",
    },
    FF: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ff",
    },
    INV: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Inv",
    },
    CE: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ce",
    },
    OPA: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Opa",
    },
    "Total TIV": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    EQPBK: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Eqpbk",
    },
    TRIA: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Tria",
    },
    LNLawOrdA: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlaworda",
    },
    LNLawOrdBC: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlawordbc",
    },
    LNLawOrd: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Lnlaword",
    },
    Valuation: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Valuation",
    },
    Coinsurance: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Coinsurance",
    },
    PTY_WIND_INCL_Y_N: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Pty Wind Incl Y N",
    },
    WIND_DEDUCTIBLE_BASIS: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Basis",
    },
    WIND_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Amount",
    },
    WIND_DEDUCTIBLE_PERCENTAGE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Deductible Percentage",
    },
    AOP_DEDUCTIBLE_BASIS: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Basis",
    },
    AOP_DEDUCTIBLE_PERCENTAGE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Percentage",
    },
    AOP_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Aop Deductible Amount",
    },
    CP_DEDUCTIBLE_AMOUNT: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cp Deductible Amount",
    },
    CP_DEDUCTIBLE_TYPE: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cp Deductible Type",
    },
    "Latitude(SK)": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Latitude(Sk)",
    },
    "Longitude(SK)": {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Longitude(Sk)",
    },
    "Geocoding Accuracy": {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Geocoding Accuracy",
    },
  },
  type: "object",
  required: [
    "Policy Number",
    "Named Insured",
    "Effective Date",
    "Expiration Date",
  ],
  title: "SpatialKeyAddress",
} as const;

export const $StagedAttachment = {
  properties: {
    name: {
      type: "string",
      title: "Name",
    },
    size: {
      type: "integer",
      title: "Size",
    },
  },
  type: "object",
  required: ["name", "size"],
  title: "StagedAttachment",
} as const;

export const $StagedAttachmentSelection = {
  properties: {
    staging_id: {
      type: "string",
      title: "Staging Id",
    },
    attachment_name: {
      type: "string",
      title: "Attachment Name",
    },
    original_classification: {
      type: "string",
      enum: [
        "sov_spreadsheet",
        "acord_app",
        "loss_run",
        "none",
        "screenshot",
        "rater",
        "loss_control_report",
        "policy_document",
        "manuscript_form",
        "final_manuscript_form",
        "specs_sheet",
        "record_keeping",
        "luminor_quote",
        "luminor_tria",
        "luminor_binder",
        "luminor_policy",
        "lead_quote",
        "lead_binder",
        "lead_policy",
        "bound_sov",
        "sl_letter",
        "endorsement_file",
        "endorsement_sov",
        "engineering_report",
        "rate_matrix",
        "form_review",
      ],
      title: "Original Classification",
    },
    manual_classification: {
      anyOf: [
        {
          type: "string",
          enum: [
            "sov_spreadsheet",
            "acord_app",
            "loss_run",
            "none",
            "screenshot",
            "rater",
            "loss_control_report",
            "policy_document",
            "manuscript_form",
            "final_manuscript_form",
            "specs_sheet",
            "record_keeping",
            "luminor_quote",
            "luminor_tria",
            "luminor_binder",
            "luminor_policy",
            "lead_quote",
            "lead_binder",
            "lead_policy",
            "bound_sov",
            "sl_letter",
            "endorsement_file",
            "endorsement_sov",
            "engineering_report",
            "rate_matrix",
            "form_review",
          ],
        },
        {
          type: "null",
        },
      ],
      title: "Manual Classification",
    },
    conversation_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Conversation Id",
    },
  },
  type: "object",
  required: [
    "staging_id",
    "attachment_name",
    "original_classification",
    "manual_classification",
    "conversation_id",
  ],
  title: "StagedAttachmentSelection",
  description: `One attachment the user chose to promote out of a staged email.

\`\`original_classification\`\` is the machine suggestion shown in the dialog;
\`\`manual_classification\`\` is set when the user picked something else (or
when no suggestion could be computed), so the pick survives report reruns
the same way manual reclassification on the attachments tab does.`,
} as const;

export const $StagedEmailManifest = {
  properties: {
    staging_id: {
      type: "string",
      title: "Staging Id",
    },
    filename: {
      type: "string",
      title: "Filename",
    },
    subject: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Subject",
    },
    conversation_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Conversation Id",
    },
    attachments: {
      items: {
        $ref: "#/components/schemas/StagedAttachment",
      },
      type: "array",
      title: "Attachments",
    },
  },
  type: "object",
  required: [
    "staging_id",
    "filename",
    "subject",
    "conversation_id",
    "attachments",
  ],
  title: "StagedEmailManifest",
} as const;

export const $StandardFormattingRequest = {
  properties: {
    text: {
      type: "string",
      title: "Text",
    },
    field: {
      type: "string",
      enum: ["limit", "deductible", "sublimit"],
      title: "Field",
    },
    classification: {
      anyOf: [
        {
          type: "string",
          enum: ["time_limit", "distance_limit", "waiting_period"],
        },
        {
          type: "null",
        },
      ],
      title: "Classification",
    },
  },
  type: "object",
  required: ["text", "field", "classification"],
  title: "StandardFormattingRequest",
} as const;

export const $StateSummary = {
  properties: {
    state: {
      type: "string",
      title: "State",
    },
    total_tiv: {
      type: "number",
      title: "Total Tiv",
    },
    construction_mix: {
      items: {
        $ref: "#/components/schemas/ConstructionMix",
      },
      type: "array",
      title: "Construction Mix",
    },
    occupancy_mix: {
      items: {
        $ref: "#/components/schemas/OccupancyMix",
      },
      type: "array",
      title: "Occupancy Mix",
    },
    year_built_distribution: {
      items: {
        $ref: "#/components/schemas/YearBuiltBand",
      },
      type: "array",
      title: "Year Built Distribution",
    },
  },
  type: "object",
  required: [
    "state",
    "total_tiv",
    "construction_mix",
    "occupancy_mix",
    "year_built_distribution",
  ],
  title: "StateSummary",
} as const;

export const $StatusExposure = {
  properties: {
    status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "Status",
    },
    policies: {
      type: "integer",
      title: "Policies",
    },
    locations: {
      type: "integer",
      title: "Locations",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
  },
  type: "object",
  required: ["status", "policies", "locations", "tiv"],
  title: "StatusExposure",
} as const;

export const $StormWithTrack = {
  properties: {
    storm: {
      $ref: "#/components/schemas/ActiveStorm",
    },
    track: {
      items: {
        $ref: "#/components/schemas/TrackPoint",
      },
      type: "array",
      title: "Track",
    },
    cone: {
      items: {
        $ref: "#/components/schemas/Coordinate",
      },
      type: "array",
      title: "Cone",
    },
  },
  type: "object",
  required: ["storm", "track", "cone"],
  title: "StormWithTrack",
  description:
    "One active storm and the path the NHC currently forecasts for it.",
} as const;

export const $Sublimit = {
  properties: {
    sublimit_name: {
      type: "string",
      title: "Sublimit Name",
    },
    sublimit_description: {
      type: "string",
      title: "Sublimit Description",
    },
    document_excerpt: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Document Excerpt",
    },
    manual_override: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Manual Override",
    },
    is_removed: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Removed",
    },
    classification: {
      anyOf: [
        {
          type: "string",
          enum: ["time_limit", "distance_limit", "waiting_period"],
        },
        {
          type: "null",
        },
      ],
      title: "Classification",
    },
    sort_key: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Sort Key",
    },
    id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
  },
  type: "object",
  required: ["sublimit_name", "sublimit_description", "document_excerpt"],
  title: "Sublimit",
} as const;

export const $SublimitInfo = {
  properties: {
    extracted_sublimits: {
      additionalProperties: {
        items: {
          $ref: "#/components/schemas/Sublimit",
        },
        type: "array",
      },
      type: "object",
      title: "Extracted Sublimits",
    },
    manual_sublimits: {
      items: {
        $ref: "#/components/schemas/Sublimit",
      },
      type: "array",
      title: "Manual Sublimits",
    },
  },
  type: "object",
  required: ["extracted_sublimits", "manual_sublimits"],
  title: "SublimitInfo",
} as const;

export const $SublimitSortEntry = {
  properties: {
    id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Id",
    },
    sublimit_name: {
      type: "string",
      title: "Sublimit Name",
    },
    classification: {
      anyOf: [
        {
          type: "string",
          enum: ["time_limit", "distance_limit", "waiting_period"],
        },
        {
          type: "null",
        },
      ],
      title: "Classification",
    },
    sort_key: {
      type: "string",
      title: "Sort Key",
    },
  },
  type: "object",
  required: ["id", "sublimit_name", "classification", "sort_key"],
  title: "SublimitSortEntry",
} as const;

export const $SublimitSortUpdate = {
  properties: {
    group: {
      type: "string",
      enum: ["manual", "extracted"],
      title: "Group",
    },
    filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Filename",
    },
    entries: {
      items: {
        $ref: "#/components/schemas/SublimitSortEntry",
      },
      type: "array",
      title: "Entries",
    },
  },
  type: "object",
  required: ["group", "filename", "entries"],
  title: "SublimitSortUpdate",
  description: `A reorder of sublimit rows within one displayed group.

\`\`group="manual"\`\` targets \`\`manual_sublimits\`\` (\`\`filename\`\` None);
\`\`group="extracted"\`\` targets a file's \`\`extracted_sublimits\`\`. A reorder
that interleaves manual and extracted rows emits one update per source list.`,
} as const;

export const $SubmissionAnalyticsResponse = {
  properties: {
    reports: {
      items: {
        $ref: "#/components/schemas/SubmissionAnalyticsRow",
      },
      type: "array",
      title: "Reports",
    },
    last_refreshed_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "Last Refreshed At",
    },
  },
  type: "object",
  required: ["reports", "last_refreshed_at"],
  title: "SubmissionAnalyticsResponse",
} as const;

export const $SubmissionAnalyticsRow = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    lob: {
      type: "string",
      title: "Lob",
    },
    status: {
      type: "string",
      title: "Status",
    },
    assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Assignee",
    },
    broker_organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Organization Name",
    },
    broker_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Broker Name",
    },
    mode_sic_prefix: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Mode Sic Prefix",
    },
    mode_construction_code: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Mode Construction Code",
    },
    sum_layer_target_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sum Layer Target Premium",
    },
    sum_policyfly_total_premium: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Sum Policyfly Total Premium",
    },
    total_tiv: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Total Tiv",
    },
    num_locations: {
      anyOf: [
        {
          type: "integer",
        },
        {
          type: "null",
        },
      ],
      title: "Num Locations",
    },
    created_at: {
      type: "string",
      format: "date-time",
      title: "Created At",
    },
    first_bound_at: {
      anyOf: [
        {
          type: "string",
          format: "date-time",
        },
        {
          type: "null",
        },
      ],
      title: "First Bound At",
    },
    furthest_stage: {
      type: "integer",
      title: "Furthest Stage",
    },
  },
  type: "object",
  required: [
    "report_id",
    "lob",
    "status",
    "assignee",
    "broker_organization_name",
    "broker_name",
    "mode_sic_prefix",
    "mode_construction_code",
    "sum_layer_target_premium",
    "sum_policyfly_total_premium",
    "total_tiv",
    "num_locations",
    "created_at",
    "first_bound_at",
    "furthest_stage",
  ],
  title: "SubmissionAnalyticsRow",
} as const;

export const $SubmissionStatusCountsResponse = {
  properties: {
    pre_underwriting_review: {
      type: "integer",
      title: "Pre Underwriting Review",
    },
    cleared: {
      type: "integer",
      title: "Cleared",
    },
    in_progress: {
      type: "integer",
      title: "In Progress",
    },
    quoted: {
      type: "integer",
      title: "Quoted",
    },
    bound: {
      type: "integer",
      title: "Bound",
    },
    indicated: {
      type: "integer",
      title: "Indicated",
    },
    quoted_premium: {
      type: "integer",
      title: "Quoted Premium",
    },
    bound_premium: {
      type: "integer",
      title: "Bound Premium",
    },
  },
  type: "object",
  required: [
    "pre_underwriting_review",
    "cleared",
    "in_progress",
    "quoted",
    "bound",
    "indicated",
    "quoted_premium",
    "bound_premium",
  ],
  title: "SubmissionStatusCountsResponse",
} as const;

export const $Template = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    author_id: {
      type: "string",
      title: "Author Id",
    },
    use_case: {
      type: "string",
      title: "Use Case",
    },
    created_at_ts: {
      type: "string",
      format: "date-time",
      title: "Created At Ts",
    },
    template_pointer: {
      type: "string",
      title: "Template Pointer",
    },
    template_name: {
      type: "string",
      title: "Template Name",
    },
    live: {
      anyOf: [
        {
          type: "boolean",
          const: true,
        },
        {
          type: "null",
        },
      ],
      title: "Live",
    },
  },
  type: "object",
  required: [
    "template_id",
    "client_id",
    "author_id",
    "use_case",
    "created_at_ts",
    "template_pointer",
    "template_name",
    "live",
  ],
  title: "Template",
} as const;

export const $TermWording = {
  properties: {
    term: {
      type: "string",
      enum: ["annual", "policy"],
      title: "Term",
    },
    effective_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Effective Date",
    },
    expiration_date: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Expiration Date",
    },
    rewordings: {
      additionalProperties: {
        type: "string",
      },
      type: "object",
      title: "Rewordings",
    },
  },
  type: "object",
  required: ["term", "effective_date", "expiration_date", "rewordings"],
  title: "TermWording",
  description: `How a report's stored limit / sublimit / deductible text prints for its
policy term, so an editor can show the printed text while editing the
stored one (see term_wording).`,
} as const;

export const $TestPythonFunctionRequest = {
  properties: {
    peril_type: {
      type: "string",
      enum: [
        "aop",
        "earthquake",
        "earth_movement",
        "named_storm",
        "scs",
        "flood",
        "wildfire",
        "equipment_breakdown",
      ],
      title: "Peril Type",
    },
    extracted_filename: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Extracted Filename",
    },
    function_type: {
      type: "string",
      enum: ["limit", "deductible"],
      title: "Function Type",
    },
  },
  type: "object",
  required: ["peril_type", "function_type"],
  title: "TestPythonFunctionRequest",
} as const;

export const $TestPythonFunctionResponse = {
  properties: {
    num_addresses_run: {
      type: "integer",
      title: "Num Addresses Run",
    },
  },
  type: "object",
  required: ["num_addresses_run"],
  title: "TestPythonFunctionResponse",
} as const;

export const $TrackPoint = {
  properties: {
    lat: {
      type: "number",
      title: "Lat",
    },
    lon: {
      type: "number",
      title: "Lon",
    },
    tau: {
      type: "integer",
      title: "Tau",
    },
    max_wind_kt: {
      type: "integer",
      title: "Max Wind Kt",
    },
    classification: {
      type: "string",
      title: "Classification",
    },
    label: {
      type: "string",
      title: "Label",
    },
    wind_radius_miles: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Wind Radius Miles",
    },
    radius_50kt_miles: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Radius 50Kt Miles",
    },
    radius_64kt_miles: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Radius 64Kt Miles",
    },
  },
  additionalProperties: false,
  type: "object",
  required: [
    "lat",
    "lon",
    "tau",
    "max_wind_kt",
    "classification",
    "label",
    "wind_radius_miles",
    "radius_50kt_miles",
    "radius_64kt_miles",
  ],
  title: "TrackPoint",
  description: "One forecast position along a storm's track.",
} as const;

export const $UnderwritingRationale = {
  properties: {
    text: {
      type: "string",
      title: "Text",
    },
    last_updated_user_id: {
      type: "string",
      title: "Last Updated User Id",
    },
    last_updated_ts: {
      type: "string",
      format: "date-time",
      title: "Last Updated Ts",
    },
  },
  type: "object",
  required: ["text", "last_updated_user_id", "last_updated_ts"],
  title: "UnderwritingRationale",
} as const;

export const $UnknownCoverageColumnFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "unkonwn_coverage_column",
      title: "Flag Id",
    },
    columns: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Columns",
    },
  },
  type: "object",
  required: ["flag_id", "columns"],
  title: "UnknownCoverageColumnFlag",
} as const;

export const $UnknownInsuranceSubjectFlag = {
  properties: {
    flag_id: {
      type: "string",
      const: "non_property_insurance_value_v2",
      title: "Flag Id",
    },
    subjects: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Subjects",
    },
  },
  type: "object",
  required: ["flag_id", "subjects"],
  title: "UnknownInsuranceSubjectFlag",
} as const;

export const $UnlinkPolicyFlyApplicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
  },
  type: "object",
  required: ["report_id", "suffix"],
  title: "UnlinkPolicyFlyApplicationRequest",
} as const;

export const $UnlinkPolicyFlyApplicationResponse = {
  properties: {
    policy_fly_info: {
      $ref: "#/components/schemas/PolicyFlyInfo",
    },
  },
  type: "object",
  required: ["policy_fly_info"],
  title: "UnlinkPolicyFlyApplicationResponse",
} as const;

export const $UpdateAddressRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["report_id", "addresses"],
  title: "UpdateAddressRequest",
} as const;

export const $UpdateAddressResponse = {
  properties: {
    addresses: {
      items: {
        $ref: "#/components/schemas/Address",
      },
      type: "array",
      title: "Addresses",
    },
  },
  type: "object",
  required: ["addresses"],
  title: "UpdateAddressResponse",
} as const;

export const $UpdateApplicationFormRequest = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    form_id: {
      type: "string",
      title: "Form Id",
    },
    enabled: {
      type: "boolean",
      title: "Enabled",
    },
  },
  type: "object",
  required: ["application_id", "form_id", "enabled"],
  title: "UpdateApplicationFormRequest",
} as const;

export const $UpdateAsignee = {
  properties: {
    new_assignee: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "New Assignee",
    },
  },
  type: "object",
  required: ["new_assignee"],
  title: "UpdateAsignee",
} as const;

export const $UpdateBrokerContact = {
  properties: {
    new_broker_contact_id: {
      type: "string",
      format: "uuid",
      title: "New Broker Contact Id",
    },
  },
  type: "object",
  required: ["new_broker_contact_id"],
  title: "UpdateBrokerContact",
} as const;

export const $UpdateContactRequest = {
  properties: {
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    organization_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Organization Name",
    },
    office_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Office Phone",
    },
    cell_phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Cell Phone",
    },
    role: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Role",
    },
  },
  type: "object",
  title: "UpdateContactRequest",
} as const;

export const $UpdateContactResponse = {
  properties: {
    contact: {
      $ref: "#/components/schemas/ReportContact",
    },
  },
  type: "object",
  required: ["contact"],
  title: "UpdateContactResponse",
} as const;

export const $UpdateEndorsementPremiumRequest = {
  properties: {
    endorsement_id: {
      type: "string",
      format: "uuid",
      title: "Endorsement Id",
    },
    premium_change: {
      $ref: "#/components/schemas/EndorsementPremiumChange",
    },
  },
  type: "object",
  required: ["endorsement_id", "premium_change"],
  title: "UpdateEndorsementPremiumRequest",
} as const;

export const $UpdateEndorsementStatusRequest = {
  properties: {
    endorsement_id: {
      type: "string",
      format: "uuid",
      title: "Endorsement Id",
    },
    status: {
      $ref: "#/components/schemas/EndorsementStatus",
    },
  },
  type: "object",
  required: ["endorsement_id", "status"],
  title: "UpdateEndorsementStatusRequest",
} as const;

export const $UpdateGoogleGroup = {
  properties: {
    new_google_group_email: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "New Google Group Email",
    },
  },
  type: "object",
  required: ["new_google_group_email"],
  title: "UpdateGoogleGroup",
} as const;

export const $UpdatePolicyApplicationRequest = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    status: {
      $ref: "#/components/schemas/PolicyApplicationStatus",
    },
  },
  type: "object",
  required: ["application_id", "status"],
  title: "UpdatePolicyApplicationRequest",
} as const;

export const $UpdatePolicyFlyApplicationRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    suffix: {
      type: "string",
      title: "Suffix",
    },
    perils_insured_description: {
      type: "string",
      title: "Perils Insured Description",
    },
  },
  type: "object",
  required: ["report_id", "suffix", "perils_insured_description"],
  title: "UpdatePolicyFlyApplicationRequest",
} as const;

export const $UpdatePolicyFlyApplicationResponse = {
  properties: {
    task_id: {
      type: "string",
      title: "Task Id",
    },
  },
  type: "object",
  required: ["task_id"],
  title: "UpdatePolicyFlyApplicationResponse",
} as const;

export const $UpdatePolicyOverlayRequest = {
  properties: {
    application_id: {
      type: "string",
      title: "Application Id",
    },
    overlay: {
      $ref: "#/components/schemas/PolicyFieldOverlay",
    },
    notes: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Notes",
    },
  },
  type: "object",
  required: ["application_id", "overlay", "notes"],
  title: "UpdatePolicyOverlayRequest",
} as const;

export const $UpdateReportRequest = {
  properties: {
    report_id: {
      type: "string",
      title: "Report Id",
    },
    update_assignee: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateAsignee",
        },
        {
          type: "null",
        },
      ],
    },
    update_status: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateStatus",
        },
        {
          type: "null",
        },
      ],
    },
    update_additional_assignees: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdditionalAssigneeInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_sovs: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/SOV",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Sovs",
    },
    update_loss_runs_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LossRunInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_review_question_response: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReviewQuestionResponse",
        },
        {
          type: "null",
        },
      ],
    },
    update_company_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/CompanyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_attachment_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AttachmentInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_referral_text: {
      anyOf: [
        {
          $ref: "#/components/schemas/ReferralText",
        },
        {
          type: "null",
        },
      ],
    },
    update_underwriting_rationale: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Update Underwriting Rationale",
    },
    rerun_report: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Rerun Report",
    },
    rerun_components: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/RerunComponent",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Rerun Components",
    },
    rerun_attachments: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Rerun Attachments",
    },
    update_broker_contact: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateBrokerContact",
        },
        {
          type: "null",
        },
      ],
    },
    update_limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/LimitAndSublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_policy_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/PolicyInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_sublimit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/SublimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_deductible_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedDeductibleInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_advanced_limit_info: {
      anyOf: [
        {
          $ref: "#/components/schemas/AdvancedLimitInfo",
        },
        {
          type: "null",
        },
      ],
    },
    update_layer_info: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/Layer",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Layer Info",
    },
    update_google_group_email: {
      anyOf: [
        {
          $ref: "#/components/schemas/UpdateGoogleGroup",
        },
        {
          type: "null",
        },
      ],
    },
    update_submission_recipients: {
      anyOf: [
        {
          items: {
            type: "string",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Submission Recipients",
    },
    update_limit_order: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/ExcerptSortUpdate",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Limit Order",
    },
    update_deductible_order: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/ExcerptSortUpdate",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Deductible Order",
    },
    update_sublimit_order: {
      anyOf: [
        {
          items: {
            $ref: "#/components/schemas/SublimitSortUpdate",
          },
          type: "array",
        },
        {
          type: "null",
        },
      ],
      title: "Update Sublimit Order",
    },
  },
  type: "object",
  required: [
    "report_id",
    "update_assignee",
    "update_status",
    "update_additional_assignees",
    "update_sovs",
    "update_loss_runs_info",
    "update_review_question_response",
    "update_company_info",
    "update_attachment_info",
    "update_referral_text",
    "update_underwriting_rationale",
    "rerun_report",
    "rerun_components",
    "rerun_attachments",
    "update_broker_contact",
    "update_limit_info",
    "update_policy_info",
    "update_sublimit_info",
    "update_deductible_info",
    "update_advanced_limit_info",
    "update_layer_info",
    "update_google_group_email",
    "update_submission_recipients",
    "update_limit_order",
    "update_deductible_order",
    "update_sublimit_order",
  ],
  title: "UpdateReportRequest",
} as const;

export const $UpdateReportResponse = {
  properties: {
    use_old_sovs: {
      type: "boolean",
      title: "Use Old Sovs",
    },
    report: {
      $ref: "#/components/schemas/ReportResponse",
    },
  },
  type: "object",
  required: ["use_old_sovs", "report"],
  title: "UpdateReportResponse",
} as const;

export const $UpdateSavedFilterRequest = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    is_default: {
      type: "boolean",
      title: "Is Default",
    },
    nickname: {
      type: "string",
      title: "Nickname",
    },
  },
  type: "object",
  required: ["id", "is_default", "nickname"],
  title: "UpdateSavedFilterRequest",
} as const;

export const $UpdateStatus = {
  properties: {
    new_status: {
      type: "string",
      enum: [
        "pre_underwriting_review",
        "blocked",
        "not_cleared_prior_submission",
        "not_cleared_incomplete_submission",
        "not_cleared_out_of_appetite",
        "not_cleared_effective_date_too_far",
        "not_cleared_unapproved_broker",
        "not_cleared_low_tiv",
        "not_cleared_foreign_exposure",
        "cleared",
        "pending",
        "modeling_complete",
        "referral_sent",
        "flagged_for_review",
        "indicated",
        "quoted",
        "declined",
        "closed",
        "closed_bor",
        "not_reviewed",
        "lost",
        "quoted_not_taken_up",
        "bound",
        "issued",
      ],
      title: "New Status",
    },
  },
  type: "object",
  required: ["new_status"],
  title: "UpdateStatus",
} as const;

export const $UpdateTemplate = {
  properties: {
    template_id: {
      type: "string",
      title: "Template Id",
    },
    live: {
      type: "boolean",
      title: "Live",
    },
  },
  type: "object",
  required: ["template_id", "live"],
  title: "UpdateTemplate",
} as const;

export const $UploadEmailThreadResponse = {
  properties: {
    was_new: {
      type: "boolean",
      title: "Was New",
    },
    eml_count: {
      type: "integer",
      title: "Eml Count",
    },
    pf_pushed: {
      type: "integer",
      title: "Pf Pushed",
    },
    staged_emails: {
      items: {
        $ref: "#/components/schemas/StagedEmailManifest",
      },
      type: "array",
      title: "Staged Emails",
    },
    reprocess_classifications: {
      items: {
        type: "string",
        enum: [
          "sov_spreadsheet",
          "acord_app",
          "loss_run",
          "none",
          "screenshot",
          "rater",
          "loss_control_report",
          "policy_document",
          "manuscript_form",
          "final_manuscript_form",
          "specs_sheet",
          "record_keeping",
          "luminor_quote",
          "luminor_tria",
          "luminor_binder",
          "luminor_policy",
          "lead_quote",
          "lead_binder",
          "lead_policy",
          "bound_sov",
          "sl_letter",
          "endorsement_file",
          "endorsement_sov",
          "engineering_report",
          "rate_matrix",
          "form_review",
        ],
      },
      type: "array",
      title: "Reprocess Classifications",
    },
  },
  type: "object",
  required: [
    "was_new",
    "eml_count",
    "pf_pushed",
    "staged_emails",
    "reprocess_classifications",
  ],
  title: "UploadEmailThreadResponse",
} as const;

export const $User = {
  properties: {
    id: {
      type: "string",
      title: "Id",
    },
    email: {
      type: "string",
      title: "Email",
    },
    client_id: {
      type: "string",
      title: "Client Id",
    },
    lobs: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Lobs",
    },
    full_name: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Full Name",
    },
    profile_image_url: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Profile Image Url",
    },
    phone: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Phone",
    },
    scopes: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Scopes",
    },
    user_type: {
      $ref: "#/components/schemas/UserType",
    },
    is_client_admin: {
      type: "boolean",
      title: "Is Client Admin",
      default: false,
    },
  },
  type: "object",
  required: ["id", "email", "client_id", "lobs", "scopes", "user_type"],
  title: "User",
} as const;

export const $UserGeneratedLoss = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    date_of_loss: {
      type: "string",
      title: "Date Of Loss",
    },
    address: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Address",
    },
    claim_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Claim Id",
    },
    loss_id: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Loss Id",
    },
    status: {
      type: "string",
      title: "Status",
    },
    description: {
      anyOf: [
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Description",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    deductible: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Deductible",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    is_cat_event: {
      anyOf: [
        {
          type: "boolean",
        },
        {
          type: "null",
        },
      ],
      title: "Is Cat Event",
    },
    claim_type: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Claim Type",
    },
    source: {
      type: "string",
      const: "user_generated",
      title: "Source",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "date_of_loss",
    "address",
    "claim_id",
    "loss_id",
    "status",
    "description",
    "ground_up_loss",
    "deductible",
    "net_incurred",
    "is_cat_event",
    "claim_type",
    "source",
    "source_details",
  ],
  title: "UserGeneratedLoss",
} as const;

export const $UserGeneratedLossRunByYear = {
  properties: {
    policy_year: {
      type: "string",
      title: "Policy Year",
    },
    description_of_losses: {
      type: "string",
      title: "Description Of Losses",
    },
    calc_mode: {
      anyOf: [
        {
          type: "string",
          enum: ["historical", "as_if"],
        },
        {
          type: "null",
        },
      ],
      title: "Calc Mode",
    },
    source_details: {
      $ref: "#/components/schemas/SourceDetails",
    },
    open_claims: {
      type: "integer",
      title: "Open Claims",
    },
    closed_claims: {
      type: "integer",
      title: "Closed Claims",
    },
    ground_up_loss: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Ground Up Loss",
    },
    net_incurred: {
      anyOf: [
        {
          type: "number",
        },
        {
          type: "null",
        },
      ],
      title: "Net Incurred",
    },
    source: {
      type: "string",
      const: "user_generated",
      title: "Source",
    },
  },
  type: "object",
  required: [
    "policy_year",
    "description_of_losses",
    "calc_mode",
    "source_details",
    "open_claims",
    "closed_claims",
    "ground_up_loss",
    "net_incurred",
    "source",
  ],
  title: "UserGeneratedLossRunByYear",
} as const;

export const $UserType = {
  type: "string",
  enum: ["HUMAN", "SERVICE"],
  title: "UserType",
  description: `Classifies an account so non-human actors can be excluded from
"select a user" UIs. \`\`SERVICE\`\` covers automation / API / system accounts.`,
} as const;

export const $ValidationError = {
  properties: {
    loc: {
      items: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "integer",
          },
        ],
      },
      type: "array",
      title: "Location",
    },
    msg: {
      type: "string",
      title: "Message",
    },
    type: {
      type: "string",
      title: "Error Type",
    },
  },
  type: "object",
  required: ["loc", "msg", "type"],
  title: "ValidationError",
} as const;

export const $ValuationInfo = {
  properties: {
    physical_valuation_type_1: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Physical Valuation Type 1",
    },
    physical_valuation_type_2: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Physical Valuation Type 2",
    },
    bi_valuation_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Bi Valuation Type",
    },
    equipment_valuation_type: {
      anyOf: [
        {
          type: "string",
          enum: [
            "Excluded",
            "Actual Cash Value",
            "Replacement Cost",
            "Functional Replacement Cost",
            "Selling Price",
            "Actual Loss Sustained",
            "Agreed Value",
            "Actual Cash Value, except Replacement cost if newer than 5 years old",
          ],
        },
        {
          type: "string",
        },
        {
          type: "null",
        },
      ],
      title: "Equipment Valuation Type",
    },
  },
  type: "object",
  required: [
    "physical_valuation_type_1",
    "physical_valuation_type_2",
    "bi_valuation_type",
    "equipment_valuation_type",
  ],
  title: "ValuationInfo",
} as const;

export const $VendorEnrichment = {
  properties: {
    vendor: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Vendor",
    },
    live_source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Live Source",
    },
    has_live_run: {
      type: "boolean",
      title: "Has Live Run",
    },
    options: {
      items: {
        $ref: "#/components/schemas/VendorEnrichmentOption",
      },
      type: "array",
      title: "Options",
    },
  },
  type: "object",
  required: ["vendor", "live_source", "has_live_run", "options"],
  title: "VendorEnrichment",
} as const;

export const $VendorEnrichmentOption = {
  properties: {
    source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
    available: {
      type: "boolean",
      title: "Available",
    },
  },
  type: "object",
  required: ["source", "available"],
  title: "VendorEnrichmentOption",
} as const;

export const $VendorEnrichmentRequest = {
  properties: {
    selections: {
      items: {
        $ref: "#/components/schemas/VendorEnrichmentSelection",
      },
      type: "array",
      title: "Selections",
    },
  },
  type: "object",
  required: ["selections"],
  title: "VendorEnrichmentRequest",
} as const;

export const $VendorEnrichmentSelection = {
  properties: {
    vendor: {
      anyOf: [
        {
          type: "string",
          enum: ["spatialkat", "rms_elt", "rms_22", "icm_ylt"],
        },
        {
          type: "string",
          enum: ["rater", "eqbd_rater"],
        },
      ],
      title: "Vendor",
    },
    source: {
      anyOf: [
        {
          type: "string",
          enum: ["nearmap", "cape"],
        },
        {
          type: "null",
        },
      ],
      title: "Source",
    },
  },
  type: "object",
  required: ["vendor", "source"],
  title: "VendorEnrichmentSelection",
} as const;

export const $VendorEnrichmentState = {
  properties: {
    vendors: {
      items: {
        $ref: "#/components/schemas/VendorEnrichment",
      },
      type: "array",
      title: "Vendors",
    },
  },
  type: "object",
  required: ["vendors"],
  title: "VendorEnrichmentState",
} as const;

export const $VendorPrecheck = {
  properties: {
    warnings: {
      items: {
        type: "string",
      },
      type: "array",
      title: "Warnings",
    },
    blocked: {
      type: "boolean",
      title: "Blocked",
    },
    run_perils: {
      items: {
        type: "string",
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "array",
      title: "Run Perils",
    },
    skipped_perils: {
      items: {
        type: "string",
        enum: [
          "PWH",
          "PSH",
          "PWH_PSH",
          "PES",
          "PFL",
          "PFL_PSH",
          "PWB",
          "PWW",
          "PWT",
        ],
      },
      type: "array",
      title: "Skipped Perils",
    },
    results_change: {
      $ref: "#/components/schemas/CatRunChangeResult",
    },
  },
  type: "object",
  required: [
    "warnings",
    "blocked",
    "run_perils",
    "skipped_perils",
    "results_change",
  ],
  title: "VendorPrecheck",
} as const;

export const $WorkStatus = {
  type: "string",
  enum: ["pending", "in_progress", "done", "failed", "cancelled"],
  title: "WorkStatus",
  description: "Status of a queued job.",
} as const;

export const $YearBuiltBand = {
  properties: {
    band: {
      type: "string",
      title: "Band",
    },
    tiv: {
      type: "number",
      title: "Tiv",
    },
    pct_tiv: {
      type: "number",
      title: "Pct Tiv",
    },
  },
  type: "object",
  required: ["band", "tiv", "pct_tiv"],
  title: "YearBuiltBand",
} as const;

export const $YearIncorporatedDerivedFromSearch = {
  properties: {
    flag_id: {
      type: "string",
      const: "year_incorporated_derived_from_search",
      title: "Flag Id",
    },
    source: {
      type: "string",
      title: "Source",
    },
  },
  type: "object",
  required: ["flag_id", "source"],
  title: "YearIncorporatedDerivedFromSearch",
} as const;
